(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var Controller = require('./Controller');
var extend = require('../functions/extend');

var AccordionController = function (options) {

    options = options || {};


    this.$el = options.$el || null;

    this.accordion = options.accordion || {};

    this.onUpdate = options.onUpdate || function () {
        };

    this.init();
};

extend(Controller, AccordionController);

AccordionController.prototype.init = function () {

    var accordion = this.$el.parent();

    if (this.$el && typeof this.$el.click === 'function') {

        this.$el.click(function (e) {

            accordion.toggleClass('is-expanded is-collapsed');

        });
    }
};

module.exports = AccordionController;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/controllers/AccordionController.js","/controllers")
},{"../functions/extend":67,"./Controller":3,"buffer":114,"r7L21G":116}],2:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var Controller = require('./Controller');
var extend = require('../functions/extend');

var ContainerController = function (options) {
    options = options || {};

    this.$el = options.$el || null;
    this.model = options.model || {};
    this._elements = [];
    this.init = options.init || ContainerController.prototype.init;
};

extend(Controller, ContainerController);

ContainerController.prototype.Add = function(className, options) {
    var ctrl;
    if(className instanceof Controller) {
        ctrl = className;
    } else {
        ctrl = new className(options);
    }

    this._elements.push(ctrl);
    ctrl._parent = this;
};

ContainerController.prototype.Remove = function(ctrl) {

    for(var i in this._elements){
        if (this._elements[i] === ctrl){
            this._elements.splice(i, 1);
        }
    }
    ctrl = null;
};

module.exports = ContainerController;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/controllers/ContainerController.js","/controllers")
},{"../functions/extend":67,"./Controller":3,"buffer":114,"r7L21G":116}],3:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var Controller = function () {

};

Controller.prototype.Add = function () {
    throw new Error('Cannot add new element');
};

Controller.prototype.Remove = function () {
    throw new Error('Cannot remove element');
};

Controller.prototype.init = null;

Controller.prototype._parent = null;

Controller.prototype.getParent = function () { return this._parent; };

module.exports = Controller;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/controllers/Controller.js","/controllers")
},{"buffer":114,"r7L21G":116}],4:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var Controller = require('./Controller');
var extend = require('../functions/extend');


// Dropdown controller
var DropdownController = function (options) {

    options = options || {};

    this.model = options.model || {};

    this.modelProperty = options.modelProperty || null;

    this.$el = options.$el || null;

    this.$items = options.$items || null;

    this.onUpdate = options.onUpdate || function () {};

    this.init();
};

extend(Controller, DropdownController);

DropdownController.prototype.init = function () {
    var that = this;

    if (this.$el && typeof this.$el.click === 'function') {
        // Define expanding of dropdown
        // .control-dropdown
        this.$el.click(function (e) {
            var $this = $(this);
            var isExpanded = $this.hasClass('is-expanded');

            // Explicitly collapse all expanded dropdowns
            $('.control-dropdown').removeClass('is-expanded');

            // Toggle its state
            if (!isExpanded) {
                $this.addClass('is-expanded');
            }

        });
    }

    if (this.$items && typeof this.$items.click === 'function') {
        // Define item choosing
        // .control-dropdown li
        this.$items.click(function () {
            var $this = $(this);

            if (that.modelProperty) {
                that.model[that.modelProperty] = $this.data('value');
            }

            that.onUpdate();

            var $chosen = $this.closest('.control-dropdown').find('.control-dropdown-chosen');

            // Set data to chosen
            $chosen.data('value', that.value).text($this.text());
        });
    }
};

module.exports = DropdownController;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/controllers/DropdownController.js","/controllers")
},{"../functions/extend":67,"./Controller":3,"buffer":114,"r7L21G":116}],5:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var Controller = require('./Controller');
var extend = require('../functions/extend');

// SliderInput Controller
var SliderInputController = function (options) {
    options = options || {};

    this.model = options.model || {};
    this.modelProperty = options.modelProperty || null;

    this.onUpdate = options.onUpdate || function () {};

    this.$el = options.$el || null;
    this.$handler = options.$handler || null;
    this.$input = options.$input || this.$el.find('input');

    this.init();
};

extend(Controller, SliderInputController);

SliderInputController.prototype.init = function () {
    var that = this;

    if (this.$handler && typeof this.$handler.mousemove === 'function') {
        this.$handler.mousemove(function () {
            var value = that.$input.val();

            that.model[that.modelProperty] = value;
            that.onUpdate();
        });
    }

    if (this.$input && typeof this.$input.change === 'function') {
        this.$input.change(function () {
            var value = that.$input.val();

            if (that.$handler && that.model.maxPrice) {
                that.$handler.css('left', (parseInt(value) / that.model.maxPrice) * 100 + '%');
            }

            that.model[that.modelProperty] = value;
            that.onUpdate();
        });
    }

    // Define touch event handler
    this.$handler.on('touchstart', function (e) {
        that.$handler.isDragged = true;
    });

    this.$handler.on('touchmove', function (e) {
        if(that.$handler.isDragged) {
            var percent = 0;
            var minPrice;
            var maxPrice;
            var currentPrice;
            that.$handler.each(function (el) {
                var $this = $(this);
                var currentPos = e.originalEvent.changedTouches[0].pageX;
                var parentPos = $this.closest('.ui-slider').offset().left;
                var parentWidth = $this.closest('.ui-slider').width();
                var sliderRange = $('.ui-slider-range');
                if ((currentPos < parentPos + parentWidth) && (currentPos > parentPos)) {
                    percent = ((currentPos - parentPos) / parentWidth);
                    $this.css('left', percent * 100 + '%');
                    sliderRange.css('width',percent * 100 + '%');

                    // Set input to the corresponding price

                    minPrice = parseInt(that.$input.data('min-price'));
                    maxPrice = parseInt(that.$input.data('max-price'));
                    currentPrice = Math.ceil(percent * (maxPrice - minPrice) + minPrice);
                    that.$input.val(currentPrice);
                }
            });
        }
    });

    this.$handler.on('touchend', function (e) {
        that.$handler.isDragged = false;
        var value = that.$input.val();

        that.model[that.modelProperty] = value;
        that.onUpdate();
    });
};

module.exports = SliderInputController;

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/controllers/SliderInputController.js","/controllers")
},{"../functions/extend":67,"./Controller":3,"buffer":114,"r7L21G":116}],6:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var DropdownController = require('./DropdownController');
var TriggerController = require('./TriggerController');

var SportsNutritionController = function (options) {
    options = options || {};

    this.$el = options.$el || null;

    this.model = options.model || {};

    this.$link = options.$link || this.$el.find('input[type="submit"]');

    this.init();
};

SportsNutritionController.prototype.init = function () {
    var that = this;
    var model = this.model;

    this._ageController = new DropdownController({
        model: model,
        modelProperty: 'age',
        onUpdate: that.updateLink.bind(that),
        $el: this.$el.find('.sports-builder-age-control'),
        $items: this.$el.find('.sports-builder-age-control li')
    });

    this._sexController = new TriggerController({
        model: model,
        modelProperty: 'sex',
        onUpdate: that.updateLink.bind(that),
        $el: this.$el.find('.sports-builder-sex-control')
    });

    this._reasonController = new DropdownController({
        model: this.model,
        modelProperty: 'reason',
        onUpdate: that.updateLink.bind(that),
        $el: this.$el.find('.sports-builder-reason-control'),
        $items: this.$el.find('.sports-builder-reason-control li')
    });

    this.updateLink();
};

SportsNutritionController.prototype.updateLink = function () {
    this.$link.attr('href', this.model.composeLink());
};

module.exports = SportsNutritionController;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/controllers/SportsNutritionController.js","/controllers")
},{"./DropdownController":4,"./TriggerController":8,"buffer":114,"r7L21G":116}],7:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var DropdownController = require('./DropdownController');

var TiresAndWheelsBuilderController = function(options) {
    options = options || {};

    this.$el = options.$el || null;

    this.init();
};

TiresAndWheelsBuilderController.prototype.init = function() {
    var that = this;

    this.initStyler();

    if (window.location.pathname.indexOf('/uk') > -1){
        $(document).on('change', '.tires-wheels-builder-form select', function () {
            var $form = $(this).closest('form');

            $.post('/uk/site/update-category-filter-block', $form.serialize(), function (response) {
                $form.replaceWith(response);
                that.initStyler();
            });
        });
    } else {
        $(document).on('change', '.tires-wheels-builder-form select', function () {
            var $form = $(this).closest('form');

            $.post('/site/update-category-filter-block', $form.serialize(), function (response) {
                $form.replaceWith(response);
                that.initStyler();
            });
        });
    }

    $(document).on('input', '.tires-wheels-builder-form-car input.control-dropdown', function() {
        var textInput = $(this).val().toUpperCase();
        var namePullItems = document.querySelectorAll(".cont .jq-selectbox__dropdown ul li");
        var $form = $(this).closest('form');

        $(this).siblings('i').addClass('close-up').siblings('.cont').css('z-index', '101').addClass('opened focused').find('.jq-selectbox__dropdown').css('display', 'block');

        if(textInput.length === 0) {
            $(this).siblings('i').removeClass('close-up').siblings('.cont').css('z-index', '0').addClass(' ').find('.jq-selectbox__dropdown').css('display', 'none');
        }

        namePullItems.forEach(function(i) {
            if (i.innerHTML.toUpperCase().indexOf(textInput) != -1) {
                i.style.display = 'block';
            } else {
                i.style.display = 'none';
            }
        });

        $(this).siblings('.cont').on('click', '.jq-selectbox__dropdown ul li', function() {
            var inputText = $(this).parent().parent().siblings('select').val();

            $.get($form.data('action'), $form.serialize(), function(response) {
                $form.replaceWith(response);
                that.initStyler();

                $('.tires-wheels-builder-form-car input.control-dropdown').val($.trim(inputText));
            });
        });
    });

    $(document).on('click', '.tires-wheels-builder-form-car input.control-dropdown', function() {
        $(this).siblings('i').toggleClass('close-up').siblings('.cont').toggleClass('focus').find('.jq-selectbox__dropdown').toggleClass('focus');
    });

    $(document).on('change', '.tires-wheels-builder-form-car select', function() {
        var $form = $(this).closest('form');
        var currentSelect = $('.tires-wheels-builder-form-car input.control-dropdown').siblings('.jq-selectbox').find('select').val();

        $.get($form.data('action'), $form.serialize(), function(response) {
            $form.replaceWith(response);
            that.initStyler();

            $('.tires-wheels-builder-form-car input.control-dropdown').val($.trim(currentSelect));
        });
    });


    if (window.location.pathname.indexOf('/uk') > -1){

        this.$el.find('.tires-wheels-builder-tire-form .tires-wheels-builder-parameters').on('click', function () {
            that.toggleTabFilterBlock(this);

            var $form = $(this).closest('div.tires-wheels-builder-form-block').find('form');

            $.get('/uk/site/show-tires-filter-block', function(response) {
                $form.replaceWith(response);
                that.initStyler();
            });
        });

        this.$el.find('.tires-wheels-builder-wheels-form .tires-wheels-builder-parameters').on('click', function() {
            that.toggleTabFilterBlock(this);

            var $form = $(this).closest('div.tires-wheels-builder-form-block').find('form');

            $.get('/uk/site/show-wheels-filter-block', function(response) {
                $form.replaceWith(response);
                that.initStyler();
            });
        });

        this.$el.find('.tires-wheels-builder-brand').on('click', function() {
            that.toggleTabFilterBlock(this);

            var $form = $(this).closest('div.tires-wheels-builder-form-block').find('form'),
                category = $(this).data('category');

            $.get('/uk/site/show-selected-car-' + category, function(response) {
                $form.replaceWith(response);
                that.initStyler();

                $(document).ready(function() {
                    var currentInput = $('.tires-wheels-builder-form-car input.control-dropdown');
                    var t = currentInput.siblings('.jq-selectbox').find('select').val();
                    currentInput.val(t);
                });
            });
        });
    } else {
        this.$el.find('.tires-wheels-builder-tire-form .tires-wheels-builder-parameters').on('click', function () {
            that.toggleTabFilterBlock(this);

            var $form = $(this).closest('div.tires-wheels-builder-form-block').find('form');

            $.get('/site/show-tires-filter-block', function(response) {
                $form.replaceWith(response);
                that.initStyler();
            });
        });

        this.$el.find('.tires-wheels-builder-wheels-form .tires-wheels-builder-parameters').on('click', function() {
            that.toggleTabFilterBlock(this);

            var $form = $(this).closest('div.tires-wheels-builder-form-block').find('form');

            $.get('/site/show-wheels-filter-block', function(response) {
                $form.replaceWith(response);
                that.initStyler();
            });
        });

        this.$el.find('.tires-wheels-builder-brand').on('click', function() {
            that.toggleTabFilterBlock(this);

            var $form = $(this).closest('div.tires-wheels-builder-form-block').find('form'),
                category = $(this).data('category');

            $.get('/site/show-selected-car-' + category, function(response) {
                $form.replaceWith(response);
                that.initStyler();

                $(document).ready(function() {
                    var currentInput = $('.tires-wheels-builder-form-car input.control-dropdown');
                    var t = currentInput.siblings('.jq-selectbox').find('select').val();
                    currentInput.val(t);
                });
            });
        });
    }


    $('.select-auto').on('click', that.toggle);

    $('.select-auto').on('click', function() {
        $(document).ready(function() {
            var currentInput = $('.tires-wheels-builder-form-car input.control-dropdown');
            var t = currentInput.siblings('.jq-selectbox').find('select').val();
            currentInput.val(t);
        });
    });
};


TiresAndWheelsBuilderController.prototype.initStyler = function () {
    $('.control-dropdown').styler({
        selectSearch: false,
        selectSmartPositioning: false
    });
};

TiresAndWheelsBuilderController.prototype.toggleTabFilterBlock = function(element) {
    $(element).closest("div.tires-wheels-builder-toggle-form").find(".btn-dark").removeClass("btn-dark").addClass("btn");
    $(element).removeClass("btn").addClass("btn-dark");
};

TiresAndWheelsBuilderController.prototype.toggle = function () {
    $(this).closest('.tires-wheels-builder-horizontal').find('.form').stop(true, true).slideToggle(200);
};

module.exports = TiresAndWheelsBuilderController;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/controllers/TiresAndWheelsBuilderController.js","/controllers")
},{"./DropdownController":4,"buffer":114,"r7L21G":116}],8:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var Controller = require('./Controller');
var extend = require('../functions/extend');

var TriggerController = function (options) {
    options = options || {};

    this.model = options.model || {} || this.getParent().model;

    this.modelProperty = options.modelProperty || null;

    this.onUpdate = options.onUpdate || function () {};

    this.$el = options.$el || null;

    this.init();
};

extend(Controller, TriggerController);

TriggerController.prototype.init = function () {
    var that = this;

    // .trigger-left
    // .trigger-right
    if (this.$el && this.$el.children && typeof this.$el.children === 'function') {
        // Define toggling behavior
        this.$el.children().click(function () {
            var $this = $(this);
            var $parent = $this.closest('.control-trigger');

            // Clear all active items
            $parent.children().removeClass('is-active');

            $this.addClass('is-active');

            // Grab data
            that.model[that.modelProperty] = $this.data('value');
            that.onUpdate();
        });
    }
};

module.exports = TriggerController;

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/controllers/TriggerController.js","/controllers")
},{"../functions/extend":67,"./Controller":3,"buffer":114,"r7L21G":116}],9:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var searchTypehead = require('../functions/typehead/search');

module.exports = (function () {
    searchTypehead();
})();

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/autocomplete.js","/expressions")
},{"../functions/typehead/search":97,"buffer":114,"r7L21G":116}],10:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {
    var slickPhoto = require('../functions/slick/slickPhoto');
    
    // Big photo Trigger BEGIN

    $(document).on('click', '.popup-more', function () {
        var $body = $('body');
        var context = $(this).closest('.product-photo');
        var id = $(this).data('product-id');
        var num = $(this).data('num') != undefined ? $(this).data('num') : $(this).find('.is-active').data('num');
        var url = 'product/product-photo';
        
        if (id === undefined) {
            id = $(this).data('model-id');
            url = 'model/model-photo';
        }

        // If id isn't false
        if (id) {
            $body.addClass('is-modal-open is-nonscrollable');
            $('.popup-wrapper', context)
                .addClass('is-flex')
                .addClass('open');
            $('.popup', context).css('display', 'block');

            // AJAX get request to get maximized version of the photo
            $.get(url, {
                id: id,
                num : num
            }, function (res) {

                $('.popup', context).html(res);
                $('.popup .close-popup', context).click(function () {
                    $('.popup-wrapper', context).removeClass('is-flex');
                    $('.popup', context).css('display', 'none');
                    $('body').removeClass('is-modal-open is-nonscrollable');
                });

                var productItems = $('.popup .product-photos .item');
                var i = 0;

                for (var t = 0; t < productItems.length; t++) {
                    $('.dots-block').append('<div class="dots"></div>');
                }

                $('.dots:first').addClass('active');

                $(document).on('click', '.dots', function() {
                    $('.dots').removeClass('active').eq($(this).index()).addClass('active');
                    productItems.removeClass('is-active').eq($(this).index()).addClass('is-active');
                });

                if(productItems.length <= 1) {
                    $('.product-slider-control').css('display', 'none');
                }

                $('body').keydown(function(e) {
                    if(e.keyCode == 37) { // left
                        $('.popup .product-photos .item').removeClass('is-active');
                        $('.dots').removeClass('active');
                        i--;

                        if (i < 0) {
                            i = productItems.length - 1;
                        }

                        $('.popup .product-photos .item:eq("'+i+'")').addClass('is-active');
                        $('.dots:eq("'+i+'")').addClass('active');
                    }
                    else if(e.keyCode == 39) { // right
                        $('.popup .product-photos .item').removeClass('is-active');
                        $('.dots').removeClass('active');
                        i++;

                        if (i >= productItems.length) {
                            i = 0;
                        }

                        $('.popup .product-photos .item:eq("'+i+'")').addClass('is-active');
                        $('.dots:eq("'+i+'")').addClass('active');
                    }
                });
                
                slickPhoto();
            });
        }
    });
    
    // Big photo Trigger END

    $('.small-certificate').on('click', 'img', function() {
        var smallId = $(this).attr('src');
        var bigImg = $('.big-certificate img');
        $('.big-certificate').addClass('open');

        bigImg.each(function() {
            if ($(this).attr('src') === smallId) {
                var height = $(this).height() / 2;
                $(this).css('display', 'block');
                $(this).css('margin-top', -height);
            }
        });
    });

    function closeCertificate() {
        $('.big-certificate').removeClass('open');
        $('.big-certificate img').css('display', 'none');
    }

    $(document).keydown(function(e) {
        if (e.keyCode == 27) {
            closeCertificate();
        }
    });

    $('.certificate-close').on('click', function() {
        closeCertificate();
    });

})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/bigPhoto.js","/expressions")
},{"../functions/slick/slickPhoto":87,"buffer":114,"r7L21G":116}],11:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {
    var $doc = $(document);

    $doc.on('click', '.filter-tires a', function(){updateTires($(this), $(this).data())});

    $doc.on('click', '.filter-wheels a', function(){updateWheels($(this), $(this).data())});

    $doc.on('click', '.show-calc-auto', function () {
        var $form = $(this).closest('form'),
            $auto = $doc.find('.calc-auto');
        if (window.location.pathname.indexOf('/uk') > -1){
            $.get('/uk/calc/show-calc-auto', $form.serialize(), function (response) {
                $auto.html(response).removeClass('is-hidden');

                var $tire = $auto.find('.filter-tires .original'),
                    $wheel = $auto.find('.filter-wheels .original');

                updateTires($tire, $tire.data());
                updateWheels($wheel, $wheel.data());
            });
        }else {
            $.get('/calc/show-calc-auto', $form.serialize(), function (response) {
                $auto.html(response).removeClass('is-hidden');

                var $tire = $auto.find('.filter-tires .original'),
                    $wheel = $auto.find('.filter-wheels .original');

                updateTires($tire, $tire.data());
                updateWheels($wheel, $wheel.data());
            });
        }

    });

    if ($doc.find('#two-block').length) {
        $doc.find('#two-block')[0].onload = function () {
            var $iframes = $(document).find('#first-block, #two-block').contents();

            $doc.find('#first-block').contents().find('select').on('change', function (e) {
                e.stopImmediatePropagation();

                updateData();
                updateLinks($(this).closest('body'), true);
            });

            $doc.find('#two-block').contents().find('select').on('change', function (e) {
                e.stopImmediatePropagation();

                updateData();
                updateLinks($(this).closest('body'));
            });

            $iframes.on('click', 'a[href="#"]', function (e) {
                e.preventDefault();
            });

            $doc.on('click', '.l-calc a[href="#"]', function (e) {
                e.preventDefault();
            });

            updateData();
        };
    }

    function updateData() {
        var $doc = $(document),
            firstHeight = parseInt($doc.find('.first-tire-height').text()),
            secondHeight = parseInt($doc.find('.second-tire-height').text()),
            firstWidth = parseInt($doc.find('.first-tire-width').text()),
            secondWidth = parseInt($doc.find('.second-tire-width').text()),
            firstProfileHeight = parseInt($doc.find('.first-profile-height').text()),
            secondProfileHeight = parseInt($doc.find('.second-profile-height').text()),
            speedmetrValue = parseFloat($doc.find('.speedmetr').text()),
            speedSescription = $doc.find('.speed-description').text(),
            $firstTireImg = $doc.find('.first-tire-img'),
            $secondTireImg = $doc.find('.second-tire-img'),
            $tireWidthLess = $doc.find('.tire-width-less-text'),
            $tireWidthLonger = $doc.find('.tire-width-longer-text'),
            $profileHeightLess = $doc.find('.profile-height-less-text'),
            $profileHeightLonger = $doc.find('.profile-height-longer-text'),
            $tireHeightLess = $doc.find('.tire-height-less-text'),
            $tireHeightLonger = $doc.find('.tire-height-longer-text'),
            $speedometrWrap = $doc.find('.speedometr-wrap'),
            $klirensPosition = $doc.find('.klirens'),
            klirens;

        klirens = (firstHeight - secondHeight) / 2;

        if (!isNaN(klirens)) {
            if (klirens > 0) {
                $firstTireImg.removeClass('tire-small').addClass('tire-big');
                $secondTireImg.removeClass('tire-big').addClass('tire-small');
                $tireHeightLess.removeClass('is-hidden');
                $tireHeightLonger.addClass('is-hidden');
            } else if (klirens < 0) {
                $secondTireImg.removeClass('tire-small').addClass('tire-big');
                $firstTireImg.removeClass('tire-big').addClass('tire-small');
                $tireHeightLonger.removeClass('is-hidden');
                $tireHeightLess.addClass('is-hidden');
                $klirensPosition.addClass('left');
            } else {
                $doc.find('.first-tire-img, .second-tire-img').removeClass('tire-small').addClass('tire-big');
                $tireHeightLess.addClass('is-hidden');
                $tireHeightLonger.addClass('is-hidden');
                $klirensPosition.removeClass('left');
            }

            $doc.find('.klirens').text(klirens + 'мм');
        }

        if (!isNaN(firstWidth) && !isNaN(secondWidth)) {
            if (firstWidth > secondWidth) {
                $tireWidthLess.removeClass('is-hidden');
                $tireWidthLonger.addClass('is-hidden');
            } else if (firstWidth < secondWidth) {
                $tireWidthLonger.removeClass('is-hidden');
                $tireWidthLess.addClass('is-hidden');
            } else {
                $tireWidthLess.addClass('is-hidden');
                $tireWidthLonger.addClass('is-hidden');
                $speedometrWrap.addClass('speedometr-no-text');
            }
        }

        if (!isNaN(firstProfileHeight) && !isNaN(secondProfileHeight)) {
            if (firstProfileHeight > secondProfileHeight) {
                $profileHeightLess.removeClass('is-hidden');
                $profileHeightLonger.addClass('is-hidden');
            } else if (firstProfileHeight < secondProfileHeight) {
                $profileHeightLonger.removeClass('is-hidden');
                $profileHeightLess.addClass('is-hidden');
            } else {
                $profileHeightLess.addClass('is-hidden');
                $profileHeightLonger.addClass('is-hidden');
            }
        }

        if (!isNaN(speedmetrValue)) {
            $doc.find('.speedometr-value').text(speedmetrValue);
            $doc.find('.speedometr-description').text(speedSescription);
        }
    }

    function updateLinks($el, isFirst) {
        var data = {
            shirinaShina: $el.find('[name="sw"]').val(),
            profil: $el.find('[name="ar"]').val(),
            diametrShina: $el.find('[name="bd"]').val(),
            shirinaDisk: $el.find('[name="rw"]').val(),
            diametrDisk: $el.find('[name="rd"]').val(),
            et: $el.find('[name="et"]').val()
        };

        isFirst = isFirst || false;
        if (window.location.pathname.indexOf('/uk') > -1){
            $.get('/uk/calc/get-selection-urls', data, function (response) {
                var json = $.parseJSON(response),
                    $tire = $el.find('.tires-link'),
                    $wheel = $el.find('.wheels-link');

                setLinks($tire, $wheel);

                if (isFirst) {
                    setLinks($doc.find('.current-tires-link'), $doc.find('.current-wheels-link'));
                } else {
                    setLinks($doc.find('.new-tires-link'), $doc.find('.new-wheels-link'));
                }

                function setLinks($tire, $wheel) {
                    $tire.prop('href', json.tire || '#');
                    $wheel.prop('href', json.disk || '#');

                    $tire.removeClass('btn-grey').addClass('btn-dark');
                    $wheel.removeClass('btn-grey').addClass('btn-dark');

                    if (!json.tire) {
                        $tire.removeClass('btn-dark').addClass('btn-grey');
                    }

                    if (!json.disk) {
                        $wheel.removeClass('btn-dark').addClass('btn-grey');
                    }
                }
            });
        } else {
            $.get('/calc/get-selection-urls', data, function (response) {
                var json = $.parseJSON(response),
                    $tire = $el.find('.tires-link'),
                    $wheel = $el.find('.wheels-link');

                setLinks($tire, $wheel);

                if (isFirst) {
                    setLinks($doc.find('.current-tires-link'), $doc.find('.current-wheels-link'));
                } else {
                    setLinks($doc.find('.new-tires-link'), $doc.find('.new-wheels-link'));
                }

                function setLinks($tire, $wheel) {
                    $tire.prop('href', json.tire || '#');
                    $wheel.prop('href', json.disk || '#');

                    $tire.removeClass('btn-grey').addClass('btn-dark');
                    $wheel.removeClass('btn-grey').addClass('btn-dark');

                    if (!json.tire) {
                        $tire.removeClass('btn-dark').addClass('btn-grey');
                    }

                    if (!json.disk) {
                        $wheel.removeClass('btn-dark').addClass('btn-grey');
                    }
                }
            });
        }
    }

    function updateTires($el, data) {
        var $iframe = $doc.find('#first-block, #two-block').contents();

        $el.closest('.car-filters').find('a').removeClass('active');
        $el.addClass('active');

        $iframe.find('[name="sw"]').val(data.widthtire);
        $iframe.find('[name="ar"]').val(data.profile);
        $iframe.find('[name="bd"]').val(data.diametertire);

        $iframe.find('input[name="tireMenuChange"]').click();

        updateData();
        updateLinks($doc.find('#first-block').contents(), true);
        updateLinks($doc.find('#two-block').contents());
    }

    function updateWheels($el, data) {
        var $iframe = $doc.find('#first-block, #two-block').contents();

        $el.closest('.car-filters').find('a').removeClass('active');
        $el.addClass('active');

        $iframe.find('[name="rw"]').val(data.widthdisk);
        $iframe.find('[name="rd"]').val(data.diameterdisk);
        $iframe.find('[name="et"]').val(data.et);

        $iframe.find('input[name="rimMenuChange"]').click();

        updateData();
        updateLinks($doc.find('#first-block').contents(), true);
        updateLinks($doc.find('#two-block').contents());
    }
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/calcPage.js","/expressions")
},{"buffer":114,"r7L21G":116}],12:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {

    $(document).ready(function () {
        $(document).on('click', '[data-toggle=cars]', function (event) {
            event.preventDefault();
            var target = event.target,
                url = target.dataset.url,
                container = $('.l-goods .container');

            $.post(url).done(function (response) {
                $(container).html(response);
            });

        });
    })

})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/cars.js","/expressions")
},{"buffer":114,"r7L21G":116}],13:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var Cart = require('../models/Cart');
var updateCartBlock = require('../functions/updateCartBlock');
var removeProduct = require('../functions/removeProduct');

module.exports = (function () {
    // Required to be global
    window.cart = new Cart();

    var removeProduct = removeProduct;

    // Define all controllers for cart BEGIN
    var cartItems = $('.cart-item');
    for (var i = 0, length = cartItems.length; i < length; i++) {
        cart.subscribe($('.cart-item').get(i));
    }

    cartItems.on('change', function (event) {
        var model = event.originalEvent.detail.model;
        var products = model.properties.products;
        var context = $(this);
        var goodsList = $('.goods-list', context);
        var productsHTML = '';
        var cartInfoHTML = 'В корзине <span class="number">' + model.properties.count + '</span> ';
        var cartInfoHTMLUKR = 'В кошику <span class="number">' + model.properties.count + '</span> ';

        if (window.location.pathname.indexOf('/uk') > -1){
            cartInfoHTMLUKR += model.properties.countString;
        }else {
            cartInfoHTML += model.properties.countString;
        }

        $('.cart-count', context).text(model.properties.count);

        if (window.location.pathname.indexOf('/uk') > -1){
            $('.cart-info', context).html(cartInfoHTMLUKR);
        }else {
            $('.cart-info', context).html(cartInfoHTML);
        }

        $('.cart-summary .price .number', context).text(model.properties.totalPrice);

        $('body').addClass('is-modal-open');

        cartItems.removeClass('is-empty');

        // Update list of products
        for (var item in products) {
            for( var data in products[item] ) {
                if ('properties' in products[item][data]) {
                    var product = products[item][data];
                    productsHTML += '<li class="item"><div class="good">';
                    productsHTML += '<a href="' + product.properties.url + '"><img src="' + product.properties.image + '" alt=""></a>';
                    productsHTML += '<div class="title"><a href="' + product.properties.url + '">' + product.properties.title + '</a>';
                    if (window.location.pathname.indexOf('/uk') > -1){
                        productsHTML += '<div class="nomen">Код товару: ' + product.properties.article + '</div></div>';
                    }else {
                        productsHTML += '<div class="nomen">Код товара: ' + product.properties.article + '</div></div>';
                    }
                    productsHTML += '<div class="price"><div class="number">' + product.properties.price
                        + '</div><div class="currency"> ' + model.properties.currency + '</div></div>';
                    productsHTML += '<div class="counter"><div class="less-control" data-product-id="' + product.properties.productId + '"></div>';
                    productsHTML += '<input disabled="" type="text" class="number_input" maxlength="2" value="'
                        + product.properties.quantity + '" required="">';
                    productsHTML += '<div class="more-control" data-product-id="' + product.properties.productId
                        + '"></div></div>';
                    productsHTML += '<a href="javascript: void(0);" data-product-id="' + product.properties.productId
                        + '" class="remove-product">';
                    productsHTML += '<div class="glyph remove-filter"></div></a></div>';
                    productsHTML += '<div class="title-adaptive"><a href="' + product.properties.url + '">' + product.properties.title + '</a>';
                    if (window.location.pathname.indexOf('/uk') > -1){
                    productsHTML += '<div class="nomen">Код товару: ' + product.properties.article + '</div></div></li>';
                    }else {
                    productsHTML += '<div class="nomen">Код товара: ' + product.properties.article + '</div></div></li>';
                    }
                } else {
                    var price = 0;

                    productsHTML += '<li class="item item-set">';
                    for (var productId in products[item][data]) {
                        var product = products[item][data][productId];
                        price += product.properties.price;
                        productsHTML += '<div class="good">';
                        productsHTML += '<a href="' + product.properties.url + '"><img src="' + product.properties.image + '" alt=""></a>';
                        productsHTML += '<div class="title"><a href="' + product.properties.url + '">' + product.properties.title + '</a>';
                        if (window.location.pathname.indexOf('/uk') > -1){
                            productsHTML += '<div class="nomen">Код товару: ' + product.properties.article + '</div></div><div class="buy-wrap">';
                        }else {
                            productsHTML += '<div class="nomen">Код товара: ' + product.properties.article + '</div></div><div class="buy-wrap">';
                        }


                        if (product.properties.priceOld != 0) {
                            productsHTML += '<div class="price-old"><div class="number">' + product.properties.priceOld
                                + '</div><div class="currency"> ' + model.properties.currency + '</div></div>';
                        }
                        
                        productsHTML += '<div class="price"><div class="number">' + product.properties.price
                            + '</div><div class="currency"> ' + model.properties.currency + '</div></div></div>';
                        productsHTML += '</div><div class="title-adaptive"><a href="' + product.properties.url + '">' + product.properties.title + '</a>';
                        productsHTML += '<div class="nomen">Код товара: ' + product.properties.article + '</div></div>';
                    }
                    productsHTML += '<div class="counter"><div class="less-control" data-key="' + product.properties.key + '" data-set-id="' + item + '"></div>';
                    productsHTML += '<input disabled="" type="text" class="number_input" maxlength="2" value="'
                        + product.properties.quantity + '" required="">';
                    productsHTML += '<div class="more-control" data-key="' + product.properties.key + '" data-set-id="' + item + '"></div></div>';
                    productsHTML += '<div class="total-set-price"><div class="number">' + price
                        + '</div><div class="currency"> ' + model.properties.currency + '</div></div></div>';
                    productsHTML += '<a href="javascript: void(0);" data-key="' + product.properties.key + '" data-set-id="' + item + '" class="remove-product">';
                    productsHTML += '<div class="glyph remove-filter"></div></a>';
                    productsHTML += '</li>';
                }
            }
        }
        goodsList.html(productsHTML);

        // Update event handlers


        $('.good .counter .more-control, .item-set .counter .more-control').off().on('click', function (e) {
            e.stopPropagation();

            if (window.location.pathname.indexOf('/uk') > -1) {
                var cartLinkUpdate = '/uk/cart/increase-cart-summary';
            } else {
                var cartLinkUpdate = '/cart/increase-cart-summary';
            }

            $.get(cartLinkUpdate, getData($(this)), function () {
                updateCartBlock();
            });
        });

        $('.good .counter .less-control, .item-set .counter .less-control').off().on('click', function (e) {
            e.stopPropagation();

            if (window.location.pathname.indexOf('/uk') > -1) {
                var cartLinkUpdate = '/uk/cart/decrease-cart-summary';
            } else {
                var cartLinkUpdate = '/cart/decrease-cart-summary';
            }

            $.get(cartLinkUpdate, getData($(this)), function () {
                updateCartBlock();
            });
        });

        function getData($a) {
            var data = {};

            if ($a.data('product-id') !== undefined) {
                data.id = $a.data('product-id');
            } else {
                data.key = $a.data('key');
                data.set = $a.data('set-id');
            }

            return data;
        }
    });
})();


// Define all controllers for cart END
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/cartBehavior.js","/expressions")
},{"../functions/removeProduct":79,"../functions/updateCartBlock":98,"../models/Cart":105,"buffer":114,"r7L21G":116}],14:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var updateSizeOfFilter = require('../functions/updateSizeOfFilter');
var showFilter = require('../functions/showFilter');
var changeListItem = require('../functions/changeListItem');
var dropdownFilter = require('./dropdownFilter');
var loadMore = require('./loadMore');

module.exports = (function () {
    // Loading dependencies for category page

    var overlay = $('.overlay');

    overlay.removeClass('is-visible');
    overlay.addClass('is-hidden');

    $(document).on('click', '.filter input[type="checkbox"], .filter input[type="radio"]', function () {
        showFilter();
    });

    $(document).on('click', '.reset-auto', function () {
        if (window.location.pathname.indexOf('/uk') > -1){
            $.get('/uk/category/escape-selected-car');
        }else {
            $.get('/category/escape-selected-car');
        }

    });

    $(document).on('click', '.filter .btn', function () {
        showFilter();
    });

    $(document).on('click', '.filters-list .remove-filter', function () {
        showFilter();
    });

    $(document).on('click', '.filters-trigger .accordion-header', function () {
        $('.filter').toggleClass('is-collapsed is-expanded');
    });

    $(document).on('click', '.filter.is-expanded .close_popup', function () {
        $('.filter').removeClass('is-expanded').addClass('is-collapsed');
        $('.filters-trigger').removeClass('is-collapsed').addClass('is-expanded');
    });

    // Toggle states for accordion trigger
    $(document).on('click', '.accordion > .accordion-header', function () {
        var accordion = $(this).parent();
        accordion.toggleClass('is-expanded is-collapsed');

        if (accordion.hasClass('is-collapsed')) {
            // Hide content
            $('.accordion-content', accordion).css('display', 'none');
        } else if (accordion.hasClass('is-expanded')) {
            // Show content
            $('.accordion-content', accordion).css('display', 'block');
        }
    });

    // Mobile hide content

    $(document).ready(function() {
        if ($(window).width() < 1050) {
            $('.side .filter .filter-group:eq(2)').children().slice(3).removeClass('is-expanded').addClass('is-collapsed');
        }
    });

    $(document).on('click', '#list_view', function () {
        changeListItem.apply(this, ['tile-item', 'list-item', 'goods-tiles', 'goods-list']);
    });

    $(document).on('click', '#grid_view', function () {
        changeListItem.apply(this, ['list-item', 'tile-item', 'goods-list', 'goods-tiles']);
    });

    updateSizeOfFilter();

})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/categoryPage.js","/expressions")
},{"../functions/changeListItem":65,"../functions/showFilter":81,"../functions/updateSizeOfFilter":101,"./dropdownFilter":20,"./loadMore":24,"buffer":114,"r7L21G":116}],15:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports =(function () {

    var showAll = $('.characteristics-list-mobile .show-all');

    $(showAll).click(function(){
      $(this).parent().children('.is-collapsed').toggleClass('is-hidden');
        $(this).toggleClass('is-expanded');
        if($(this).hasClass('is-expanded')){
            if (window.location.pathname.indexOf('/uk') > -1){
                $(this).html('Сховати');
            } else {
                $(this).html('Скрыть');
            }

        }else {
            if (window.location.pathname.indexOf('/uk') > -1){
                $(this).html('Читати повністю');
            } else {
                $(this).html('Читать полностью');
            }

        }
    })

})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/characteristicMobile.js","/expressions")
},{"buffer":114,"r7L21G":116}],16:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// Loading module dependencies
var validate = require('../functions/validate');
var initRadio = require('../functions/initRadio');
var toggleRadio = require('../functions/toggleRadio');
var toggleTotals = require('../functions/toggleTotals');
var updateCartBlock = require('../functions/updateCartBlock');
var updateTotals = require('../functions/updateTotals');
var updateStep2 = require('../functions/updateStep2');
var ContainerController = require('../controllers/ContainerController');
var AccordionController = require('../controllers/AccordionController');
var cityTypehead = require('../functions/typehead/city');
var updateIsLegal = require('../functions/updateIsLegal');
var initRemoveBtn = require('./initRemoveBtn');

$(document).ready(function () {
    var $body = $('body');


    var checkoutCtrl = new ContainerController();
    checkoutCtrl.Add(AccordionController, {
        $el: $('.promo').find('.accordion')
    });

    $body.on('click', '.next_step_btn', function () {
        var $this = $(this);
        var $selector = $this.parents('.step');
        var $form = $('#checkout_form');

        $form.addClass('table-second');

        validate($selector, callback);

        function callback() {

            var $form = $selector.closest('form');
            var $btn = $this.closest('.step-content').find('.spinner-loader');

            $this.addClass('is-hidden');
            $btn.removeClass('is-hidden');

            if (window.location.pathname.indexOf('/uk') > -1) {
                var cartLinkUpdate = '/uk/cart/step-two';
            } else {
                var cartLinkUpdate = 'cart/step-two';
            }

            $.post(cartLinkUpdate, $form.serialize(), function (response) {
                $('#step_2').replaceWith(response);
                
                $.when(updateTotals(),
                    $selector.find('.step-content').slideUp(250, function () {
                        $('.control-dropdown').styler({
                            selectSearch: false,
                            selectSmartPositioning: false
                        });
                        cityTypehead();
                        $(this).parent().addClass('checked').removeClass('active');
                        $selector.next().addClass('active').find('.step-content').slideDown(250);

                        if($(window).width() < 940) {
                            $('html, body').animate({
                                scrollTop: $selector.next().offset().top
                            }, 200);
                        }

                        $this.removeClass('is-hidden');
                        $btn.addClass('is-hidden');
                    }),
                    initRadio()).done(function () {toggleTotals(true)});

                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push($('#step_2').data('ga'));
                }
            });
        }
    });

    $body.on('input', '#phone, .phone_mask', function () {
        var prefix = $(this).data('prefix') ? '+' + $(this).data('prefix') : false;
        if (prefix && !($(this).val().indexOf(prefix) + 1)) {
            $(this).val(prefix);
        }
    });

    $body.on('focusout', '.order_block .counter .number_input', function () {
        var $input = $(this),
            count = parseInt($input.val());

        if (count < 1) {
            count = 1;
        }

        $input.val(count);
        $input.parents('.counter').next().find('.count').html(count);
    });

    $body.on('change', '#checkout_form .step_2 input[type=\'radio\']', function () {
        updateTotals().then(function () {
            var $el = $(document).find('#delivery');
            if (typeof $el != 'undefined') {
                updateStep2($el);
            }
        });

        if ($(this).closest('#deliveryMethod').length) {
            $('.address-delivery').toggleClass('is-hidden');
        }
    });

    $body.on('change', '#product-insurance', function () {
        updateTotals();
    });

    $body.on('change', '.step_2 .field-carrier select.control-dropdown', function () {updateStep2($(this), true)});
    
   // $body.on('change', '.step_2 .field-branch select.control-dropdown', function () {updateTotals()});

    $body.on('click', '.is-legal li', updateIsLegal);
});

var counter = require('../expressions/counter');

(function radio() {
    initRadio();
    $('body').on('change', '.radio', toggleRadio);
})();

(function showCodeInput() {
    $('.enter_code').on('click', showCodeBlock);

    function showCodeBlock() {
        $(this).parents('.order_block').addClass('show_code');
    }
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/checkout.js","/expressions")
},{"../controllers/AccordionController":1,"../controllers/ContainerController":2,"../expressions/counter":18,"../functions/initRadio":74,"../functions/toggleRadio":93,"../functions/toggleTotals":94,"../functions/typehead/city":96,"../functions/updateCartBlock":98,"../functions/updateIsLegal":99,"../functions/updateStep2":102,"../functions/updateTotals":103,"../functions/validate":104,"./initRemoveBtn":22,"buffer":114,"r7L21G":116}],17:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var cityTypehead = require('../functions/typehead/city');
var updateStep2 = require('../functions/updateStep2');

$(document).ready(function () {
    var $body = $('body');
    var value;

    cityTypehead();

    $body.bind('typeahead:select', function(ev, data) {
        var $textField = $(ev.target),
            $input = $textField.closest('.form-group').find('input[type="hidden"]');

        $input.val(data.id);
        $textField.blur().val(data.name);
        value = data || value;

        if ($textField.closest('#checkout_form').length) {
            updateStep2($textField, true)
        }
    });

    $body.on('focus', '.city-load-field', function () {
        $(this).select();
    });

    $body.on('focusout', '.city-load-field', function (e) {
        e.preventDefault();

        var $this = $(this);
        setTimeout(function() {
            if (value != undefined) {
                $this.val(value.name);
            }
        }, 0);
    });

    $body.on('keydown', '.city-load-field', function (e) {
        var $parent = $(this).closest('.form-group'),
            $element = $parent.find('.tt-cursor'),
            $input = $parent.find('input[type="hidden"]'),
            $textField = $parent.find('.city-load-field');

        if ($element.length && ((e.which == 40) || (e.which == 38))) {
            var data = $element.find('.city').data();

            $input.val(data.id);
            $textField.val(data.name);
            value =  data || value;
        }

        if (value != undefined && e.which == 13) {
            $input.val(value.id);
            $textField.blur().val(value.name);

            if ($(this).closest('#checkout_form').length) {
                updateStep2($(this), true);
            }
        }
    });
});
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/city.js","/expressions")
},{"../functions/typehead/city":96,"../functions/updateStep2":102,"buffer":114,"r7L21G":116}],18:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var allowDeliveryRequest = require('../functions/allowDeliveryRequest');
var updateCartBlock = require('../functions/updateCartBlock');
var totalsOverlay = require('../functions/totalsOverlay');

module.exports = (function counter() {
    $(document).on('click', '.checkout-order .counter .more-control', increase);
    $(document).on('click', '.checkout-order .counter .less-control', decrease);
    $('.popup-cart .counter .more-control').on('click', increaseCart);
    $('.popup-cart .counter .less-control').on('click', decreaseCart);

    function increase() {
        var $a = $(this),
            $counterParent = $a.parents('.counter'),
            $counterInput = $counterParent.find('.number_input'),
            counterValue = parseInt($counterInput.val()),
            data = getData($a);

        if (counterValue < $counterParent.data('remain')) {

            counterValue++;
            $counterInput.val(counterValue);
            $counterParent.next().find('.count').html(counterValue);

            if (!allowDeliveryRequest()) {
                data.paymentMethod = $(document).find('#paymentMethod input[type=\'radio\']:checked').val();
                data.deliveryMethod = $(document).find('#deliveryMethod input[type=\'radio\']:checked').val();

                var city_id = $(document).find('input[name=\'OrderForm[cityId]\']').val();
                if (typeof city_id != "undefined") {
                    data.city_id = city_id;
                }

                var carrier = $(document).find('#carrier').val();
                if (typeof carrier != "undefined") {
                    data.carrier = carrier;
                }

                var branch = $(document).find('#branch').val();
                if (typeof branch != "undefined") {
                    data.branch = branch;
                }

                totalsOverlay.show();
            }

            if (window.location.pathname.indexOf('uk') > -1) {
                var cartLinkUpdate = '/uk/cart/increase';
            } else {
                var cartLinkUpdate = 'cart/increase';
            }

            $.get(cartLinkUpdate, data, function (response) {
                var json = $.parseJSON(response),
                    productPrice = $('#totalsFirst');
                $('#totals').html(json.totals);
                productPrice.find('.price .number').html(json.productPrice);
                productPrice.find('.price-old .number').html(json.productPriceOld);

                $(document).find('[data-toggle="tooltip"]').tooltip({
                    html: true
                });

                totalsOverlay.hide();
            });
        }
    }

    function decrease() {
        var $a = $(this),
            $counterParent = $a.parents('.counter'),
            $counterInput = $counterParent.find('.number_input'),
            counterValue = parseInt($counterInput.val()),
            data = getData($a);

        if (counterValue > 1) {
            counterValue--;

        } else {
            return;
        }

        $counterInput.val(counterValue);
        $counterParent.next().find('.count').html(counterValue);

        if (!allowDeliveryRequest()) {
            data.paymentMethod = $(document).find('#paymentMethod input[type=\'radio\']:checked').val();
            data.deliveryMethod = $(document).find('#deliveryMethod input[type=\'radio\']:checked').val();

            var city_id = $(document).find('input[name=\'OrderForm[cityId]\']').val();
            if (typeof city_id != "undefined") {
                data.city_id = city_id;
            }

            var carrier = $(document).find('#carrier').val();
            if (typeof carrier != "undefined") {
                data.carrier = carrier;
            }

            var branch = $(document).find('#branch').val();
            if (typeof branch != "undefined") {
                data.branch = branch;
            }

            totalsOverlay.show();
        }

        if (window.location.pathname.indexOf('uk') > -1) {
            var cartLinkUpdate = '/uk/cart/decrease';
        } else {
            var cartLinkUpdate = 'cart/decrease';
        }

        $.get(cartLinkUpdate, data, function (response) {
            var json = $.parseJSON(response),
                productPrice = $('#totalsFirst');
            $('#totals').html(json.totals);
            productPrice.find('.price .number').html(json.productPrice);
            productPrice.find('.price-old .number').html(json.productPriceOld);

            $(document).find('[data-toggle="tooltip"]').tooltip({
                html: true
            });

            totalsOverlay.hide();
        });
    }

    function increaseCart(e) {
        e.stopPropagation();

        if (window.location.pathname.indexOf('uk') > -1) {
            var cartLinkUpdate = '/uk/cart/increase-cart-summary';
        } else {
            var cartLinkUpdate = 'cart/increase-cart-summary';
        }

        $.get(cartLinkUpdate, getData($(this)), function () {
            updateCartBlock();
        });
    }

    function decreaseCart(e) {
        e.stopPropagation();

        if (window.location.pathname.indexOf('uk') > -1) {
            var cartLinkUpdate = '/uk/cart/decrease-cart-summary';
        } else {
            var cartLinkUpdate = 'cart/decrease-cart-summary';
        }

        $.get(cartLinkUpdate, getData($(this)), function () {
            updateCartBlock();
        });
    }

    function getData($a) {
        var data = {};

        if ($a.data('product-id') !== undefined) {
            data.id = $a.data('product-id');
        } else {
            data.key = $a.data('key');
            data.set = $a.data('set-id');
        }

        var productInsuranceCheckbox = $('#product-insurance');
        if (productInsuranceCheckbox.length > 0) {
            data.productInsurance = productInsuranceCheckbox.is(':checked') ? 1 : 0;
        }

        return data;
    }
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/counter.js","/expressions")
},{"../functions/allowDeliveryRequest":64,"../functions/totalsOverlay":95,"../functions/updateCartBlock":98,"buffer":114,"r7L21G":116}],19:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {
    // Delivery section on the product page
    $('.l-info .advantages-list h3').on('click', function () {
        var headings = $('.l-info .advantages-list h3');
        var textTarget = $('.l-info .advantages .tab-text');
        var target = $(this);

        // Make all headings inactive
        headings.removeClass('is-active');
        // Mark event target as active heading
        target.addClass('is-active');

        // Mark corresponding description as visible
       textTarget.html(target.parent().find('.text').html());
    });
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/deliverySlider.js","/expressions")
},{"buffer":114,"r7L21G":116}],20:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var initPriceSlider = require('../functions/initPriceSlider');

module.exports =(function () {

    $(document).ready(function () {
        $(document).on('click', '.dropdown-selected', function () {
            var $el = $(this);

            if ($el.parent().hasClass('is-collapsed')) {
                $el.siblings('.dropdown-list').slideDown(300, function () {
                    $el.closest('.dropdown').toggleClass('is-collapsed is-expanded');
                });
            } else {
                $el.siblings('.dropdown-list').slideUp(300, function () {
                    $el.closest('.dropdown').toggleClass('is-collapsed is-expanded');
                });
            }
        });

        $('.filter').on('click', '.dropdown-item', function (e) {
            e.stopPropagation();
            var $el = $(this);
            var value = $el.data('value');
            var quantity = $el.find('.quantity').text();
            var url = $el.data('url');
            var validatedUrl = url.replace(/\s/g, "%20"); // in the URL spaces are replaced by %20

            $('.filter').load(validatedUrl + " .filter-group", function() {
                var filterPosition = $('.filter').offset().top;
                var windowPosition = $(window).scrollTop();
                var t = $('.accordion.filters').height();
                var builderHeight = $('.l-tires-wheels-builder').height() === null ? 0 : $('.l-tires-wheels-builder').height();
                var lBanner = $('.l-banner').height();

                if (builderHeight > 1 && $(window).width() > 600) {
                    windowPosition = windowPosition - builderHeight;
                    filterPosition = filterPosition - builderHeight;
                }

                if (lBanner > 1 && $(window).width() > 600) {
                    windowPosition = windowPosition - lBanner;
                    filterPosition = filterPosition - lBanner;
                }

                if (window.location.pathname.indexOf('/uk') > -1){
                    $('.filter').append('<a class="filter-link" href="'+validatedUrl+'">Підібрати</a>');
                }else {
                    $('.filter').append('<a class="filter-link" href="'+validatedUrl+'">Подобрать</a>');
                }

                if (filterPosition <= windowPosition) {
                    $('.filter-link').css('top', windowPosition + 'px');
                } else if (filterPosition >= windowPosition) {
                    $('.filter-link').css('top', filterPosition - 150 + 'px');
                }

                if (filterPosition <= windowPosition && $(window).width() < 600) {
                    $('.filter-link').css('top', windowPosition + 200 + 'px');
                } else if (filterPosition >= windowPosition && $(window).width() < 600) {
                    $('.filter-link').css('top', filterPosition + t + 'px');
                }

                if (filterPosition <= windowPosition && $(window).height() < 500) {
                    $('.filter-link').css('top', windowPosition + builderHeight + t + 'px');
                } else if (filterPosition >= windowPosition && $(window).height() < 500) {
                    $('.filter-link').css('top', filterPosition + builderHeight + t + 'px');
                }

                initPriceSlider();
            });

            $(window).scroll(function () {
                var filterPosition = $('.filter').offset().top;
                var windowPosition = $(window).scrollTop();
                var filterHeight = $('.filter').height();
                var builderHeight = $('.l-tires-wheels-builder').height() === null ? 0 : $('.l-tires-wheels-builder').height();
                var t = $('.accordion.filters').height();
                var lBanner = $('.l-banner').height();

                if (builderHeight > 1) {
                    windowPosition = windowPosition - builderHeight;
                    filterPosition = filterPosition - builderHeight;
                }

                if (lBanner > 1) {
                    windowPosition = windowPosition - lBanner;
                    filterPosition = filterPosition - lBanner;
                }

                var outArea = (filterPosition + filterHeight) - 200;

                if (filterPosition <= windowPosition) {
                    $('.filter-link').css('top', windowPosition + 'px');
                } else if (filterPosition >= windowPosition) {
                    $('.filter-link').css('top', filterPosition - 150 + 'px');
                }

                if (filterPosition <= windowPosition && $(window).width() < 600) {
                    $('.filter-link').css('top', windowPosition + builderHeight + 200 + 'px');
                } else if (filterPosition >= windowPosition && $(window).width() < 600) {
                    $('.filter-link').css('top', filterPosition + t + builderHeight + 'px');
                }

                if (filterPosition <= windowPosition && $(window).height() < 500) {
                    $('.filter-link').css('top', windowPosition + builderHeight + t + 'px');
                } else if (filterPosition >= windowPosition && $(window).height() < 500) {
                    $('.filter-link').css('top', filterPosition + builderHeight + t + 'px');
                }

                if (windowPosition >= outArea) {
                    $('.filter-link').css('top', filterPosition + 'px');
                }

                if (filterPosition <= windowPosition && $(window).height() < 500) {
                    $('.filter-link').css('top', windowPosition - 200 + 'px');
                } else if (filterPosition >= windowPosition && $(window).height() < 500) {
                    $('.filter-link').css('top', filterPosition - 150 + 'px');
                }
            });

            $el.closest('.dropdown-list')
                .find('.dropdown-item')
                .removeClass('dropdown-item-selected');

            // Set value to hidden input and to chosen element module
            $el.addClass('dropdown-item-selected')
                .closest('.dropdown')
                .find('.dropdown-value')
                .val(value)
                .end()
                .find('.dropdown-selected .dropdown-item-title')
                .text(value)
                .end()
                .find('.dropdown-selected .quantity')
                .text(quantity);

            // Hide list and add class
            $el.parent()
                .slideUp(300, function () {
                    $el.closest('.dropdown').toggleClass('is-collapsed is-expanded');
                    // window.location = $el.data('url');
                });
        });
    });

})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/dropdownFilter.js","/expressions")
},{"../functions/initPriceSlider":73,"buffer":114,"r7L21G":116}],21:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {
    // Estimation mechanism for reviews
    var estimationItem = $('.estimation .item');
    estimationItem.on('mouseover', function () {
        var stars = estimationItem;
        $(this).addClass('is-active');

        // Make active all elements that situated before current one
        for (var i = 0, length = stars.length; i < length; i++) {
            // If the element is inactive then make it active one
            if (!(stars[i] === $(this)[0])) {
                $(stars[i]).addClass('is-active');
            } else {
                return;
            }
        }
    });

    estimationItem.on('mouseleave', function () {
        var stars = estimationItem;
        var current = $(this);
        if (!current.hasClass('is-chosen')) {
            $(this).removeClass('is-active');
        }

        // Make active all elements that situated before current one
    });

    estimationItem.on('click', function () {
        var stars = estimationItem;
        var newStarIndex = 0;

        // Define position of the new chosen "star"
        for (var i = 0, length = stars.length; i < length; i++) {
            if (stars[i] === $(this)[0]) {
                newStarIndex = i;
            }
        }

        for (var i = 0, length = stars.length; i < length; i++) {
            if ($(stars[i]).hasClass('is-chosen') && newStarIndex <= i) {
                $(stars[i]).removeClass('is-active');
            }
        }

        estimationItem.removeClass('is-chosen');
        $(this).addClass('is-chosen');
    });

    $('.estimation .mark').on('mouseleave', function () {
        var isChosen = false;
        var stars = estimationItem;
        var current;

        for (var i = 0, length = stars.length; i < length; i++) {
            if ($(stars[i]).hasClass('is-chosen')) {
                isChosen = true;
                current = i;
            }
        }

        if (!isChosen) {
            estimationItem.removeClass('is-active');
        } else {
            for (var i = stars.length - 1; i > current; i--) {
                $(stars[i]).removeClass('is-active');
            }

            for (var i = 0; i <= current; i++) {
                $(stars[i]).addClass('is-active');
            }
        }

    });

    // Rating in reviews section
    $('.estimation .mark').click(function () {
        var rating = 0;
        var context = $(this);
        var items = $('.item', context);

        // Traverse items for is-active class
        for (var i = 0, length = items.length; i < length; i++) {
            if ($(items[i]).hasClass('is-chosen')) {
                rating = i + 1;
            }
        }

        // Put the value of rating to the form
        $('#rating').attr('value', rating);
    });
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/estimationBehavior.js","/expressions")
},{"buffer":114,"r7L21G":116}],22:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var allowDeliveryRequest = require('../functions/allowDeliveryRequest');

module.exports = (function initRemoveBtn() {

    $(document).on('click', '.checkout-table .good .remove-product, .item-set .remove-product', function () {
        var $btnRemove = $(this),
            data = {};

        if ($btnRemove.data('product-id') !== undefined) {
            data.id = $btnRemove.data('product-id');
        } else {
            data.key = $btnRemove.data('key');
            data.set = $btnRemove.data('set-id');
        }

        if (!allowDeliveryRequest()) {
            data.paymentMethod = $(document).find('#paymentMethod input[type=\'radio\']:checked').val();
            data.deliveryMethod = $(document).find('#deliveryMethod input[type=\'radio\']:checked').val();
        }

        if (window.location.pathname.indexOf('/uk') > -1) {
            var cartLinkUpdate = '/uk/cart/remove';
        } else {
            var cartLinkUpdate = 'cart/remove';
        }

        $.get(cartLinkUpdate, data, function (response) {
            $btnRemove.closest('li.item').remove();

            var json = $.parseJSON(response),
                productPrice = $('#totalsFirst');
            $('#totals').html(json.totals);
            productPrice.find('.price .number').html(json.productPrice);
            productPrice.find('.price-old .number').html(json.productPriceOld);
        });
    });
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/initRemoveBtn.js","/expressions")
},{"../functions/allowDeliveryRequest":64,"buffer":114,"r7L21G":116}],23:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {

    $(document).on('click', '#liqpay-link' ,function (e) {

        var $form = $('#checkout_form'),
            $cityInput = $form.find('#city'),
            $panendInput = $form.find('#orderform-panend'),
            $comment = $form.find('#orderform-comment'),
            $city = $cityInput.closest('.form-group').find('input:hidden'),
            cityRequired = parseInt($form.data('city-required')),
            emptyCarried = $('#carrier').val();
        var alfaRadioInput = $panendInput.closest('.form-group').siblings('.radiobutton').find('input').prop('checked');
        var cartFirstName = $('#firstName').val().length;
        var cartSurnameName = $('.field-surname #surname').val().length;
        var cartPhoneField = $('.field-phone #phone').val().length;
        var nonCyrillicVal = /[^а-яА-ЯёЁіІїЇЄєґҐ'\s]|^$/;
        var cartFirstNameVal = $('#firstName').val();
        var cartSurnameNameVal = $('.field-surname #surname').val();

        if (cartFirstName <= 2 || nonCyrillicVal.test(cartFirstNameVal)) {
            $('#firstName').closest('.form-group').addClass('has-error');
            $('#firstName').closest('.form-group').find('.help-block').show();
            $('.checkout-footer .error-text').addClass('show');
        } else {
            $('#firstName').closest('.form-group').removeClass('has-error');
            $('#firstName').closest('.form-group').find('.help-block').hide();
            $('.checkout-footer .error-text').removeClass('show');
        }

        if (cartSurnameName <= 2 || nonCyrillicVal.test(cartSurnameNameVal)) {
            $('.field-surname #surname').closest('.form-group').addClass('has-error');
            $('.field-surname #surname').closest('.form-group').find('.help-block').show();
            $('.checkout-footer .error-text').addClass('show');
        } else {
            $('#surname').closest('.form-group').removeClass('has-error');
            $('#surname').closest('.form-group').find('.help-block').hide();
            $('.checkout-footer .error-text').removeClass('show');
        }

        if (cartPhoneField == 0) {
            $('.field-phone #phone').closest('.form-group').addClass('has-error');
            $('.field-phone #phone').closest('.form-group').find('.help-block').show();
            $('.checkout-footer .error-text').addClass('show');
        } else {
            $('.field-phone #phone').closest('.form-group').removeClass('has-error');
            $('.field-phone #phone').closest('.form-group').find('.help-block').hide();
        }

        if (alfaRadioInput == true) {
            if ($panendInput.val().length === 4) {
                    $panendInput.closest('.form-group').removeClass('has-error error');
            }

            if ($('.field-surname').hasClass('has-error') || $('.field-firstName').hasClass('has-error') || $('.field-phone').hasClass('has-error')) {
                $('.checkout-footer .error-text').show();
            } else {
            if ($panendInput.val().length < 4) {
                e.preventDefault();
                $panendInput.closest('.form-group').addClass('has-error error');
            } else if (cityRequired && !$city.val()) {
                e.preventDefault();
                $city.closest('.form-group').addClass('has-error error');
            } else if (+emptyCarried === +" ") {
                e.preventDefault();
                $('#carrier').closest('.form-group').addClass('has-error error');
            } else {
                $(this).addClass('is-hidden')
                    .closest('.buttons')
                    .find('.spinner-loader')
                    .removeClass('is-hidden');

                if (!cityRequired && $cityInput.val() && !$city.val()) {
                    $comment.val('Название города: ' + $cityInput.val() + "\n" + $comment.val());
                }

                $.ajax({
                    url: $form[0].action,
                    method: 'post',
                    data: $form.serialize()
                }).then(function (data) {
                        var jsondata = JSON.parse(data);
                        window.location.href = jsondata.url;
                    },
                    function (err) {
                        console.error(err);
                    }
                );
                }
            }

        } else {
            $panendInput.closest('.form-group').removeClass('has-error error');

            if ($('.field-surname').hasClass('has-error') || $('.field-firstName').hasClass('has-error') || $('.field-phone').hasClass('has-error')) {
                $('.checkout-footer .error-text').show();
            } else {
            if (cityRequired && !$city.val()) {
                e.preventDefault();
                $city.closest('.form-group').addClass('has-error error');
            } else if (+emptyCarried === +" ") {
                e.preventDefault();
                $('#carrier').closest('.form-group').addClass('has-error error');
            } else {
                $(this).addClass('is-hidden')
                    .closest('.buttons')
                    .find('.spinner-loader')
                    .removeClass('is-hidden');

                if (!cityRequired && $cityInput.val() && !$city.val()) {
                    $comment.val('Название города: ' + $cityInput.val() + "\n" + $comment.val());
                }

                var selector = $(this).data('target');

                var paymentMethodR = $('#paymentMethod input[type=\'radio\']:checked').val();

                if (paymentMethodR == 10) {
                    $.ajax({
                        url: $form[0].action,
                        method: 'post',
                        data: $form.serialize()
                    }).then(function (data) {
                            var liqpayform = JSON.parse(data);
                            var dataset = liqpayform.data;
                            var signature = liqpayform.signature;

                            var liqpaydata = document.getElementById('liqpaydata');
                            liqpaydata.value = dataset;

                            var liqpaysignature = document.getElementById('liqpaysignature');
                            liqpaysignature.value = signature;

                            var selectorElement = $(document).find(selector);

                            var productInsuranceCheckbox = $form.find('#product-insurance');
                            if (productInsuranceCheckbox.length > 0) {
                                productInsuranceCheckbox.removeAttr("disabled");
                            }

                            formLiqpay = $(selectorElement).find('form');
                            $(formLiqpay).submit();
                        },
                        function (err) {
                            console.error(err);
                        }
                    );
                } else {
                    var productInsuranceCheckbox = $form.find('#product-insurance');
                    if (productInsuranceCheckbox.length > 0) {
                        productInsuranceCheckbox.removeAttr("disabled");
                    }
                    $.ajax({
                        url: $form[0].action,
                        method: 'post',
                        data: $form.serialize()
                    }).then(function (data) {
                            var jsondata = JSON.parse(data);
                            window.location.href = jsondata.url;
                        },
                        function (err) {
                            console.error(err);
                        }
                    );
                };
            }
            }
        }
    });
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/liqpay.js","/expressions")
},{"buffer":114,"r7L21G":116}],24:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {

    // Load more button BEGIN
    $(document).ready(function () {
        $(document).on('click', '.goods-more', function () {
            var pageItems = $('.l-goods .pagination .pages li');
            var context = $(this);
            var spinner = $('img', context);
            var currentActive;

            // Start from the second element because the first is the pointer to previous
            for (var i = 1, length = pageItems.length - 1; i < length; i++) {
                var $currentItem = pageItems.eq(i);
                if ($currentItem.hasClass('active') || $currentItem.hasClass('disabled')) {
                    currentActive = i;
                    break;
                }
            }



            // Define next page

            var nextHref = $('.pagination .next').eq(1).find('a').attr('href');

            if (!nextHref) {
                var nextHref = $('.pagination .next').eq(0).find('a').attr('href');
            }

            console.log(nextHref);

            if (nextHref) {
                spinner.addClass('is-visible');
                spinner.removeClass('is-hidden');

                // Load goods from the next page via AJAX-request
                var loadGoods = function () {
                    var d = $.Deferred();
                    var active = $('.settings .display-list .is-active').attr('id');

                    var view = active == 'grid_view' ? 'tiles' : 'list';

                    var href = nextHref + '&view=partial';

                    $('.l-goods .goods-' + view).first().append($('<ul class="goods-' + view + '">').load(href + ' .goods-' + view, function () {
                        // Resolve loading goods ajax-request
                        d.resolve();
                    }));
                    return d.promise();

                };

                // To update pagination above
                var loadTopPagination = function () {
                    var d = $.Deferred();
                    var href = nextHref + '&view=paging';

                    $('.settings .pagination').load(href + ' .pages', function (res) {
                        loadPaginationCb('.settings .pagination .pages li', currentActive, d);
                    });
                    return d.promise();
                };

                // To update pagination below
                var loadBottomPagination = function () {
                    var d = $.Deferred();
                    var href = nextHref + '&view=paging';

                    $('.l-goods .pagination').load(href + ' .pages', function () {
                        loadPaginationCb('.l-goods .pagination .pages li', currentActive, d);
                    });
                    return d.promise();
                };


                $.when(loadGoods(), loadBottomPagination()).done(function () {
                    // Set spinner in loaded state
                    spinner.addClass('is-hidden');
                    spinner.removeClass('is-visible');
                });
            }
        });

        $(document).on('click', '.models-more', function () {
            var pageItems = $('.l-goods .pagination .pages li');
            var context = $(this);
            var spinner = $('img', context);
            var currentActive;

            // Start from the second element because the first is the pointer to previous
            for (var i = 1, length = pageItems.length - 1; i < length; i++) {
                var $currentItem = pageItems.eq(i);
                if ($currentItem.hasClass('active') || $currentItem.hasClass('disabled')) {
                    currentActive = i;
                    break;
                }
            }

            // Define next page
            var nextHref = $('.pagination .next').eq(0).find('a').attr('href');

            if (nextHref) {
                spinner.addClass('is-visible');
                spinner.removeClass('is-hidden');

                // Load goods from the next page via AJAX-request
                var loadGoods = function () {
                    var d = $.Deferred();
                    var active = $('.settings .display-list .is-active').attr('id');

                    var view = 'list';

                    var href = nextHref + '&view=partial';

                    $('.l-goods .goods-' + view).first().append($('<ul class="goods-' + view + '">').load(href + ' .goods-' + view, function () {
                        // Resolve loading goods ajax-request
                        d.resolve();
                    }));

                    return d.promise();
                };

                // To update pagination above
                var loadTopPagination = function () {
                    var d = $.Deferred();
                    var href = nextHref + '&view=paging';

                    $('.settings .pagination').load(href + ' .pages', function (res) {
                        loadPaginationCb('.settings .pagination .pages li', currentActive, d);
                    });

                    return d.promise();
                };

                // To update pagination below
                var loadBottomPagination = function () {
                    var d = $.Deferred();
                    var href = nextHref + '&view=paging';

                    $('.l-goods .pagination').load(href + ' .pages', function () {
                        loadPaginationCb('.l-goods .pagination .pages li', currentActive, d);
                    });

                    return d.promise();
                };

                $.when(loadGoods(), loadBottomPagination()).done(function () {
                    // Set spinner in loaded state
                    spinner.addClass('is-hidden');
                    spinner.removeClass('is-visible');
                });
            }
        });
    });


    var loadPaginationCb = function (selector, currentActive, deferred) {
        var $pageItems = $(selector);
        checkNext();

        for (var i = currentActive, length = $pageItems.length; i < length; i++) {
            var $item = $pageItems.eq(i);
            if (!$item.hasClass('active')) {
                $item.addClass('active')
                    .find('a')
                    .removeAttr('href');
            } else {
                $item.find('a')
                    .removeAttr('href');
                break;
            }
        }

        deferred.resolve();
    };

    var checkNext = function () {
        var pages = $('.settings .pages li');
        if (pages.eq(pages.length - 1).hasClass('disabled')) {
            $('.btn-dark.goods-more').addClass('is-hidden');
        }
    };

    $(document).ready(function () {
        $('.pagination .pages .active a').removeAttr('href');
        checkNext();
    });
    // Load more button END
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/loadMore.js","/expressions")
},{"buffer":114,"r7L21G":116}],25:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// Loading dependencies

var updateCartBlock = require('../functions/updateCartBlock');
var initPriceSlider = require('../functions/initPriceSlider');
var validate = require('../functions/validate');
var loadBlock = require('../functions/loadBlock');
var setViewType = require('../functions/setViewType');
var PresentBuilder = require('../models/PresentBuilder');
var SportsNutrition = require('../models/SportsNutrition');
var SportsNutritionController = require('../controllers/SportsNutritionController');
var TiresAndWheelsBuilderController = require('../controllers/TiresAndWheelsBuilderController');
var city = require('./city');

var Slider = require('../models/Slider');


var ContainerController = require('../controllers/ContainerController');
var DropdownController = require('../controllers/DropdownController');
var SliderInputController = require('../controllers/SliderInputController');
var TriggerController = require('../controllers/TriggerController');
var AccordionController = require('../controllers/AccordionController');

module.exports = (function () {

    $(document).ready(function () {

        setTimeout(function () {
            var e = $('#cart-code');

            if (window.location.pathname.indexOf('/uk') > -1) {
                var cartLinkUpdate = '/uk/cart/get-cart-code';
            } else {
                var cartLinkUpdate = '/cart/get-cart-code';
            }

            if (e.data('get') == 1) {
                $.get(cartLinkUpdate, {
                    cm: e.data('cm'),
                    cs: e.data('cs'),
                    cn: e.data('cn'),
                    ck: e.data('ck'),
                    referrer: document.referrer
                }, function (r) {
                    if (r.length > 0) {
                        e.find('.cart-code').html(r);
                        e.css('display', 'inline-block')
                    }
                })
            }
        }, 500);

        if (window.urlQueryParams['popup'] !== undefined) {
            $('.' + window.urlQueryParams['popup']).click();
        }

        var cartBehavior = require('./cartBehavior');
        var toggleBrands = require('./toggleBrands');
        var togglePopups = require('./togglePopups');

        var slider = new Slider({
            $prevSlide: $('.slider-prev'),
            $nextSlide: $('.slider-next'),
            $slides: $('.commercials-slider .slider-photos')
        });

        // Present builder instantiation (begin)

        var prB = new PresentBuilder({
            pol2: 'dlya-malchikov',
            'vozrast-rebenka': '3-6-let',
            reason: 'birth',
            price_to: 100,
            maxPrice: 20000
        });

        var headerCtrl = new ContainerController();

        headerCtrl.Add(DropdownController, {
            $el: $('.l-header').find('.top-menu-dropdown'),
            $items: $('.l-header').find('.top-menu-dropdown li')
        });

        headerCtrl.Add(DropdownController, {
            $el: $('.l-header').find('.contact-dropdown'),
            $items: $('.l-header').find('.contact-dropdown li')
        });

        var presentBuilderCtrl = new ContainerController();

        presentBuilderCtrl.Add(AccordionController, {
            $el: $('.present-builder').find('.accordion-control')
        });
        presentBuilderCtrl.Add(AccordionController, {
            $el: $('.present-builder-age-small').find('.accordion-control')
        });

        presentBuilderCtrl.Add(DropdownController, {
            model: prB,
            modelProperty: 'vozrast-rebenka',
            $el: $('.present-builder').find('.present-builder-age-control'),
            onUpdate: function () {
                $('.present-builder a.btn-dark').attr('href', this.model.composeLink())
            },
            $items: $('.present-builder').find('.present-builder-age-control li')
        });
        presentBuilderCtrl.Add(TriggerController, {
            model: prB,
            modelProperty: 'pol2',
            onUpdate: function () {
                $('.present-builder a.btn-dark').attr('href', this.model.composeLink())
            },
            $el: $('.present-builder').find('.present-builder-sex-control')
        });
        presentBuilderCtrl.Add(SliderInputController, {
            model: prB,
            modelProperty: 'price_to',
            onUpdate: function () {
                $('.present-builder a.btn-dark').attr('href', this.model.composeLink())
            },
            $el: $('.present-builder').find('.ui-slider-horizontal'),
            $handler: $('.present-builder').find('.ui-slider-horizontal .ui-slider-handle')
        });
        presentBuilderCtrl.Add(DropdownController, {
            model: prB,
            modelProperty: 'reason',
            onUpdate: function () {
                $('.present-builder a.btn-dark').attr('href', this.model.composeLink())
            },
            $el: $('.present-builder').find('.present-builder-reason-control'),
            $items: $('.present-builder').find('.present-builder-reason-control li')
        });

        var spN = new SportsNutrition({
            reason: 'increase',
            age: 'teen',
            sex: 'man'
        });

        var sportsNutritionCtrl = new SportsNutritionController({
            model: spN,
            $el: $('#sports-nutrition'),
            $link: $('#sports-nutrition a.btn-dark')
        });

        // Present builder instantiation (end)

        var tiresAndWheelsBuilderCtrl = new TiresAndWheelsBuilderController({
            $el: $('.tires-wheels-builder')
        });

        var productsCarousel = $('.carousel_slider').bxSlider({
            slideWidth: 232,
            slideMargin: 35,
            moveSlides: 1,
            minSlides: 1,
            maxSlides: 5,
            infiniteLoop: false,
            hideControlOnEnd: true,
            pager: false,
            speed: 210
        });

        $('.popular ul').bxSlider({
            minSlides: 1,
            maxSlides: 3,
            speed: 250,
            slideWidth: 160,
            slideMargin: 20,
            moveSlides: 1,
            infiniteLoop: false,
            hideControlOnEnd: true,
            pager: false
        });

        (function iePlaceholder() {
            if (document.all && !window.atob) {
                var $form = $('form');

                $form.find('input[type="text"]').each(function () {
                    var ph = $(this).attr('placeholder');
                    $(this).attr('value', ph);
                }).focusin(function () {
                    var val = $(this).attr('placeholder');
                    if ($(this).val() == val) {
                        $(this).attr('value', '');
                    }
                }).focusout(function () {
                    var val = $(this).attr('placeholder');
                    if ($(this).val() == '') {
                        $(this).attr('value', val);
                    }
                });

                /* Protected send form */
                $form.submit(function () {
                    $(this).find('input[type="text"]').each(function () {
                        var val = $(this).attr('placeholder');
                        if ($(this).val() == val) {
                            $(this).attr('value', '');
                        }
                    })
                });
            }
        })();

        var $body = $('body');

        $body.on('submit', '#subscribe_form', function (e) {
            e.preventDefault();
            var $form = $(this);
            validate($form, callback);

            function callback() {
                $.get('/subscription', $form.serialize(), onAjaxSuccess);

                function onAjaxSuccess(response) {
                    $('.modal .modal-body').html(response);
                    $('#modal').modal();
                }
            }
        });

        $body.on('submit', '#checkout_subscribe_form', function (e) {
            e.preventDefault();
            validate($(this), callback);

            function callback() {
                $.post(
                    'ajax',
                    onAjaxSuccess
                );

                function onAjaxSuccess() {
                    $('#modal').modal();
                    $('.modal .modal-body').html('<div class="name">Спасибо, вы успешно подписались.</div>')
                }
            }
        });

        $body.on('submit', '.interview_form', function (e) {
            e.preventDefault();
            validate($(this), callback);

            function callback() {
                $.post(
                    'ajax/interview_results.php',
                    onAjaxSuccess
                );

                function onAjaxSuccess(data) {
                    $('.interview_content').html(data);
                }
            }
        });

        $body.on('submit', '#callback_form', function (e) {
            e.preventDefault();
            var $form = $(this);
            $.post($form.attr('action'), $form.serialize(), function (response) {
                $('#cntCallbackForm').replaceWith(response);
                onloadCaptchaCallback();
                setInputmask();

                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push({event : "callback"});
                }
            });
        });

        $body.on('submit', '#feedback_form', function (e) {
            e.preventDefault();
            var $form = $(this);
            $.post($form.attr('action'), $form.serialize(), function (response) {
                $('#cntFeedbackForm').replaceWith(response);
                onloadCaptchaCallback();

                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push({event : "feedback"});
                }
            });
        });

        $body.on('submit', '#quickbuy_form', function (e) {
            e.preventDefault();
            var $form = $(this);
            $.post($form.attr('action'), $form.serialize(), function (response) {
                $('#quick_buy_block').replaceWith(response);

                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push({event : "quickbuy"});
                }
            });
        });

        $body.on('submit', '#insurance_form', function (e) {
            e.preventDefault();
            var $form = $(this);
            $.post($form.attr('action'), $form.serialize(), function (response) {
                $('#insurance_block').replaceWith(response);
            });
        });

        $body.on('change', '#calculate_step2 .field-mark select.control-dropdown', function () {
            var findModel = '/vuso/select-model';
            var form = $(this).closest('form');

            $.post(findModel, form.serialize(), function (response) {
                $('#calculate_step2').replaceWith(response);
            });
        });

        $body.on('submit', '#save_insurance_form', function (e) {
            e.preventDefault();
            var $form = $(this);

            if ($('#save_insurance_form .field-saveinsuranceform-start_date #saveinsuranceform-start_date').val().length === 0) {
                $('#save_insurance_form .field-saveinsuranceform-start_date').addClass('error');
            } else {
                $('#save_insurance_form .field-saveinsuranceform-start_date').removeClass('error');
            }

            if ($('#save_insurance_form .field-saveinsuranceform-end_date #saveinsuranceform-end_date').val().length === 0) {
                $('#save_insurance_form .field-saveinsuranceform-end_date').addClass('error');
            } else {
                $('#save_insurance_form .field-saveinsuranceform-end_date').removeClass('error');
            }

            if ($('#save_insurance_form .field-name #name').val().length === 0 || $('#save_insurance_form .field-name #name').val().length < 2) {
                $('#save_insurance_form .field-name').addClass('error');
            } else {
                $('#save_insurance_form .field-name').removeClass('error');
            }

            if ($('#save_insurance_form .field-surname #surname').val().length === 0 || $('#save_insurance_form .field-surname #surname').val().length < 2) {
                $('#save_insurance_form .field-surname').addClass('error');
            } else {
                $('#save_insurance_form .field-surname').removeClass('error');
            }

            if ($('#save_insurance_form .field-middle-name #middle-name').val().length === 0 || $('#save_insurance_form .field-middle-name #middle-name').val().length < 2) {
                $('#save_insurance_form .field-middle-name').addClass('error');
            } else {
                $('#save_insurance_form .field-middle-name').removeClass('error');
            }

            if ($('#save_insurance_form .field-address #address').val().length === 0) {
                $('#save_insurance_form .field-address').addClass('error');
            } else {
                $('#save_insurance_form .field-address').removeClass('error');
            }

            if ($('#save_insurance_form .field-phone #phone').val().length === 0) {
                $('#save_insurance_form .field-phone').addClass('error');
            } else {
                $('#save_insurance_form .field-phone').removeClass('error');
            }

            if ($('#save_insurance_form .field-ins-code #ins-code').val().length !== 10) {
                $('#save_insurance_form .field-ins-code').addClass('error');
            } else {
                $('#save_insurance_form .field-ins-code').removeClass('error');
            }

            if ($('#save_insurance_form .field-saveinsuranceform-borndate #saveinsuranceform-borndate').val().length === 0) {
                $('#save_insurance_form .field-saveinsuranceform-borndate').addClass('error');
            } else {
                $('#save_insurance_form .field-saveinsuranceform-borndate').removeClass('error');
            }

            if ($('#save_insurance_form .field-vin #vin').val().length !== 17) {
                $('#save_insurance_form .field-vin').addClass('error');
            } else {
                $('#save_insurance_form .field-vin').removeClass('error');
            }

            if ($('#save_insurance_form .field-regnum #regnum').val().length === 0) {
                $('#save_insurance_form .field-regnum').addClass('error');
            } else {
                $('#save_insurance_form .field-regnum').removeClass('error');
            }

            if ($('#save_insurance_form .field-year #year').val().length === 0) {
                $('#save_insurance_form .field-year').addClass('error');
            } else {
                $('#save_insurance_form .field-year').removeClass('error');
            }

            if (
                $('#save_insurance_form .field-saveinsuranceform-start_date').hasClass('error') ||
                $('#save_insurance_form .field-saveinsuranceform-end_date').hasClass('error') ||
                $('#save_insurance_form .field-name').hasClass('error') ||
                $('#save_insurance_form .field-surname').hasClass('error') ||
                $('#save_insurance_form .field-middle-name').hasClass('error') ||
                $('#save_insurance_form .field-address').hasClass('error') ||
                $('#save_insurance_form .field-phone').hasClass('error') ||
                $('#save_insurance_form .field-ins-code').hasClass('error') ||
                $('#save_insurance_form .field-saveinsuranceform-borndate').hasClass('error') ||
                $('#save_insurance_form .field-vin').hasClass('error') ||
                $('#save_insurance_form .field-regnum').hasClass('error') ||
                $('#save_insurance_form .field-year').hasClass('error')
            ) {
                $('#save_insurance_form .submit-wrap').addClass('error');
            } else {
                $('#save_insurance_form .submit-wrap').removeClass('error');

                $.post($form.attr('action'), $form.serialize(), function (response) {
                    $('#save_insurance_block').replaceWith(response);
                });
            }
        });

        $body.on('submit', '#buy_insurance_form', function (e) {
            e.preventDefault();
            var $form = $(this);

            $.post($form.attr('action'), $form.serialize(), function (response) {
                $('#buy_insurance_block').replaceWith(response);
            });
        });

        $body.on('submit', '#catch_form', function (e) {
            e.preventDefault();
            var $form = $(this);
            $.post($form.attr('action'), $form.serialize(), function (response) {
                $('#cntCatchForm').replaceWith(response);

                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push({event : "catch"});
                }
            });
        });



        $body.on('submit', '#outofstock_form', function (e) {
            e.preventDefault();
            var $form = $(this);
            $.post($form.attr('action'), $form.serialize(), function (response) {
                $('#cntOutofstockForm').replaceWith(response);
            });
        });

        $body.on('click', '.sitemap .sub-item', function () {
            var el = $(this).parent('.sub').children('ul');

            if (el.children('.hide').length) {
                el.children('.hide').removeClass('hide').addClass('show');
            } else {
                el.children('.show').removeClass('show').addClass('hide');
            }
        });

        setInputmask();

        $('[data-toggle="tooltip"]').tooltip({
            html: true
        });

        initPriceSlider();

        $body.on('click', '#grid_view.inactive', setGridView);

        $body.on('click', '#list_view.inactive', setListView);

        $('.seo-text-button').on('click', function() {
            $('.seo-text').toggleClass('open');

           if ($('.seo-text').hasClass('open')) {
                $('.seo-text-button').text('Свернуть');
           } else {
               $('.seo-text-button').text('Подробнее');
           }
        });
    });

    function setGridView() {
        setViewType('grid');
    }

    function setListView() {
        setViewType('list');
    }

    (function toAnchor() {
        $('.anchor').on('click', goToAnchor);

        function goToAnchor() {
            $('html, body').animate({
                scrollTop: $($(this).attr('href')).offset().top
            }, {
                duration: 500
            });
            return false;
        }
    })();

    (function scrollToTop() {
        $('#to_top').on('click', function () {
            $('html, body').animate({
                scrollTop: 0
            }, {
                duration: 500
            });
        });

        $(window).scroll(function () {
            var scroll = $('html').scrollTop() || $('body').scrollTop();

            if (scroll > 400) {
                $('#to_top').show();
            } else {
                $('#to_top').hide();
            }
        });
    })();

    (function toggleMenu() {
        $('#menu_toggle').on('click', toggle);

        function toggle() {
            $('.menu').stop(true, true).slideToggle(250);
        }
    })();

    (function sort() {
        $('#by_date').on('click', selectSortByDate);

        $('#by_popular').on('click', selectSortByPopular);

        function selectSortByDate() {
            //TODO: дописать аякс
            $(this).parent().addClass('active').siblings().removeClass('active');
        }

        function selectSortByPopular() {
            //TODO: дописать аякс
            $(this).parent().addClass('active').siblings().removeClass('active');
        }
    })();

    (function onlyNumbers() {
        var $body = $('body');
        $body.on('change', '.number_input', testReg);
        $body.on('keyup', '.number_input', testReg);

        function testReg() {
            var number = $(this).val();
            number = number.replace(/[^0-9]/g, '');
            $(this).val(number);
        }
    })();

    (function filter() {
        $('.filter').on('click', '.checkboxes .item', function() {
            var that = $(this);
            var route = that.data('link');
            var validatedRoute = route.replace(/\s/g, "%20"); // in the URL spaces are replaced by %20

            load(validatedRoute, that);

            scrollButton();
        });

        function load(validatedRoute, that) {
            $('.filter').load(validatedRoute + " .filter-group", function() {
                var filterPosition = $('.filter').offset().top;
                var windowPosition = $(window).scrollTop();
                var t = $('.accordion.filters').height();
                var builderHeight = $('.l-tires-wheels-builder').height() === null ? 0 : $('.l-tires-wheels-builder').height();
                var lBanner = $('.l-banner').height();

                var contextAccordion = $(this).find('.accordion.checkbox-list').find('.selected').parent().parent();

                if (that.hasClass('show')) {
                    $('.item', contextAccordion).removeClass('hide').addClass('show');
                    $('.show_all', contextAccordion).addClass('hide');
                    $('.show_popular', contextAccordion).removeClass('hide').addClass('show');
                }

                if (builderHeight > 1 && $(window).width() > 600) {
                    windowPosition = windowPosition - builderHeight;
                    filterPosition = filterPosition - builderHeight;
                }

                if (lBanner > 1 && $(window).width() > 600) {
                    windowPosition = windowPosition - lBanner;
                    filterPosition = filterPosition - lBanner;
                }

                if (window.location.pathname.indexOf('/uk') > -1){
                    $('.filter').append('<a class="filter-link" href="'+validatedRoute+'">Підібрати</a>');
                }else {
                    $('.filter').append('<a class="filter-link" href="'+validatedRoute+'">Подобрать</a>');
                }

                if (filterPosition <= windowPosition) {
                    $('.filter-link').css('top', windowPosition + 'px');
                } else if (filterPosition >= windowPosition) {
                    $('.filter-link').css('top', filterPosition - 150 + 'px');
                }

                if (filterPosition <= windowPosition && $(window).width() < 600) {
                    $('.filter-link').css('top', windowPosition + 200 + 'px');
                } else if (filterPosition >= windowPosition && $(window).width() < 600) {
                    $('.filter-link').css('top', filterPosition + t + 'px');
                }

                if (filterPosition <= windowPosition && $(window).height() < 500) {
                    $('.filter-link').css('top', windowPosition + builderHeight + t + 'px');
                } else if (filterPosition >= windowPosition && $(window).height() < 500) {
                    $('.filter-link').css('top', filterPosition + builderHeight + t + 'px');
                }

                initPriceSlider();
            });
        }

        function scrollButton() {
            $(window).scroll(function () {
               var filterPosition = $('.filter').offset().top;
               var windowPosition = $(window).scrollTop();
               var filterHeight = $('.filter').height();
               var builderHeight = $('.l-tires-wheels-builder').height() === null ? 0 : $('.l-tires-wheels-builder').height();
               var t = $('.accordion.filters').height();
               var lBanner = $('.l-banner').height();

               if (builderHeight > 1) {
                   windowPosition = windowPosition - builderHeight;
                   filterPosition = filterPosition - builderHeight;
               }

                if (lBanner > 1) {
                    windowPosition = windowPosition - lBanner;
                    filterPosition = filterPosition - lBanner;
                }

                var outArea = (filterPosition + filterHeight) - 200;

                if (filterPosition <= windowPosition) {
                    $('.filter-link').css('top', windowPosition + 'px');
                } else if (filterPosition >= windowPosition) {
                    $('.filter-link').css('top', filterPosition - 150 + 'px');
                }

                if (filterPosition <= windowPosition && $(window).width() < 600) {
                    $('.filter-link').css('top', windowPosition + builderHeight + 200 + 'px');
                } else if (filterPosition >= windowPosition && $(window).width() < 600) {
                    $('.filter-link').css('top', filterPosition + t + builderHeight + 'px');
                }

                if (filterPosition <= windowPosition && $(window).height() < 500) {
                    $('.filter-link').css('top', windowPosition + builderHeight + t + 'px');
                } else if (filterPosition >= windowPosition && $(window).height() < 500) {
                    $('.filter-link').css('top', filterPosition + builderHeight + t + 'px');
                }

                if (windowPosition >= outArea) {
                    $('.filter-link').css('top', filterPosition + 'px');
                }
            });
        }

    })();

    (function selectFilter() {
        $('.checkbox_list ul li a').on('click', toggle);

        function toggle() {
            $(this).parent().toggleClass('active')
        }
    })();


    (function toggleFilters() {
        $('.toggle_filters').on('click', toggle);

        function toggle() {
            $(this).parents('.filter').find('.list').stop(true, true).slideToggle(250);
        }
    })();

    (function () {
        $('.styled, .show_search').styler({
            selectSearch: false,
            selectSmartPositioning: false
        });
    })();

    (function loadAjaxBlock() {
        $('body').on('click', '.toggle_block', function () {
            var selector = $(this).parents('.form_block'),
                url = $(this).attr('data-url');

            load(selector, url);
        });

        function load(selector, url) {
            $(selector).load(url, function () {
                $('.styled').styler({
                    selectSearch: false,
                    selectSmartPositioning: false
                });
            });
        }
    })();

    (function toggleProductsCarousel() {
        $('body').on('click', '.inactive.toggle_list', toggle);

        function toggle() {
            // дописать аякс, в допп аттрибутах хранить url для view
            $(this).removeClass('inactive').addClass('active').siblings().removeClass('active').addClass('inactive');
        }
    })();

    (function toggleFolding() {
        $('.toggle_recommend').on('click', slideFolding);

        function slideFolding() {
            $(this).parents('.folding').find('.folding_content').stop(true, true).slideToggle(200, toggleClass);
        }

        function toggleClass() {
            $(this).parents('.folding').toggleClass('closed');
        }
    })();

    (function toggleDropDown() {
        $('.drop_down_toggle').on('click', toggle);

        function toggle() {
            $(this).parent().find('.drop_down').stop(true, true).slideToggle(250);
        }
    })();

    (function checkboxes() {
        var $checkbox = $('.checkbox');

        $checkbox.each(toggleCheckbox);
        $checkbox.on('change', toggleCheckbox);

        function toggleCheckbox() {
            if ($(this).is(':checked')) {
                $(this).parent().addClass('active').parent();
            } else {
                $(this).parent().removeClass('active');
            }
        }
    })();

    (function map() {
        $('.area_cords area').hover(showRegion, hideRegion);

        function showRegion() {
            var number = $(this).index();
            $('#map .areas img').eq(number).show();
        }

        function hideRegion() {
            var number = $(this).index();
            $('#map .areas img').eq(number).hide();
        }
    })();

    (function () {
        $('#sliderMinPrice').keypress(function (e) {
            if (e.which == 13) {
                initPriceSlider();
            }
        });

        $('.filter').on('click', '#slider-button', function () {
            initPriceSlider();
        });

        $('#sliderMaxPrice').keypress(function (e) {
            if (e.which == 13) {
                initPriceSlider();
            }
        });

        $('.search-control form input').on('submit', function ($e) {
            var $input = $('.tt-input');
            if ($input.val().length == 0) {
                $e.preventDefault();
            }
        });
    }());

    (function modal() {
        $('body').on('click', '.modal_toggle', function () {
            var $this = $(this);

            loadBlock('.modal-body', $this.attr('data-modal'), function () {
                $('#modal').modal();
                setInputmask();
            });
        });
    })();

// OLD FUNCTIONS

    (function toggleTub() {
        $('.left_side_main .tabs a').on('click', tabTrigger);

        function tabTrigger() {
            $(this).addClass('selected').siblings().removeClass('selected');
            var number = $('.left_side_main .tabs a.selected').index();
            $('.left_side_main .tab_content > div, .left_side_main .tabs_content > div').eq(number).show().siblings().hide();
        }
    })();

    (function initInCitiesSlider() {
        $('#in_city .select_city select').on('change', function () {
            raiseFilter($(this));
        });
    })();

    $('.search-control input').bind('typeahead:open', function (ev, suggestion) {
        $('.search-control').css({'box-shadow': '0px 14px 13px 0px rgba(0, 0, 0, 0.5)'});
        $('.tt-menu').css({'box-shadow': '0px 14px 13px 0px rgba(0, 0, 0, 0.5)'});

    });
    $('.search-control input').bind('typeahead:close', function (ev, suggestion) {
        $('.search-control').css({'box-shadow': 'none'});
        $('.tt-menu').css({'box-shadow': 'none'});

    });

    $(document).ready(function () {
        $('.footer-menu-dropdown').on('click', function () {
            $('.footer-menu-items').toggleClass('open');
        });
    });

    $('.order-to-call button').on('click', function() {
        $('.order-call-numbers').toggleClass('open-call');
    });

})();

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/mainPage.js","/expressions")
},{"../controllers/AccordionController":1,"../controllers/ContainerController":2,"../controllers/DropdownController":4,"../controllers/SliderInputController":5,"../controllers/SportsNutritionController":6,"../controllers/TiresAndWheelsBuilderController":7,"../controllers/TriggerController":8,"../functions/initPriceSlider":73,"../functions/loadBlock":75,"../functions/setViewType":80,"../functions/updateCartBlock":98,"../functions/validate":104,"../models/PresentBuilder":106,"../models/Slider":108,"../models/SportsNutrition":109,"./cartBehavior":13,"./city":17,"./toggleBrands":60,"./togglePopups":61,"buffer":114,"r7L21G":116}],26:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {
        // Slider on a product page (multiple photos) BEGIN

        // Method defining current slide
        var getCurrentSlide = function (items) {

            for (var i = 0, length = items.length; i < length; i++) {
                if ($(items[i]).hasClass('is-active')) {
                    return i;
                }
            }

            // If there is no active slide then return an new Error exception
            return new Error();
        };

        // Method for toggling slides
        var toggleVisibleSlides = function ($slide) {
            if ($slide[0] && !$slide.hasClass('is-current')) {
                // TODO: Switch visible slides
                // It's the edge slide
            }
        };

        // Method toggling corresponding photo on the product page
        var showPhoto = function (index, context) {
            var photos = $('.product-photos:first li', context);
            photos.removeClass('is-active');
            $(photos[index]).addClass('is-active');
        };

        // Make active chosen element
        $('body').on('click', '.product-slider .item img', function () {
            var context = $(this).closest('.product-photo');
            var $list = $(this).closest('.product-slider');
            var items = $('.list .item', $list);
            var currentSlide = getCurrentSlide(items);

            $(items[currentSlide]).removeClass('is-active');
            $(this).parent().addClass('is-active');

            for (var i = 0, length = items.length; i < length; i++) {
                if ($(items[i]).hasClass('is-active')) {
                    currentSlide = $(items[i]).data().num;
                }
            }

            showPhoto(currentSlide, context);
        });

        // Slider on a product page (multiple photos) END
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/manyPhotos.js","/expressions")
},{"buffer":114,"r7L21G":116}],27:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// Import section
var hideMenu = require('../functions/hideMenu');
var scrollMenu = require('./scrollMenu');

module.exports = (function menuBehavior() {
    // Trigger for active megamenu
    var menuInFocus = false;

    // Implement logic for the second level menu

    $('.menu > .item > a').on('click', function (event) {
        event.stopPropagation();

        if(!$(this).closest('li').hasClass('sale')) {
            $('.megamenu').removeAttr('style');

            var currentItem = $(this).parent();

            var isExpanded = currentItem.hasClass('is-expanded');

            hideMenu();

            // Toggle current menu item
            if (!isExpanded) {
                currentItem.toggleClass('is-collapsed is-expanded');

                // Toggle trigger for activity of the megamenu
                menuInFocus = true;
            }
        }

    });


    $('.menu-second > .item').on('click', function (event) {
        if ($(document).width() < 941) {
            event.stopPropagation();

            var secondLevel = $('.menu-second > .item');
            var currentItem = $(this);
            var isCollapsed = currentItem.hasClass('is-collapsed');
            var $megamenu = currentItem.closest('.megamenu');
            var actionsImg = $('.megamenu .actions-image-wrapper');
            var rightSideMenu = $('.megamenu .right-side-menu');

            // Clear inline styles for megamenu
            $megamenu.removeAttr('style');

            // Make all items of the second level collapsed
            secondLevel.addClass('is-collapsed').removeClass('is-expanded');

            if (isCollapsed) {
                // Make the current element expanded
                currentItem.addClass('is-expanded').removeClass('is-collapsed');
                actionsImg.css('display', 'none');
                rightSideMenu.css('margin-right', '2em');

            } else {
                // Make the current element collapsed
                currentItem.addClass('is-collapsed').removeClass('is-expanded');
                actionsImg.css('display', 'block');
                rightSideMenu.css('margin-right', '0');
            }

            var levelThirdHeight = $(this).closest('.item')
                .find('.level-third')
                .addClass('is-selected')
                .height();

            var diff = $megamenu.height() - levelThirdHeight - 6;
            if (diff < 0) {
                $megamenu.height($megamenu.height() - diff);
            }
        } else {
            var redirectUrl = $(this).find('a').data('url');

            if (redirectUrl !== undefined) {
                window.location = redirectUrl;
            }
        }
    });

    $('.megamenu').on('click', function (event) {
        $('.menu-second > .item').addClass('is-collapsed').removeClass('is-expanded')
    });

    $('.menu-second > .item').on('mouseenter', function (event) {
        if ($(document).width() > 940) {
            var secondLevel = $('.menu-second > .item');
            var currentItem = $(this);
            var actionsImg = $('.megamenu .actions-image-wrapper');
            var rightSideMenu = $('.megamenu .right-side-menu');

            secondLevel.addClass('is-collapsed').removeClass('is-expanded');

            currentItem.addClass('is-expanded').removeClass('is-collapsed');
            actionsImg.css('display', 'none');
            rightSideMenu.css('margin-right', '2em');
        }
    });
    
    $(document).click(function () {
        if (menuInFocus) {
            hideMenu();
            menuInFocus = false;
        }
    });

    $('.menu, .menu-third > .item > a').click(function (e) {
        e.stopPropagation();
        menuInFocus = true;
    });

    // Logic for adaptive menu

    $('.menu-button').on('click', function () {
        var currentContext = $('.l-header');
        var menu = $('.menu', currentContext);
        menu.removeClass('is-collapsed');
        menu.addClass('is-expanded');
        $('body').css('overflow', 'hidden');
    });

    $(document).on('click', '.top-scroll', function () {
        $('body,html').animate({scrollTop:0},800);
    });
    
    $('.menu-close').on('click', function () {
        var currentContext = $('.l-header');
        var menu = $('.menu', currentContext);
        menu.removeClass('is-expanded');
        menu.addClass('is-collapsed');
        $('body').css('overflow', 'inherit');

        $('> .item', menu).removeClass('is-expanded');
        $('> .item', menu).addClass('is-collapsed');

        // Check width
        if ($(window).width() < 940) {
            $('.contact-dropdown', currentContext).css('display', 'inline-block');
        }

        if ($(window).width() <= 940) {
            var searchControl = $('.search');
            var searchMobile = $('.search-mobile');
            $('.status', currentContext).css('display', 'inline-block');
            $('.logo', currentContext).css('display', 'inline-block');
            searchMobile.css('display', 'none');
            searchMobile.css('display', 'inline-block');
        }

    });
})();


}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/menuBehavior.js","/expressions")
},{"../functions/hideMenu":72,"./scrollMenu":57,"buffer":114,"r7L21G":116}],28:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {
    // Mobile search BEGIN

    $('.search-mobile').click(function () {
        var searchSection = $('.search');
        searchSection.toggleClass('is-expanded is-collapsed');
    });

})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/mobileSearch.js","/expressions")
},{"buffer":114,"r7L21G":116}],29:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {
    var updateModel = require('../functions/updateModel');
    var slickPhoto = require('../functions/slick/slickPhoto');
    var slickProductList = require('../functions/slick/slickProductList');
    var slickOffer = require('../functions/slick/slickOffer');
    var slickSaleSets = require('../functions/slick/slickSaleSets');
    var slickUsefulArticles = require('../functions/slick/slickUsefulArticles');

    if ($('#model').length) {
        var hash = getProductHash(),
            h = location.hash,
            $model = $(document).find('#model'),
            showReviews = h.indexOf('#reviews') != -1,
            showCharacteristics = h.indexOf('#characteristics') != -1,
            sefu = parseInt($($model).data("sefu"));

        if (($model.data('count') < 2) && (hash == '') && ($model.data('id') != '') && (sefu !== 1)) {
            hash = $model.data('id');

            location.hash = '#!' + hash + (showReviews ? '#reviews' : (showCharacteristics ? '#characteristics' : ''));
            update();
        } else {
            if (hash !== '') {
                var $row = $(document).find('a[href="#' + hash + '"]').closest('.row');
                var utms = window.location.search;

                if (utms.length > 0) {
                    var params = window
                        .location
                        .search
                        .replace('?', '')
                        .split('&')
                        .reduce(
                            function (p, e) {
                                var a = e.split('=');
                                p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
                                return p;
                            },
                            {}
                        );
                }

                var utmUrl = [];
                var utmUrlStr = '';
                $.each(params, function (key, value) {
                        if (typeof key !== 'undefined' && typeof value !== 'undefined' && key.length > 0 && value.length > 0) {
                            utmUrlStr = key + '=' + value;
                            utmUrl.push(utmUrlStr);
                        }
                    }
                );
                var utmInString = utmUrl.join("&");

                var sefuHash = '';

                if (typeof params === 'undefined') {

                    if (sefu == 1) {
                        sefuHash = hash.replace('!', '');
                        window.location.href = sefuHash;
                    } else {
                        $(window).load(update);
                    }
                } else {
                    if (sefu == 1) {
                        sefuHash = hash.replace('!', '');
                        sefuHash += '?' + utmInString;
                        window.location.href = sefuHash;
                    } else {
                        $(window).load(update);
                    }
                }
            } else {
                slickProductList();
                slickOffer();
                slickSaleSets();
                slickUsefulArticles();

                $(document).find('.l-product').fadeIn(300);
            }
        }

        function update() {
            $.when(updateModel(hash, $row)).then(function () {
                setTimeout(function () {
                    if (showReviews) {
                        goToHash('#reviews');
                    } else if (showCharacteristics) {
                        goToHash('#characteristics');
                    }
                }, 2000);
            })
        }
    }

    $(document).on('click', '.product-hash', function (e) {
        e.preventDefault();

        var hash = $(this)[0].hash,
            productHash = getProductHash();

        window.location.hash = '#' + productHash + hash;

        goToHash(hash);
    });

    function getProductHash() {
        var hashes = window.location.hash.split('#'),
            productHash = '';

        for (var i = 0; i < hashes.length; i++) {
            if (hashes[i][0] == '!') {
                productHash = hashes[i];
                productHash.slice(1);
                break;
            }
        }

        return productHash;
    }

    function goToHash(hash) {
        var target_top = $(hash).offset().top;
        $('html, body').animate({scrollTop: target_top}, 'slow');
    }

    var $modelProductsIMG = $('.model-products .row img');

    $modelProductsIMG.mouseenter(function () {
        $(this).parent('a').find('.model-photo').css('display', 'block');
    });

    $modelProductsIMG.mouseleave(function () {
        $(this).parent('a').find('.model-photo').css('display', 'none');
    });

    $itemsD = $('#tab-contents .row:not(.header-row)');
    $dataTabItemFirst = $('#tab-buttons ul li a').attr('data-name');

    $('#tab-contents .row:not(.header-row)').css('display','none');
    $('#tab-contents .row:not(.header-row)[data-diametr_shina = "'+$dataTabItemFirst+'"]').css('display','table-row');

    $('#tab-buttons a').click(function () {
        var $el = $(this);

        $('#tab-buttons a').removeClass('active');

        if ($(this).hasClass('btn-grey')) {
            return;
        }

        if ($el.hasClass('active')) {
            if (!$el.find('img').length) {
                $el.removeClass('btn-dark').addClass('btn');
            }

            $el.removeClass('active')
        } else {
            if (!$el.find('img').length) {
                $el.addClass('btn-dark').removeClass('btn');
            }

            $el.addClass('active')
        }

        var $activeFilters = $el.closest('#tab-buttons').find('.active').closest('ul'),
            $filters = $('#tab-buttons ul'),
            $items = $('#tab-contents .row:not(.header-row)');

        $items.each(function () {
            var show = true,
                $item = $(this);

            $activeFilters.each(function () {
                var data = [];

                $(this).find('.active').each(function () {
                    data[data.length] = $(this).data('name');
                });

                if ($.inArray($item.data($(this).data('param')), data) === -1) {
                    show = false;
                }
            });

            $(this).css('display', show ? 'table-row' : 'none');
        });

        $filters.find('a:not(.active)').each(function () {
            if (!$(this).find('img').length) {
                $(this).removeClass('btn-grey').addClass('btn');
            }

            $(this).removeClass('disabled');
        });

        $filters.each(function () {
            var param = $(this).data('param'),
                active = [];

            $(this).find('.active').each(function () {
                active[active.length] = $(this).data('name');
            });

            var $i = $items.filter(function () {
                return $.inArray($(this).data(param), active) !== -1;
            });

            if ($i.length) {
                $('#tab-buttons ul:not([data-param="' + param + '"])').each(function () {
                    var p = $(this).data('param'),
                        d = [];

                    $i.each(function () {
                        d[d.length] = $(this).data(p);
                    });

                    $(this).find('a:not(.active)').each(function () {
                        if ($.inArray($(this).data('name'), d) !== -1) {
                            if (!$(this).find('img').length) {
                                $(this).addClass('btn').removeClass('btn-grey');
                            }

                            $(this).removeClass('disabled');
                        } else {
                            if (!$(this).find('img').length) {
                                $(this).addClass('btn-grey').removeClass('btn');
                            }

                            $(this).addClass('disabled');
                        }
                    })
                });
            }
        });
    });

    slickPhoto();
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/modelPage.js","/expressions")
},{"../functions/slick/slickOffer":86,"../functions/slick/slickPhoto":87,"../functions/slick/slickProductList":88,"../functions/slick/slickSaleSets":89,"../functions/slick/slickUsefulArticles":90,"../functions/updateModel":100,"buffer":114,"r7L21G":116}],30:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {

    $(document).on('click', '#otp-link' ,function (e) {

        var $form = $('#checkout_form'),
            $cityInput = $form.find('#city'),
            $panendInput = $form.find('#orderform-panend'),
            $comment = $form.find('#orderform-comment'),
            $city = $cityInput.closest('.form-group').find('input:hidden'),
            cityRequired = parseInt($form.data('city-required')),
            emptyCarried = $('#carrier').val();
        var alfaRadioInput = $panendInput.closest('.form-group').siblings('.radiobutton').find('input').prop('checked');
        var cartFirstName = $('#firstName').val().length;
        var cartSurnameName = $('.field-surname #surname').val().length;
        var cartPhoneField = $('.field-phone #phone').val().length;
        var nonCyrillicVal = /[^а-яА-ЯёЁіІїЇЄєґҐ'\s]|^$/;
        var cartFirstNameVal = $('#firstName').val();
        var cartSurnameNameVal = $('.field-surname #surname').val();

        if (cartFirstName <= 2 || nonCyrillicVal.test(cartFirstNameVal)) {
            $('#firstName').closest('.form-group').addClass('has-error');
            $('#firstName').closest('.form-group').find('.help-block').show();
            $('.checkout-footer .error-text').addClass('show');
        } else {
            $('#firstName').closest('.form-group').removeClass('has-error');
            $('#firstName').closest('.form-group').find('.help-block').hide();
            $('.checkout-footer .error-text').removeClass('show');
        }

        if (cartSurnameName <= 2 || nonCyrillicVal.test(cartSurnameNameVal)) {
            $('.field-surname #surname').closest('.form-group').addClass('has-error');
            $('.field-surname #surname').closest('.form-group').find('.help-block').show();
            $('.checkout-footer .error-text').addClass('show');
        } else {
            $('#surname').closest('.form-group').removeClass('has-error');
            $('#surname').closest('.form-group').find('.help-block').hide();
            $('.checkout-footer .error-text').removeClass('show');
        }

        if (cartPhoneField == 0) {
            $('.field-phone #phone').closest('.form-group').addClass('has-error');
            $('.field-phone #phone').closest('.form-group').find('.help-block').show();
            $('.checkout-footer .error-text').addClass('show');
        } else {
            $('.field-phone #phone').closest('.form-group').removeClass('has-error');
            $('.field-phone #phone').closest('.form-group').find('.help-block').hide();
        }

        if (alfaRadioInput == true) {
            if ($panendInput.val().length === 4) {
                    $panendInput.closest('.form-group').removeClass('has-error error');
            }

            if ($('.field-surname').hasClass('has-error') || $('.field-firstName').hasClass('has-error') || $('.field-phone').hasClass('has-error')) {
                $('.checkout-footer .error-text').show();
            } else {
            if ($panendInput.val().length < 4) {
                e.preventDefault();
                $panendInput.closest('.form-group').addClass('has-error error');
            } else if (cityRequired && !$city.val()) {
                e.preventDefault();
                $city.closest('.form-group').addClass('has-error error');
            } else if (+emptyCarried === +" ") {
                e.preventDefault();
                $('#carrier').closest('.form-group').addClass('has-error error');
            } else {
                $(this).addClass('is-hidden')
                    .closest('.buttons')
                    .find('.spinner-loader')
                    .removeClass('is-hidden');

                if (!cityRequired && $cityInput.val() && !$city.val()) {
                    $comment.val('Название города: ' + $cityInput.val() + "\n" + $comment.val());
                }

                $.ajax({
                    url: $form[0].action,
                    method: 'post',
                    data: $form.serialize()
                }).then(function (data) {
                        var jsondata = JSON.parse(data);
                        window.location.href = jsondata.url;
                    },
                    function (err) {
                        console.error(err);
                    }
                );
                }
            }

        } else {
            $panendInput.closest('.form-group').removeClass('has-error error');

            if ($('.field-surname').hasClass('has-error') || $('.field-firstName').hasClass('has-error') || $('.field-phone').hasClass('has-error')) {
                $('.checkout-footer .error-text').show();
            } else {
            if (cityRequired && !$city.val()) {
                e.preventDefault();
                $city.closest('.form-group').addClass('has-error error');
            } else if (+emptyCarried === +" ") {
                e.preventDefault();
                $('#carrier').closest('.form-group').addClass('has-error error');
            } else {
                $(this).addClass('is-hidden')
                    .closest('.buttons')
                    .find('.spinner-loader')
                    .removeClass('is-hidden');

                if (!cityRequired && $cityInput.val() && !$city.val()) {
                    $comment.val('Название города: ' + $cityInput.val() + "\n" + $comment.val());
                }

                var selector = $(this).data('target');

                var paymentMethodR = $('#paymentMethod input[type=\'radio\']:checked').val();

                if (paymentMethodR == 11) {
                    $.ajax({
                        url: $form[0].action,
                        method: 'post',
                        data: $form.serialize()
                    }).then(function (data) {
                            var parsedData = JSON.parse(data);

                            var otpVersion = document.getElementById('otp-version');
                            otpVersion.value = parsedData.version;

                            var otpMerchantid = document.getElementById('otp-merchantid');
                            otpMerchantid.value = parsedData.merchantId;

                            var otpTerminalid = document.getElementById('otp-terminalid');
                            otpTerminalid.value = parsedData.terminalId;

                            var otpTotalamount = document.getElementById('otp-totalamount');
                            otpTotalamount.value = parsedData.totalAmount;

                            var otpCurrency = document.getElementById('otp-currency');
                            otpCurrency.value = parsedData.currency;

                            var otpPurchasetime = document.getElementById('otp-purchasetime');
                            otpPurchasetime.value = parsedData.purchaseTime;

                            var otpOrderid = document.getElementById('otp-orderid');
                            otpOrderid.value = parsedData.orderId;

                            var otpSignature = document.getElementById('otp-signature');
                            otpSignature.value = parsedData.signature;

                            var selectorElement = $(document).find(selector);

                            formOtp = $(selectorElement).find('form');
                            $(formOtp).submit();
                            
                        },
                        function (err) {
                            console.error(err);
                        }
                    );
                } else {
                    var productInsuranceCheckbox = $form.find('#product-insurance');
                    if (productInsuranceCheckbox.length > 0) {
                        productInsuranceCheckbox.removeAttr("disabled");
                    }
                    $.ajax({
                        url: $form[0].action,
                        method: 'post',
                        data: $form.serialize()
                    }).then(function (data) {
                            var jsondata = JSON.parse(data);
                            window.location.href = jsondata.url;
                        },
                        function (err) {
                            console.error(err);
                        }
                    );
                };
            }
            }
        }
    });
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/otp.js","/expressions")
},{"buffer":114,"r7L21G":116}],31:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
/**
 * Created by s.maksimovsky on 08.02.2017.
 */

module.exports = (function () {
    $('body').on('click', '#4_Payment',  function () {
        $('.online-help-block').html('Оплатить заказ онлайн возможно после согласования заказа с менеджером').show();
        $(this).addClass('checked');
        $('.payment-wrap-popup').show();

        $('body').on('click', '#3_Payment',  function () {
            $('.online-help-block').hide();
            $('#4_Payment').removeClass('checked');
            $('.payment-wrap-popup').hide();
        });

        $('body').on('click', '#2_Payment',  function () {
            $('.online-help-block').hide();
            $('#4_Payment').removeClass('checked');
            $('.payment-wrap-popup').hide();
        });

        $('body').on('click', '#1_Payment',  function () {
            $('.online-help-block').hide();
            $('#4_Payment').removeClass('checked');
            $('.payment-wrap-popup').hide();
        });
    });
})();

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/paymentMassage.js","/expressions")
},{"buffer":114,"r7L21G":116}],32:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var agreementPopup;

module.exports = (function () {

    $('body').on('click', '.agreement-popup', function () {

        // Check if the element exists (if exists - reinitiliazation will throw an error)
        try {

            if (window.location.pathname.indexOf('/uk') > -1) {
                var cartLinkUpdate = '/uk/cart/agreement';
            } else {
                var cartLinkUpdate = 'cart/agreement';
            }
            
            agreementPopup = $('.agreement-popup').popup({type: 'html', allowScrolling: true});
            $.ajax({
                url: cartLinkUpdate,
                method: 'get',
                success: function (html) {
                    agreementPopup.method('setHtml', html)
                        .method('show');
                }
            });
        } catch(e) {
            // If exist show again (w/o requesting server to send new)
            agreementPopup.method('show');
        }
    });
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/popups/agreementPopup.js","/expressions/popups")
},{"buffer":114,"r7L21G":116}],33:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
/**
 * Created by admin on 23.07.2021.
 */


var disableScroll = window.handleScroll.disableScroll;
var enableScroll = window.handleScroll.enableScroll;

module.exports = (function () {

    $(document).on('click', '.alfa-installment-popup', function () {
        var alfaInstallment = $('body').find('#alfa-installment');

        disableScroll(window);
        alfaInstallment.parent().toggleClass('is-flex open');
        alfaInstallment.css('display', 'block');

        $('.close-popup').on('click', closePopup);

        function closePopup() {
            enableScroll(window);
            $('.open .popup').stop(true, true).slideUp(100, function() {
                $(this).parent().removeClass('open');
                $('.popup-wrapper').removeClass('is-flex');
            });

            $('body').removeClass('is-modal-open is-nonscrollable');
        }

    });


})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/popups/alfaInstallmentPopup.js","/expressions/popups")
},{"buffer":114,"r7L21G":116}],34:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function() {

    var announcePopup;

    // popup (begin)

    $('body').on('click', '.announce-popup', function () {
        var $this = $(this);
        var url = $this.data('modal');

        announcePopup = announcePopup ? announcePopup : $('#modal').popup({type: 'html'});

        $.get(url, function (data) {
            announcePopup.method('setHtml', data).method('show');
            onloadCaptchaCallback();
            $('#modal .close_popup').click(function () {
                announcePopup.method('destroy');
            });

            $('#modal .popup-wrapper').click(function (e) {
                try {
                    announcePopup.method('destroy');
                } catch (e) {

                }
            });

            $('#modal .btn').click(function (e) {
                var isValid = true;
                var $name = $('#modal input[name="OutOfStockForm[name]"]');
                var $email = $('#modal input[name="OutOfStockForm[email]"]');
                var $form = $name.closest('form');
                var email = /^\w+@\w+\.\w+$/i;
                e.preventDefault();

                // Run validation
                // Validate inputs
                if (!$name.val()) {
                    // Add error messages
                    $name.closest('.form-group').addClass('has-error');
                    $name.siblings('.help-block').html('Представьтесь, пожалуйста');
                    isValid = false;
                } else {
                    // Remove error messages
                    $name.closest('.form-group').removeClass('has-error');
                    $name.siblings('.help-block').html('');
                }

                if (!email.test($email.val())) {
                    // Add error messages
                    $email.closest('.form-group').addClass('has-error');
                    $email.siblings('.help-block').html('Необходимо указать Ваш Email');
                    isValid = false;
                } else {
                    // Remove error messages
                    $email.closest('.form-group').removeClass('has-error');
                    $email.siblings('.help-block').html('');
                }

                if (isValid) {
                    announcePopup.method('hide');
                    // Send Ajax
                    $.ajax({
                        url: $form[0].action,
                        method: 'post',
                        data: $form.serialize()
                    }).then(function (data)  {
                        announcePopup.method('setHtml', data).method('show');
                        onloadCaptchaCallback();

                    }, function (err) {
                        console.error(err);
                        announcePopup.method('hide').method('destroy');
                    });
                }
            });
        });
    });

    // Announce popup (end)
 })();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/popups/announcePopup.js","/expressions/popups")
},{"buffer":114,"r7L21G":116}],35:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {
    $('.callback-popup').click(function () {
        var callbackPopup;
        var setBtnHandler;

        try {
            callbackPopup = $('#modal').popup({type: 'html'});
        } catch(e) {

        }

        if (window.location.pathname.indexOf('/uk') > -1) {
            $.ajax({
                method: 'get',
                url: '/uk/site/callback'
            }).done(function (data) {
                callbackPopup.method('setHtml', data).method('show');
                $('#modal .close_popup').eq(0).css('display', 'none').end().click(function () {
                    callbackPopup.method('destroy');
                });

                $('#modal .popup-wrapper').click(function (e) {
                    try {
                        callbackPopup.method('destroy');
                    } catch (e) {

                    }
                });

                $('#modal .btn').click(function (e) {
                    var isValid = true;
                    var data = {};
                    var $name = $('#modal input[name="CallbackForm[name]"]');
                    var $phone = $('#modal input[name="CallbackForm[phone]"]');
                    var $message = $('#modal textarea[name="CallbackForm[message]"]');
                    var phone = /^[+]?[0-9]{12}$/gi;
                    e.preventDefault();

                    // Grab data
                    data['_csrf'] = $('#modal input[name="_csrf"]').val();
                    data['CallbackForm[name]'] = $name.val();
                    data['CallbackForm[phone]'] = $phone.val();
                    data['CallbackForm[message]'] = $message.val();

                    // Run validation
                    // Validate inputs
                    if (!data['CallbackForm[name]']) {
                        // Add error messages
                        $name.closest('.form-group').addClass('has-error');
                        $name.siblings('.help-block').html('Представтесь будь ласка');
                        isValid = false;
                    } else {
                        // Remove error messages
                        $name.closest('.form-group').removeClass('has-error');
                        $name.siblings('.help-block').html('');
                    }

                    if (!phone.test($phone.val())) {
                        // Add error messages
                        $phone.closest('.form-group').addClass('has-error');
                        $phone.siblings('.help-block').html('Необхідно заповнити поле "Телефон"');
                        isValid = false;
                    } else {
                        // Remove error messages
                        $phone.closest('.form-group').removeClass('has-error');
                        $phone.siblings('.help-block').html('');
                    }

                    if (isValid) {
                        callbackPopup.method('hide');
                        // Send Ajax
                        $.ajax({
                            url: 'uk/site/callback',
                            method: 'post',
                            data: data
                        }).then(function (data)  {
                            callbackPopup.method('setHtml', data).method('show');
                            $('#modal .close_popup').eq(0).css('display', 'none').end().click(function () {
                                callbackPopup.method('destroy');
                            });

                        }, function (err) {
                            console.error(err);
                            callbackPopup.method('hide').method('destroy');
                        });
                    }
                });
            });
        } else {
            $.ajax({
                method: 'get',
                url: '/site/callback'
            }).done(function (data) {
                callbackPopup.method('setHtml', data).method('show');
                $('#modal .close_popup').eq(0).css('display', 'none').end().click(function () {
                    callbackPopup.method('destroy');
                });

                $('#modal .popup-wrapper').click(function (e) {
                    try {
                        callbackPopup.method('destroy');
                    } catch (e) {

                    }
                });

                $('#modal .btn').click(function (e) {
                    var isValid = true;
                    var data = {};
                    var $name = $('#modal input[name="CallbackForm[name]"]');
                    var $phone = $('#modal input[name="CallbackForm[phone]"]');
                    var $message = $('#modal textarea[name="CallbackForm[message]"]');
                    var phone = /^[+]?[0-9]{12}$/gi;
                    e.preventDefault();

                    // Grab data
                    data['_csrf'] = $('#modal input[name="_csrf"]').val();
                    data['CallbackForm[name]'] = $name.val();
                    data['CallbackForm[phone]'] = $phone.val();
                    data['CallbackForm[message]'] = $message.val();

                    // Run validation
                    // Validate inputs
                    if (!data['CallbackForm[name]']) {
                        // Add error messages
                        $name.closest('.form-group').addClass('has-error');
                        $name.siblings('.help-block').html('Представьтесь, пожалуйста');
                        isValid = false;
                    } else {
                        // Remove error messages
                        $name.closest('.form-group').removeClass('has-error');
                        $name.siblings('.help-block').html('');
                    }

                    if (!phone.test($phone.val())) {
                        // Add error messages
                        $phone.closest('.form-group').addClass('has-error');
                        $phone.siblings('.help-block').html('Необходимо заполнить поле "Телефон"');
                        isValid = false;
                    } else {
                        // Remove error messages
                        $phone.closest('.form-group').removeClass('has-error');
                        $phone.siblings('.help-block').html('');
                    }

                    if (isValid) {
                        callbackPopup.method('hide');
                        // Send Ajax
                        $.ajax({
                            url: 'site/callback',
                            method: 'post',
                            data: data
                        }).then(function (data)  {
                            callbackPopup.method('setHtml', data).method('show');
                            $('#modal .close_popup').eq(0).css('display', 'none').end().click(function () {
                                callbackPopup.method('destroy');
                            });

                        }, function (err) {
                            console.error(err);
                            callbackPopup.method('hide').method('destroy');
                        });
                    }
                });
            });
        }



    });
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/popups/callbackPopup.js","/expressions/popups")
},{"buffer":114,"r7L21G":116}],36:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// Import section

module.exports = (function () {
    // Cart popup logic
    $('.item > .cart-icon').click(function () {
        var context = $(this).parent();

        if (parseInt($('.cart-count', context).text()) !== 0) {
            var popup = $('.popup-cart', context);
            $('.popup-wrapper', context).addClass('is-flex');
            $('body').addClass('is-modal-open');

            var slide = function () {
                popup.addClass('is-visible');
                popup.removeClass('is-hidden');
            };

            setTimeout(slide, 100);
        }

    });

    function closeCart() {
        var popup = $('.popup-cart');

        $('body').removeClass('is-modal-open');
        popup.addClass('is-hidden');
        popup.removeClass('is-visible');
    }

    $(document).on('click', '.popup-cart .close_popup ', function (e) {
        closeCart();
    });

    $(document).keydown(function (e) {
        if (e.keyCode == 27) {
            closeCart();
        }
    });
    // Prevent incorrect input
    $('.counter input[type="text"]').change(function () {
        var inputControl = $(this);
        var val = parseInt(inputControl.val());
        if (isNaN(val)) {
            inputControl.val(0);
        }
    });
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/popups/cartPopup.js","/expressions/popups")
},{"buffer":114,"r7L21G":116}],37:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {
    var deliveryPopup = $('.delivery-popup').popup({type: 'html', allowScrolling: true});

    if (window.location.pathname.indexOf('/uk') > -1){
        $(document).on('click', '.delivery-popup', function () {
            deliveryPopup = $(document).find('.delivery-popup .popup-wrapper').length != 0
                ? deliveryPopup
                : $(document).find('.delivery-popup').popup({type: 'html', allowScrolling: true});

            $.ajax({
                url: '/uk/product/get-product-info?name=deliveryUkr',
                success: function (html) {
                    deliveryPopup.method('setHtml', '<div class="container"><div class="article">' + html + '</div></div>').method('show');
                }
            });
        });
    } else {
        $(document).on('click', '.delivery-popup', function () {
            deliveryPopup = $(document).find('.delivery-popup .popup-wrapper').length != 0
                ? deliveryPopup
                : $(document).find('.delivery-popup').popup({type: 'html', allowScrolling: true});

            $.ajax({
                url: '/product/get-product-info?name=delivery',
                success: function (html) {
                    deliveryPopup.method('setHtml', '<div class="container"><div class="article">' + html + '</div></div>').method('show');
                }
            });
        });
    }

})();

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/popups/deliveryPopup.js","/expressions/popups")
},{"buffer":114,"r7L21G":116}],38:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {
    if ($('.review-new').hasClass('feedback-popup')) {
        var feedbackPopup = $('.feedback-popup').popup({type: 'html'});

        var firstRewTabName = $(".tab-name:first").attr('data-tab-name');

        if (window.location.pathname.indexOf('/uk') > -1){
            $.ajax({
                url: '/uk/product/feedback',
                success: function (html) {
                    feedbackPopup.method('setHtml', html)
                        .method('show');

                    if (firstRewTabName !== $('.tab-name[data-tab-name = "reviews"]')) {
                        $('.tab-item[data-item-name = "'+firstRewTabName+'"]').removeClass('active');
                        $(".tab-name:first").removeClass('active');

                        $('.tab-name[data-tab-name = "reviews"]').addClass('active');
                        $('.l-product-reviews.tab-item').addClass('active');
                    }
                }
            });
        }else {
            $.ajax({
                url: '/product/feedback',
                success: function (html) {
                    feedbackPopup.method('setHtml', html)
                        .method('show');

                    if (firstRewTabName !== $('.tab-name[data-tab-name = "reviews"]')) {
                        $('.tab-item[data-item-name = "'+firstRewTabName+'"]').removeClass('active');
                        $(".tab-name:first").removeClass('active');

                        $('.tab-name[data-tab-name = "reviews"]').addClass('active');
                        $('.l-product-reviews.tab-item').addClass('active');
                    }
                }
            });
        }


    } else if ($('.review-new').hasClass('feedback-validate')) {
        var hash = '#reviews-new';

        window.location.hash = 'reviews-new';

        $("html,body").stop().animate ({
            scrollTop: $(hash).offset().top - 100
        }, 10);
    }
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/popups/feedbackPopup.js","/expressions/popups")
},{"buffer":114,"r7L21G":116}],39:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
/**
 * Created by s.maksimovsky on 14.02.2019.
 */

var disableScroll = window.handleScroll.disableScroll;
var enableScroll = window.handleScroll.enableScroll;

module.exports = (function () {

    $(document).on('click', '.installment-plan-popup', function () {
        var $test =  $('body').find('#installment-popup');

        disableScroll(window);
        $test.parent().toggleClass('is-flex open');
        $test.css('display', 'block');

        $('.close-popup').on('click', closePopup);

        function closePopup() {
            enableScroll(window);
            $('.open .popup').stop(true, true).slideUp(100, function() {
                $(this).parent().removeClass('open');
                $('.popup-wrapper').removeClass('is-flex');
            });

            $('body').removeClass('is-modal-open is-nonscrollable');
        }

    });

    $(document).keydown(function(e) {
        if (e.keyCode == 27) {
            enableScroll(window);
            $('.open .popup').stop(true, true).slideUp(100, function() {
                $('#installment-plan-popup').parent().removeClass('open');
                $('.popup-wrapper').removeClass('is-flex');
            });

            $('body').removeClass('is-modal-open is-nonscrollable');
        }
    });
    
    $(document).ready(function() {

        var currentPriceProduct = $('.good-card .buy .price .number').text().replace(/\s/g, '');

        $('.product-price-installment span').text(currentPriceProduct);
        $('.quantity-price-installment span').text(currentPriceProduct);

        var a = (currentPriceProduct / 2) + (currentPriceProduct) * 0.029;
        $('.summ span').text(Math.ceil(a));

        $('.installment-popup').on('input keyup', function() {
            var monthInputVal = $('.month-number').val() || 2;
            var quantityInputVal = $('.product-quantity').val() || 1;

            if (monthInputVal < 1) {
                monthInputVal = 1;
            }

            if (monthInputVal > 24) {
                monthInputVal = 24;
            }

            if (quantityInputVal > 99) {
                quantityInputVal = 99;
            }

            var summ = (((parseInt(currentPriceProduct) * parseInt(quantityInputVal)) / parseInt(monthInputVal)) + (parseInt(currentPriceProduct) * parseInt(quantityInputVal)) * 0.029);

            $('.summ span').text(Math.ceil(summ));

            $('.quantity-price-installment span').text(parseInt(currentPriceProduct) * parseInt(quantityInputVal));
        });

    });
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/popups/installmentPlanPopup.js","/expressions/popups")
},{"buffer":114,"r7L21G":116}],40:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var cityTypehead = require('../../functions/typehead/city');
var updateIsLegal = require('../../functions/updateIsLegal');
var showLoader = require('../../functions/showLoader');
var loginPopup;

module.exports = (function () {

    var $d = $(document);

    loginPopup = $('.popup-sign-in').popup({type: 'html'});

    $d.on('click', '.login-popup', login);


    function login(e) {

        e.preventDefault();

        var $form = $(this).closest('form:not(#login_form)');

        if ($form.length) {
            showLoader($(this));

            if (window.location.pathname.indexOf('/uk') > -1){
                $.post('/uk/auth/password-recovery', $form.serialize(), passwordRecoveryResponce)
            }else{
                $.post('/auth/password-recovery', $form.serialize(), passwordRecoveryResponce)
            }

        } else {
            if (window.location.pathname.indexOf('/uk') > -1){
                $.get('/uk/auth/password-recovery', passwordRecoveryResponce);
            }else{
                $.get('/auth/password-recovery', passwordRecoveryResponce);
            }

        }
    }

    // function login(e) {
    //     e.preventDefault();
    //
    //     var $form = $(this).closest('form:not(#login_form)');
    //
    //     if ($form.length) {
    //         var data = $form.serialize();
    //
    //         data += '&save=true';
    //
    //         if (window.urlQueryParams['path'] !== undefined) {
    //             data += '&path=' + encodeURIComponent(window.urlQueryParams['path']);
    //         }
    //
    //         showLoader($(this));
    //
    //         $.post('/auth/login', data, response)
    //     } else {
    //         $.get('/auth/login', response);
    //     }
    // }

    function response(html) {
        loginPopup.method('setHtml', html)
            .method('show');

        setInputmask();
        onloadCaptchaCallback();

        $('.send-activate-code').click(activate);
        $('.registration').click(registration);
        $('.login-btn').click(login);
        $('.password-recovery').click(passwordRecovery);
    }

    function registration() {
        var $form = $(this).closest('form');

        if ($form.length) {
            var data = $form.serialize();

            data += '&save=true';

            showLoader($(this));

            if (window.location.pathname.indexOf('/uk') > -1){
                $.post('/uk/auth/registration', data, function (html) {
                    loginPopup.method('setHtml', html);

                    setInputmask();
                    cityTypehead();
                    onloadCaptchaCallback();

                    $('.send-activate-code').click(activate);
                    $('.resend-code').click(resendCode);
                    $('.is-legal li').click(updateIsLegal);
                    $('.back-to-login').click(login);
                    $('.login-btn').click(login);
                    $('.registration').click(registration);
                })
            } else {
                $.post('/auth/registration', data, function (html) {
                    loginPopup.method('setHtml', html);

                    setInputmask();
                    cityTypehead();
                    onloadCaptchaCallback();

                    $('.send-activate-code').click(activate);
                    $('.resend-code').click(resendCode);
                    $('.is-legal li').click(updateIsLegal);
                    $('.back-to-login').click(login);
                    $('.login-btn').click(login);
                    $('.registration').click(registration);
                })
            }


        } else {
            if (window.location.pathname.indexOf('/uk') > -1){
                $.get('/uk/auth/registration', function (html) {
                    loginPopup.method('setHtml', html)
                        .method('show');

                    setInputmask();
                    cityTypehead();
                    onloadCaptchaCallback();

                    $('.is-legal li').click(updateIsLegal);
                    $('.back-to-login').click(login);
                    $('.registration').click(registration);
                });
            } else {
                $.get('/auth/registration', function (html) {
                    loginPopup.method('setHtml', html)
                        .method('show');

                    setInputmask();
                    cityTypehead();
                    onloadCaptchaCallback();

                    $('.is-legal li').click(updateIsLegal);
                    $('.back-to-login').click(login);
                    $('.registration').click(registration);
                });
            }
        }
    }

    function activate(e) {
        e.preventDefault();

        var data = $(this).closest('form').serialize();

        $.post('/auth/activate', data, response)
    }
    
    function resendCode() {
        var phone = $(this).closest('form').find('.phone-field').val();

        $.post('/auth/resend-code', {phone: phone}, function (response) {
            if (response.result) {
                $('.resend-massage').text('Успешно отправлено!');
                $('.resend-code').remove();
            } else {
                $('.resend-massage').text('Произошла ошибка!');
            }
        })
    }
    
    function passwordRecovery(e) {
        e.preventDefault();

        var $form = $(this).closest('form:not(#login_form)');

        if ($form.length) {
            showLoader($(this));
            if (window.location.pathname.indexOf('/uk') > -1){
                $.post('/uk/auth/password-recovery', $form.serialize(), passwordRecoveryResponce)
            }else {
                $.post('/auth/password-recovery', $form.serialize(), passwordRecoveryResponce)
            }

        } else {
            if (window.location.pathname.indexOf('/uk') > -1){
                $.get('/uk/auth/password-recovery', passwordRecoveryResponce);
            }else {
                $.get('/auth/password-recovery', passwordRecoveryResponce);
            }

        }
    }

    function passwordRecoveryResponce(html) {
        loginPopup.method('setHtml', html)
            .method('show');

        setInputmask();
        onloadCaptchaCallback();

        $('.recovery-btn').click(passwordRecovery);
        $('.registration').click(registration);
    }
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/popups/loginPopup.js","/expressions/popups")
},{"../../functions/showLoader":82,"../../functions/typehead/city":96,"../../functions/updateIsLegal":99,"buffer":114,"r7L21G":116}],41:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {

    // Loading popups

    require('./popupBehavior');
    require('./agreementPopup');
    require('./announcePopup');
    require('./callbackPopup');
    require('./cartPopup');
    require('./deliveryPopup');
    require('./paymentPopup');
    require('./subscriptionPopup');
    require('./warrantyPopup');
    require('./paymentOnlinePopup');
    require('./feedbackPopup');
    require('./loginPopup');
    require('./installmentPlanPopup');
    require('./partsPurchasePopup');
    require('./tireFittingPopup');
    require('./alfaInstallmentPopup');

})();

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/popups/main.js","/expressions/popups")
},{"./agreementPopup":32,"./alfaInstallmentPopup":33,"./announcePopup":34,"./callbackPopup":35,"./cartPopup":36,"./deliveryPopup":37,"./feedbackPopup":38,"./installmentPlanPopup":39,"./loginPopup":40,"./partsPurchasePopup":42,"./paymentOnlinePopup":43,"./paymentPopup":44,"./popupBehavior":45,"./subscriptionPopup":46,"./tireFittingPopup":47,"./warrantyPopup":48,"buffer":114,"r7L21G":116}],42:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
/**
 * Created by s.maksimovsky on 06.11.2019.
 */

var disableScroll = window.handleScroll.disableScroll;
var enableScroll = window.handleScroll.enableScroll;

module.exports = (function () {

    $(document).on('click', '.parts-purchase-popup', function () {
        var $purchase = $('body').find('#parts-purchase');

        disableScroll(window);
        $purchase.parent().toggleClass('is-flex open');
        $purchase.css('display', 'block');

        $('.close-popup').on('click', closePopup);

        function closePopup() {
            enableScroll(window);
            $('.open .popup').stop(true, true).slideUp(100, function() {
                $(this).parent().removeClass('open');
                $('.popup-wrapper').removeClass('is-flex');
            });

            $('body').removeClass('is-modal-open is-nonscrollable');
        }

    });

   
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/popups/partsPurchasePopup.js","/expressions/popups")
},{"buffer":114,"r7L21G":116}],43:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var paymentOnlinePopup = $('.payment-online-popup').popup({type: 'html'});

module.exports = (function () {
    $('.payment-online-popup').click(function () {
        paymentOnlinePopup.method('setHtml', $(this).data('content')).method('show');
    });
})();

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/popups/paymentOnlinePopup.js","/expressions/popups")
},{"buffer":114,"r7L21G":116}],44:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {
    var paymentPopup = $('.payment-popup').popup({type: 'html', allowScrolling: true});

    if (window.location.pathname.indexOf('/uk') > -1){
        $(document).on('click', '.payment-popup', function () {
            paymentPopup = $(document).find('.payment-popup .popup-wrapper').length != 0
                ? paymentPopup
                : $(document).find('.payment-popup').popup({type: 'html', allowScrolling: true});

            $.ajax({
                url: '/uk/product/get-product-info?name=paymentUkr',
                success: function (html) {
                    paymentPopup.method('setHtml', '<div class="container"><div class="article">' + html + '</div></div>').method('show');
                }
            });
        });
    } else {
        $(document).on('click', '.payment-popup', function () {
            paymentPopup = $(document).find('.payment-popup .popup-wrapper').length != 0
                ? paymentPopup
                : $(document).find('.payment-popup').popup({type: 'html', allowScrolling: true});

            $.ajax({
                url: '/product/get-product-info?name=payment',
                success: function (html) {
                    paymentPopup.method('setHtml', '<div class="container"><div class="article">' + html + '</div></div>').method('show');
                }
            });
        });
    }


})();

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/popups/paymentPopup.js","/expressions/popups")
},{"buffer":114,"r7L21G":116}],45:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var onClickPopupWrapper = require('../../functions/onClickPopupWrapper');

module.exports = (function () {

    $('.popup').on('mouseleave', function () {
        $('.popup-wrapper').on('click', onClickPopupWrapper);
    });

    $('.popup').on('mouseover', function () {
        $('.popup-wrapper').off('click');
    });

    $('.search-mobile').click(function (e) {
        var $el = $(this);

        e.stopPropagation();
        $el.siblings('.phones-list, .search, .search-wrapper')
            .toggleClass('is-hidden is-visible')
            .removeClass('is-collapsed is-expanded');

        return false;
    });


    $('.close-menu').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).closest('li').toggleClass('is-expanded is-collapsed');
    });

    // Popups slider
    $('body').on('click', '.popup_toggle', function () {
        var context = $(this).parent();
        $('.popup-wrapper', context).toggleClass('is-flex');
        $('body').addClass('is-nonscrollable');
    });

    $(document).click(function(e){
        if (!$(this).find('#cntLoginForm').length || $(e.target).closest(".popup-sign-in").length || $(e.target).closest('.popup_toggle').length)
            return;

        $('.popup-sign-in .close_popup').click();
        event.stopPropagation();
    });

    $(document).on('click', '.spinner-loader', function () {
        $(this).closest('form').submit(function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
        });
    });
    
    // Modal slider
    $(document).on('click', '.modal_toggle', function () {
        $('.modal-content').toggleClass('is-flex');
    });

    function closeAllModals() {
        // Close all popups windows
        $('.popup-wrapper').removeClass('is-flex');
        $('body').removeClass('is-modal-open is-nonscrollable');
    }

    $('.hide-wrapper').click(function () {
        closeAllModals();
    });

    $(document).keydown(function (e) {
        if (e.keyCode == 27) {
            closeAllModals();
        }
    });
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/popups/popupBehavior.js","/expressions/popups")
},{"../../functions/onClickPopupWrapper":76,"buffer":114,"r7L21G":116}],46:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var subscriptionPopup;

module.exports = (function () {
    $('.subscription-popup').click(function () {
        try {
            subscriptionPopup = $('#modal').popup({type: 'html'});
        } catch (e) {}

        var email = $(this).closest('.wrapper').find('input[type="email"]').val();

        $.get('/subscription', callback)

        function callback(html) {
            subscriptionPopup.method('setHtml', html).method('show');
            onloadCaptchaCallback();
            cityTypehead();
            setInputmask();

            $('#modal .btn').click(function () {
                $('.field-subscription-captcha').removeClass('has-errors');

                $.post('subscription/save', $(this).closest('form').serialize(), callback)

                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push({event : "subscription"});
                }
            });

            if (email) {
                $(document).find('#modal #subscription-email').val(email);
                email = false;
            }
        }
    });

    if (window.location.pathname === '/uk') {
        $(document).ready(function() {
            $('.widget-form').on('click', '.widget-button', function() {
                $.post('uk/subscription/newsave', $(this).closest('form').serialize(), function(data) {
                    $(".widget-form .info").html(data);
                });
            });
        });
    } else {
        $(document).ready(function() {
            $('.widget-form').on('click', '.widget-button', function() {
                $.post('subscription/newsave', $(this).closest('form').serialize(), function(data) {
                    $(".widget-form .info").html(data);
                });
            });
        });
    }


})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/popups/subscriptionPopup.js","/expressions/popups")
},{"buffer":114,"r7L21G":116}],47:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
/**
 * Created by s.maksimovsky on 21.08.2019.
 */


var disableScroll = window.handleScroll.disableScroll;
var enableScroll = window.handleScroll.enableScroll;

module.exports = (function () {

    if ($(window).width() >= 941) {
        $('.tire-fitting').on('click', '.tirefitting-popup', function () {
            var $tireFittingPopup =  $('body').find('.product-info #tire-fitting');
            $('body').addClass('is-modal-open is-nonscrollable');

            disableScroll(window);
            $tireFittingPopup.parent().toggleClass('is-flex');
            $tireFittingPopup.css('display', 'block');

            $('.close-popup').on('click', closePopup);

            function closePopup() {
                enableScroll(window);
                $('.open .popup').stop(true, true).slideUp(100, function() {
                    $('.popup-wrapper').removeClass('is-flex');
                });

                $('body').removeClass('is-modal-open is-nonscrollable');
            }
        });
    } else {
        $('.tire-fitting').on('click', '.tirefitting-popup', function () {
            var $tireFittingPopupSmall =  $('body').find('.product-buy-small #tire-fitting');
            $('body').addClass('is-modal-open is-nonscrollable');

            disableScroll(window);
            $tireFittingPopupSmall.parent().toggleClass('is-flex');
            $tireFittingPopupSmall.css('display', 'block');

            $('.close-popup').on('click', closePopup);

            function closePopup() {
                enableScroll(window);
                $('.open .popup').stop(true, true).slideUp(100, function() {
                    $('.popup-wrapper').removeClass('is-flex');
                });

                $('body').removeClass('is-modal-open is-nonscrollable');
            }

        });
    }

    $(document).keydown(function(e) {
        if (e.keyCode == 27) {
            enableScroll(window);
            $('.open .popup').stop(true, true).slideUp(100, function() {
                $('.popup-wrapper').removeClass('is-flex');
            });

            $('body').removeClass('is-modal-open is-nonscrollable');
        }
    });
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/popups/tireFittingPopup.js","/expressions/popups")
},{"buffer":114,"r7L21G":116}],48:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {
    var warrantyPopup = $('.warranty-popup').popup({type: 'html', allowScrolling: true});

    if (window.location.pathname.indexOf('/uk') > -1) {
        $(document).on('click', '.warranty-popup', function () {
            warrantyPopup = $(document).find('.warranty-popup .popup-wrapper').length != 0
                ? warrantyPopup
                : $(document).find('.warranty-popup').popup({type: 'html', allowScrolling: true});

            $.ajax({
                url: '/uk/product/get-product-info?name=warrantyUkr',
                success: function (html) {
                    warrantyPopup.method('setHtml', '<div class="container"><div class="article">' + html + '</div></div>').method('show');
                }
            });
        });
    } else {
        $(document).on('click', '.warranty-popup', function () {
            warrantyPopup = $(document).find('.warranty-popup .popup-wrapper').length != 0
                ? warrantyPopup
                : $(document).find('.warranty-popup').popup({type: 'html', allowScrolling: true});

            $.ajax({
                url: '/product/get-product-info?name=warranty',
                success: function (html) {
                    warrantyPopup.method('setHtml', '<div class="container"><div class="article">' + html + '</div></div>').method('show');
                }
            });
        });
    }


})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/popups/warrantyPopup.js","/expressions/popups")
},{"buffer":114,"r7L21G":116}],49:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {
    // Loading dependencies for product page
    var bigPhoto = require('./bigPhoto');
    var deliverySlider = require('./deliverySlider');
    var estimationBehavior = require('./estimationBehavior');
    var manyPhotos = require('./manyPhotos');
    var reviewComment = require('./reviewComment');
    var reviewNew = require('./reviewNew');
    var reviewsSlider = require('./reviewsSlider');
    var Slider = require('../models/Slider');
    var characteristicMobile = require('./characteristicMobile');
    var slickProductList = require('../functions/slick/slickProductList');
    var slickOffer = require('../functions/slick/slickOffer');
    var hideBuyTogether = require('../functions/hideBuyTogether');
    var slickSaleSets = require('../functions/slick/slickSaleSets');
    var slickArticleProducts = require('../functions/slick/slickArticleProducts');
    var slickArticlePopular = require('../functions/slick/slickArticlePopular');
    var slickUsefulArticles = require('../functions/slick/slickUsefulArticles');
    var reviews = $('#reviews');


    if (reviews.length != 0) {
        if (window.location.pathname.indexOf('uk') > -1) {
            var url = '/uk/product/get-hide-info';
        } else {
            url = '/product/get-hide-info';
        }
        // var url = '/product/get-hide-info';

        if ($('#model').length) {
            if (window.location.pathname.indexOf('uk') > -1) {
                url = '/uk/model/get-hide-info';
            } else {
                url = '/model/get-hide-info';
            }
            // url = '/model/get-hide-info';
        }

        $.ajax({
            url: url + '?slug=' + window.location.pathname,
            success: function (response) {
                var json = $.parseJSON(response);

                reviews.replaceWith(json.feedback);

                $('#about p').html(json.about);

            }
        });
    }

    $(document).on('click', '.slider-trigger', function() {
        $(this).parent().toggleClass('is-collapsed is-expanded');
    });

    $('.color-list .accordion').click(function () {
        $(this).toggleClass('is-collapsed is-expanded');
    });

    $(document).on('click', '.reviews-section #show', function () {
        $(this).addClass('is-hidden')
            .closest('.reviews-section')
            .find('#hide')
            .removeClass('is-hidden')
            .closest('.reviews-section')
            .find('.review.is-hidden')
            .removeClass('is-hidden')
            .addClass('is-visible');
    });

    $(document).on('click', '.reviews-section #hide', function () {
        $(this).addClass('is-hidden')
            .closest('.reviews-section')
            .find('#show')
            .removeClass('is-hidden')
            .closest('.reviews-section')
            .find('.review.is-visible')
            .removeClass('is-visible')
            .addClass('is-hidden');
    });

    $(document).ready(function() {
        $(".tires-wheels-builder .tab_item").not(":first").hide();
        $(".tires-wheels-builder .tab:first").addClass('active');
        $(document).on('click', '.tires-wheels-builder .tab', function() {
            $(".tires-wheels-builder .tab").removeClass("active").eq($(this).index()).addClass("active");
            $(".tires-wheels-builder .tab_item").hide().eq($(this).index()).fadeIn();
        }).eq(0).addClass("active");
    });

    $(document).ready(function() {
        $(".l-giving-out-seo .tab_item").not(":first").hide();
        $(".tabs .tab:first").addClass('active');
        $(document).on('click', '.tabs .tab', function() {
            $(".tabs .tab").removeClass("active").eq($(this).index()).addClass("active");
            $(".l-giving-out-seo .tab_item").hide().eq($(this).index()).fadeIn();
        }).eq(0).addClass("active");
    });

    $(document).ready(function() {
        $(".l-seo .tab_item").not(":first").hide();
        $(".tabs .tab:first").addClass('active');
        $(document).on('click', '.tabs .tab', function() {
            $(".tabs .tab").removeClass("active").eq($(this).index()).addClass("active");
            $(".l-seo .tab_item").hide().eq($(this).index()).fadeIn();
        }).eq(0).addClass("active");
    });

    $(document).ready(function() {
        $(".l-additional-information .tab-item").not(":first").hide();
        $(".tabs .tab:first").addClass('active');
        $(document).on('click', '.tabs .tab', function() {
            $(".tabs .tab").removeClass("active").eq($(this).index()).addClass("active");
            $(".l-additional-information .tab-item").hide().eq($(this).index()).fadeIn();
        }).eq(0).addClass("active");
    });

    $(document).ready(function(){
        $('.l-giving-out-seo.tab-item .seo').wrapInner('<div class="text"></div>>')
    });
 
    $(document).ready(function() {
        $(".tab-name:first").addClass('active');
        var firstTabName = $(".tab-name:first").attr('data-tab-name');
        $('.tab-item[data-item-name = "'+firstTabName+'"]').addClass('active');

        $(document).on('click', '.tab-name', function() {
            $('.tab-name').removeClass('active');
            $('.tab-item').removeClass('active');

            $(this).addClass('active');
            var currentNameData = $(this).attr('data-tab-name');
            $('.tab-item[data-item-name = "'+currentNameData+'"]').addClass('active');
        });

        var $productMenuS = $('.product-scroll');
        var clickItem = $productMenuS.find('.sections-item a');
        var productNewReview = $('.product-table').find('.reviews-count');
        
        var scrollToTab = function(event) {
            event.preventDefault();
            $('.tab-name').removeClass('active');
            $('.tab-item').removeClass('active');

            var currentSectionData = $(this).attr('data-section-name');

            $('.tab-item[data-item-name = "'+currentSectionData+'"]').addClass('active');
            $('.tab-name[data-tab-name = "'+currentSectionData+'"]').addClass('active');
        };

        clickItem.on('click', scrollToTab);
        productNewReview.on('click', scrollToTab);
    });

    $(document).on('click', '.product-special-offer .goods-list button', function () {
        var $set = $(this).closest('.set'),
            price = +$set.find('.product-item .price').data('price'),
            $priceItem = $set.find('.price-item'),
            priceOld = price,
            ids = [],
            ga = $set.find('.product-item').data('ga');

        $set.find('.goods-list').each(function (index) {
            var $element = $(this).find('.slick-slide.slick-active').length
                ? $(this).find('.slick-slide.slick-active')
                : $(this).find('.slick-slide[data-slick-index="0"]');

            price += +$element.find('.price').data('price');
            priceOld += +$element.find('.price-old').data('price');
            ids.push($element.data('id'));
            ga.ecommerce.add.products.push($element.data('ga'));
        });

        $priceItem.find('.price .number').html(price);
        $priceItem.find('.price-old .number').html(priceOld);
        $priceItem.find('.economy-price .number').html(priceOld - price);
        $priceItem.find('.btn-buy').data('sets', ids.toString());
        $priceItem.find('.btn-buy').data('ga', ga);
    });
    
    var productPhotoSlider = new Slider({
        $prevSlide: $('.l-product .slider-controls .slider-prev'),
        $nextSlide: $('.l-product .slider-controls .slider-next'),
        $slides: $('.l-product .product-photos')
    });

    if (!$('#model').length) {
        slickProductList();
        slickOffer();
        slickSaleSets();
        slickArticleProducts();
        slickUsefulArticles();
        slickArticlePopular();
    }

    var similarCategoriesSlider = new Slider({
        $prevSlide: $('.l-similar-categories .slider-controls .slider-prev'),
        $nextSlide: $('.l-similar-categories .slider-controls .slider-next'),
        $slides: $('.l-similar-categories .categories-list')
    });

    var elementFalse = document.getElementById('validate-false');
    var elementTrue = document.getElementById('validate-true');
    if (elementFalse) {
        document.location.href = '#validate-false';
    }
    if (elementTrue) {
        var $this = $(elementTrue);
        loadBlock('.modal-body', $this.attr('data-modal'), function () {
            $('#modal').modal();
            $('.modal-content').addClass('is-flex')
        });
    }

    $(document).ready(function() {
        var longRead = $('.l-giving-out-seo .seo .text');
        var longReadButton = $('.l-giving-out-seo').find('button');
        
        if(longRead.height() > 300) {
            longRead.addClass('hide');

            longReadButton.addClass('show');
        }

        function openSeoDescription() {
            longRead.toggleClass('open');

            if (window.location.pathname.indexOf('uk') > -1){
                if(longRead.hasClass('open')) {
                    longReadButton.html('Згорнути...');
                } else {
                    longReadButton.html('Докладніше...');
                }
            } else {
                if(longRead.hasClass('open')) {
                    longReadButton.html('Свернуть...');
                } else {
                    longReadButton.html('Подробнее...');
                }
            }
        }

        longReadButton.on('click', openSeoDescription);
    });
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/productPage.js","/expressions")
},{"../functions/hideBuyTogether":71,"../functions/slick/slickArticlePopular":84,"../functions/slick/slickArticleProducts":85,"../functions/slick/slickOffer":86,"../functions/slick/slickProductList":88,"../functions/slick/slickSaleSets":89,"../functions/slick/slickUsefulArticles":90,"../models/Slider":108,"./bigPhoto":10,"./characteristicMobile":15,"./deliverySlider":19,"./estimationBehavior":21,"./manyPhotos":26,"./reviewComment":53,"./reviewNew":54,"./reviewsSlider":55,"buffer":114,"r7L21G":116}],50:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var showLoader = require('../functions/showLoader');

module.exports = (function () {
    $('.change-password').click(function () {
        setTimeout(function () {
            if (!$(this).closest('form').find('has-error').length) {
                showLoader($(this));
            }
        }, 150);
    });
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/profilePage.js","/expressions")
},{"../functions/showLoader":82,"buffer":114,"r7L21G":116}],51:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var updateTotals = require('../functions/updateTotals');

module.exports = (function promoCodes() {
    // Promo-codes (begin)

    $('body').on('click', '.enter-code', function (e) {
        var $this = $(this);
        var $parent = $this.closest('.promo-code');
        e.preventDefault();

        $parent.find('.promo-code-block').toggleClass('is-hidden')
    });

    $('body').on('click', '.show-delivery', function(e) {
        var $this = $(this);
        var $parent = $this.closest('.delivery-block');
        e.preventDefault();

        $parent.find('.info-block').toggleClass('is-hidden')
    });

    $('body').on('click', '.promo-code-block .btn, .promo-code-remove', function (e) {
        var $this = $(this);
        var $input = $this.closest('.promo-code-block').find('input[type="text"]');

        e.preventDefault();

        if (e.target.className == 'promo-code-remove') {
            $input.val('');
        }

        if (window.location.pathname.indexOf('/uk') > -1) {
            var cartLinkUpdate = '/uk/cart/update-products?payment-id=';
        } else {
            var cartLinkUpdate = 'cart/update-products?payment-id=';
        }

        updateTotals().then(function () {
            $.ajax({
                url: cartLinkUpdate + $('#paymentMethod input[type=\'radio\']:checked').val(),
                method: 'GET'
            }).then(function (jqHtml) {
                $('.goods-list').html(jqHtml);
            }, function (err) {
                console.error(err);
            });
        });
    });

    // Promo-codes (end)
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/promoCodes.js","/expressions")
},{"../functions/updateTotals":103,"buffer":114,"r7L21G":116}],52:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var loadBlock = require('../functions/loadBlock');
var disableScroll = window.handleScroll.disableScroll;
var enableScroll = window.handleScroll.enableScroll;

module.exports = (function () {

    $(document).ready(function () {

        $('body').on('click', '.quick-buy-button', function() {
            var $this = $(this);
            var $test =  $('body').find('#quick_buy1');
            
            showPopup();

            function showPopup() {
                disableScroll(window);
                loadBlock($test, $this.attr('data-popup'), function () {
                    $test.parent().toggleClass('is-flex open');
                    $test.css('display', 'block');
                    // setInputmask();
                    $('#quickbuyform-phone').inputmask('+38 (099) 999-99-99');

                    $('.close_popup').on('click', closePopup);

                    function closePopup() {
                        enableScroll(window);
                        $('.open .popup').stop(true, true).slideUp(100, function () {
                            $(this).html('').parent().removeClass('open').find('.popup_toggle').removeClass('open');
                            $('.popup-wrapper').removeClass('is-flex');
                        });

                        $('body').removeClass('is-modal-open is-nonscrollable');
                    }
                });
            }
        });

        $(document).on('click', '.counter.quick_buy .less-control', function (event) {
            event.stopPropagation();
            var $el = $(this);
            var input = $el.parents('.quick_buy').find('.number_input');

            var max = input.attr("max") || 99;
            var min = input.attr("min") || 1;
            var currentVal = parseInt(input.val());

            if (isNaN(currentVal)) {
                input.val(min);
            }
            if (currentVal > min) {
                input.val(currentVal - 1).change();
            }
        });

        $(document).on('click', '.counter.quick_buy .more-control', function (event) {
            event.stopPropagation();
            var $el = $(this);
            var input = $el.parents('.quick_buy').find('.number_input');

            var max = input.attr("max") || 99;
            var min = input.attr("min") || 1;
            var currentVal = parseInt(input.val());
            var remain = parseInt($el.data('remain'));

            if (isNaN(currentVal)) {
                input.val(max);
            }

            if (currentVal < remain) {
                input.val(currentVal + 1).change();
            }

        });

        $(document).on('click', '#quick-buy-button', function() {
            var current = $(this);
            var phoneInput = current.siblings('.quick-buy-phone').find('#quickbuyform-phone');

            if (phoneInput.val() == 0 || phoneInput.val().indexOf('_') > -1) {
                phoneInput.parent('.form-group').addClass('has-error');
            } else {
                phoneInput.parent('.form-group').removeClass('has-error');
            }

            if (phoneInput.val().at(6) == 0) {
                phoneInput.closest('.form-group').find('.phone-error').show();
            } else {
                phoneInput.closest('.form-group').find('.phone-error').hide();
            }
        });

        $(document).on('change', '.counter.quick_buy .number_input', function (event) {
            event.stopPropagation();
            var input = $(this);
            var min = parseInt(input.attr('min'));
            var max = parseInt(input.attr('max'));
            var valueCurrent = parseInt(input.val());
            var price = parseFloat(input.data('price'));
            var sumContainer = input.parents('.quickbuy_good').find('.quickbuy_sum');
            var sum = 0;
            if (valueCurrent !== valueCurrent) {
                input.val(min);
                valueCurrent = parseInt(input.val());
            }
            if (valueCurrent <= min) {
                input.val(min);
            }

            if (valueCurrent >= max) {
                input.val(max);
            }
            valueCurrent = parseInt(input.val());

            sum = number_format(valueCurrent * price, 0, '', '');
            sumContainer.text(sum);

        })

    });

    function number_format(number, decimals, dec_point, thousands_sep) {  // Format a number with grouped thousands
        var i, j, kw, kd, km;
        // input sanitation & defaults
        if (isNaN(decimals = Math.abs(decimals))) {
            decimals = 2;
        }
        if (dec_point == undefined) {
            dec_point = ",";
        }
        if (thousands_sep == undefined) {
            thousands_sep = ".";
        }
        i = parseInt(number = (+number || 0).toFixed(decimals)) + "";
        if ((j = i.length) > 3) {
            j = j % 3;
        } else {
            j = 0;
        }

        km = (j ? i.substr(0, j) + thousands_sep : "");
        kw = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands_sep);
        //kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).slice(2) : "");
        kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "");
        return km + kw + kd;
    }
})();


}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/quickBuy.js","/expressions")
},{"../functions/loadBlock":75,"buffer":114,"r7L21G":116}],53:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {
        // Detail comment on the product page
        $('.comment-show').click(function (event) {
            event.preventDefault();
            $('textarea.comment').toggleClass('is-hidden is-visible');
        });

        // Logic for respond form in the reviews section
        $('.l-product-reviews .respond').click(function (event) {
            event.preventDefault();
            var context = $(this).parent();

            $('.respond-form', context).toggleClass('is-hidden is-visible');
        });
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/reviewComment.js","/expressions")
},{"buffer":114,"r7L21G":116}],54:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {
        // Review slider (begin)

        $('#reviews-new').click(function () {
            var $parent = $(this).closest('.review-new');

            $parent.toggleClass('is-collapsed');
        });

        $('.review-new .mark').click(function () {
            var $parent = $(this).closest('.review-new');

            $parent.removeClass('is-collapsed');
        });

        // Review slider (end)

})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/reviewNew.js","/expressions")
},{"buffer":114,"r7L21G":116}],55:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {
    var reviewSlides = 3;
    var currentSlide = 1;

    function updateReviewSlider(prevSlide) {
        // Make an appropriate status circle active
        var circles = $('.l-reviews .status .item .glyph');

        $(circles[prevSlide - 1]).removeClass('is-active');
        $(circles[currentSlide - 1]).addClass('is-active');

        // Show required slide
        var reviews = $('.l-reviews .reviews .item');

        $(reviews[prevSlide - 1]).removeClass('is-active');
        $(reviews[currentSlide - 1]).addClass('is-active');
    }

    $('.l-reviews .prev').on('click', function () {
        // Switch current slide pointer
        var prevSlide = currentSlide;
        if (currentSlide === 1) {
            currentSlide = reviewSlides;
        } else {
            currentSlide--;
        }

        updateReviewSlider(prevSlide);
    });

    $('.l-reviews .next').on('click', function () {
        // Switch current slide pointer
        var prevSlide = currentSlide;
        if (currentSlide === reviewSlides) {
            currentSlide = 1;
        } else {
            currentSlide++;
        }

        updateReviewSlider(prevSlide);
    });

})();

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/reviewsSlider.js","/expressions")
},{"buffer":114,"r7L21G":116}],56:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var loadBlock = require('../functions/loadBlock');
var disableScroll = window.handleScroll.disableScroll;
var enableScroll = window.handleScroll.enableScroll;

module.exports = (function () {

    // Logic for REZINA.CC small resolution BEGIN

    $(document).ready(function() {

        // Logic for REZINA.CC l-tires-wheels-builder BEGIN

        if ($(window).width() < 940) {
            $('.mobile-version .tires-wheels-builder-tire-form').addClass('tab_item');
            $('.mobile-version .tires-wheels-builder-wheels-form').addClass('tab_item');
        }

        $('.l-content .tires-wheels-builder-tire-form').addClass('tab_item');
        $('.l-content .tires-wheels-builder-wheels-form').addClass('tab_item');


        // Реализация Seohide. Скрытие ссылок от индексации
        $('.hidden').click(function(){
            window.location.href = $(this).attr('data-url');
            return false;
        });


        // Logic for REZINA.CC l-tires-wheels-builder END

        // Logic for slider l-articles for REZINA.CC BEGIN

        if ($(window).width() < 600) {
            var i = 0;
            var $itemsArticle =  $('.l-articles.mobile-version .articles').children();

            $itemsArticle.eq(0).addClass('show');

            for (var j = 0; j < $itemsArticle.length; j++) {
                if(j === 0) {
                    $('.l-articles.mobile-version .controls .controls-dots').append('<div class="dots active"></div>');
                } else {
                    $('.l-articles.mobile-version .controls .controls-dots').append('<div class="dots"></div>');
                }
            };

            $('.controls-dots .dots').on('click', function() {
                var indexDots = $(this).index();

                $itemsArticle.removeClass('show');
                $('.controls-dots .dots').removeClass('active');
                $(this).addClass('active');

                $itemsArticle.each(function(index) {
                    if (indexDots === index) {
                        $(this).addClass('show');
                    }
                });
            });

            $('.control-prev .prev').on('click', function() {
                $itemsArticle.removeClass('show');
                $('.controls-dots .dots').removeClass('active');
                i++;

                if (i >= $itemsArticle.length) {
                    i = 0;
                }

                $itemsArticle.eq(i).addClass('show');
                $('.controls-dots .dots').eq(i).addClass('active');
            });

            $('.control-next .next').on('click', function() {
                $itemsArticle.removeClass('show');
                $('.controls-dots .dots').removeClass('active');
                i--;

                if (i < 0) {
                    i = $itemsArticle.length - 1;
                }

                $itemsArticle.eq(i).addClass('show');
                $('.controls-dots .dots').eq(i).addClass('active');
            });
        };

        // Logic for slider l-articles for REZINA.CC END

        // Toggle delivery-text in product page in Rezina.cc BEGIN

        $('.advantages .delivery').on('click', function() {
            $('.advantages .guarantee-info').removeClass('show');
            $('.advantages .guarantee').removeClass('open');

            $('.advantages .wrapper-delivery-block').toggleClass('show');
            $(this).toggleClass('open');
        });

        $('.advantages .guarantee').on('click', function() {
            $('.advantages .wrapper-delivery-block').removeClass('show');
            $('.advantages .delivery').removeClass('open');

            $('.advantages .guarantee-info').toggleClass('show');
            $(this).toggleClass('open');
        });

        // Toggle delivery-text in product page in Rezina.cc END

        // Slider in product page in Rezina.cc BEGIN

        if ($(window).width() < 1085) {

            var tabAttr = $('#tab-buttons .tab ul li a').attr('data-name');
            var tabRow = $('#tab-contents .another-parameters .row');

            var tabRowAttrShina = $('#tab-contents .another-parameters .row[data-diametr_shina = "'+tabAttr+'"]');
            var tabRowAttrDisk = $('#tab-contents .another-parameters .row[data-diametr_disk = "'+tabAttr+'"]');
            var tabRowAttr = tabRowAttrShina.length === 0 ? tabRowAttrDisk : tabRowAttrShina;

            var classesShina = tabRow.map(function(indx, element) {return $(element).attr("data-diametr_shina");});
            var classesDisk = tabRow.map(function(indx, element) {return $(element).attr("data-diametr_disk");});
            var classes = classesShina.length === 0 ? classesDisk : classesShina;

            var productCount = tabRowAttr.length;

            for (var t = 0; t < classes.length; t++) {
                if (tabAttr === classes[t]) {
                    tabRowAttr.addClass('show');
                    tabRowAttr.first().addClass('first');

                    $('#tab-buttons .tab ul li a').on('click', function(e) {

                        e.preventDefault();
                        tabRowAttr.removeClass('show');
                        tabRowAttr.first().removeClass('first');

                        var tabAttrCurrent = $(this).attr('data-name');

                        var tabRowAttrCurrentShina = $('#tab-contents .another-parameters .row[data-diametr_shina = "'+tabAttrCurrent+'"]');
                        var tabRowAttrCurrentDisk = $('#tab-contents .another-parameters .row[data-diametr_disk = "'+tabAttrCurrent+'"]');
                        var tabRowAttrCurrent = tabRowAttrCurrentShina.length === 0 ? tabRowAttrCurrentDisk : tabRowAttrCurrentShina;

                        var allRows = $('#tab-contents .another-parameters .row');
                        var i = 0;

                        allRows.removeClass('show');
                        allRows.first().removeClass('first');

                        tabRowAttrCurrent.addClass('show');
                        tabRowAttrCurrent.first().addClass('first');

                        $('.product-count span').html(tabRowAttrCurrent.length);

                        if (tabRowAttrCurrent.length <= 1) {
                            $('.another-parameters .control-prev').css('display', 'none');
                            $('.another-parameters .control-next').css('display', 'none');
                        } else {
                            $('.another-parameters .control-prev').css('display', 'inline-block');
                            $('.another-parameters .control-next').css('display', 'inline-block');
                        }

                        $('.another-parameters .control-prev .prev').on('click', function() {
                            tabRowAttrCurrent.removeClass('first');
                            i++;

                            if (i >= tabRowAttrCurrent.length) {
                                i = 0;
                            }

                            tabRowAttrCurrent.eq(i).addClass('first');
                        });

                        $('.another-parameters .control-next .next').on('click', function() {
                            tabRowAttrCurrent.removeClass('first');
                            i--;

                            if (i < 0) {
                                i = tabRowAttrCurrent.length - 1;
                            }

                            tabRowAttrCurrent.eq(i).addClass('first');
                        });
                    })
                }
            }

            if (productCount <= 1) {
                $('.another-parameters .control-prev').css('display', 'none');
                $('.another-parameters .control-next').css('display', 'none');
            } else {
                $('.another-parameters .control-prev').css('display', 'inline-block');
                $('.another-parameters .control-next').css('display', 'inline-block');
            }

            $('.another-parameters .control-prev .prev').on('click', function() {
                tabRowAttr.removeClass('first');
                i++;

                if (i >= tabRowAttr.length) {
                    i = 0;
                }

                tabRowAttr.eq(i).addClass('first');
            });

            $('.another-parameters .control-next .next').on('click', function() {
                tabRowAttr.removeClass('first');
                i--;

                if (i < 0) {
                    i = tabRowAttr.length - 1;
                }

                tabRowAttr.eq(i).addClass('first');
            });

        };

        // Slider in product page in Rezina.cc END

        // In mobile resolution all time is close reviews BEGIN

        if ($(window).width() < 1085) {
            $('.review-new.mobile-resolution').addClass('is-collapsed');
        };

        // In mobile resolution all time is close reviews END

        // Rezina.cc widget

        function saleRezinaWidget() {
            var mainSaleWidget = $('.sale-widgets');
            var bigSaleWidget = $('.b-sale-widgets');
            var smallSaleWidget = $('.s-sale-widgets');
            var windowFullWidth = $(document).outerHeight(true);
            var windowWidth = $(window).height();
            var windowBottom = windowFullWidth - windowWidth;

            mainSaleWidget.addClass('open');

            function openWidget() {
                smallSaleWidget.toggleClass('close');
                bigSaleWidget.addClass('open');
            }

            function closeWidget() {
                bigSaleWidget.removeClass('open');
                smallSaleWidget.removeClass('close');
            }

            if($(window).width() > 1000) {
                $(document).scroll(function() {
                    if ($(window).scrollTop() == windowBottom) {
                        openWidget();
                    } else {
                        closeWidget();
                    }
                });
            }

            smallSaleWidget.on('click', openWidget);
            bigSaleWidget.on('click', '.close', closeWidget);
        };

        setTimeout(saleRezinaWidget, 10000);

        //

        var contextRow = $('.car-filters .row');
        contextRow.first().find('.name').addClass('up');
        contextRow.first().find('.list').addClass('open');

        contextRow.on('click', '.name', function() {
            $(this).toggleClass('up');
            $(this).siblings('.list').toggleClass('open');
        });

        var currentUrl = window.location.href;
        var tempArr = currentUrl.split("/");

        if($.inArray("cart", tempArr) > -1) {

        }

        $('.l-model-video iframe').load(function() {
            $(this).contents().find('ul').css('list-style-type', 'none').css('padding', '0').css('text-align', 'center');

            if($(this).contents().find('ul li').length > 1) {
                $(this).contents().find('ul li').css('display', 'inline-block');
                $(this).css('width', '100%');
            }

            if($(window).width() < 650) {
                $(this).contents().find('iframe').css('width', 'auto').css('height', 'auto');
                $(this).css('width', 'auto').css('height', 'auto');
            }
        });

        // Tabs status orders in profile
        var profileTabs = $('.l-profile .orders-list .tabs-name');
        var profileItems = $('.l-profile .orders-list .wrap-order-info');
        var profileTabsFirstAttr =  profileTabs.first().attr('tab-attr');

        profileTabs.first().addClass('active');
        $('.l-profile .orders-list .wrap-order-info[tab-attr = "'+profileTabsFirstAttr+'"]').addClass('show');

        profileTabs.on('click', function() {
            profileItems.removeClass('show');
            profileTabs.removeClass('active');
            $(this).addClass('active');
            var context = $(this).attr('tab-attr');
            $('.l-profile .orders-list .wrap-order-info[tab-attr = "'+context+'"]').addClass('show');
        });

        // Rezina.cc leave cather widget

        // if ($(window).width() >= 941) {
        //
        //     function getCookie(name) {
        //         var matches = document.cookie.match(new RegExp(
        //             "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        //         ));
        //         return matches ? decodeURIComponent(matches[1]) : undefined;
        //     }
        //
        //     var sess = getCookie("sess");
        //
        //     $(document).on('mouseleave', (function(e) {
        //         var cartPopupIsVisible = $('.popup-wrapper').hasClass('is-flex');
        //
        //         if (e.clientY < 0 && getCookie("sess") == undefined
        //             && window.location.pathname != '/contacts'
        //             && window.location.pathname != '/garantia'
        //             && window.location.pathname != '/delivery'
        //             && !cartPopupIsVisible) {
        //
        //             showPopup();
        //
        //             document.cookie = "sess=act; path=/; max-age=3600";
        //
        //         }
        //     }));
        //
        //     function showPopup() {
        //         var $this = $('.catch-widget a');
        //         var parent = $this.parent();
        //
        //         disableScroll(window);
        //         loadBlock(parent.find('.popup'),$this.attr('data-popup'), function () {
        //             parent.find('.popup-wrapper').addClass('is-flex open');
        //             parent.find('.popup').css('display', 'block');
        //         });
        //     }
        // }

        // Accordion in Rezina.cc

        var accordionItems = $('.schema-accordion .accordion-list .accordion-item');
        
        accordionItems.on('click', function() {
           $(this).toggleClass('active');
           accordionItems.not(this).removeClass('active');
        });

        // function binotelNomerReplacement() {
        //     var binotelNomer = $('.binct-phone-number-1').filter(':first').text();

            // $('.binct-phone-number-1').attr('href', 'tel:' + binotelNomer);
        // }

        // setTimeout(binotelNomerReplacement, 5000);
    });

    // Добавление класса checked на выбранные фитры блога

    $('.filter-button').on('click', function() {
        $('.wrapper-blog-filter').toggleClass('open');
    });

    $('.wrapper-blog-filter').on('click', '.group-blog-filter input', function() {
        $(this).toggleClass('checked');
    });

    if (window.location.pathname.indexOf('/uk') > -1){
        var filterUrlBlogUkr = $(location).attr('origin') + '/uk/blog/filter';

        if ($(location).attr('href') === filterUrlBlogUkr) {
            $('.remove-filters').addClass('show');
        }
    }else {
        var filterUrlBlog = $(location).attr('origin') + '/blog/filter';

        if ($(location).attr('href') === filterUrlBlog) {
            $('.remove-filters').addClass('show');
        }
    }

    var currentDiameterLi = $('.l-info .characteristics-list.characteristics-list-mobile li .key:contains("Диаметр:")').siblings('.value').text() ? $('.l-info .characteristics-list.characteristics-list-mobile li .key:contains("Диаметр:")').siblings('.value').text() : $('.l-info .characteristics-list.characteristics-list-mobile li .key:contains("Діаметр шини:")').siblings('.value').text();

    switch(currentDiameterLi.replace(/\s+/g, '')) {
        case 'R12':
        case 'R13':
        case 'R14':
            $('.delivery-cost-row.new-post span').text('215');
            $('.delivery-cost-row.delivery span').text('144');
            break;
        case 'R12C':
        case 'R13C':
        case 'R14C':
            $('.delivery-cost-row.new-post span').text('215');
            $('.delivery-cost-row.delivery span').text('144');
            break;
        case 'R15':
        case 'R16':
            $('.delivery-cost-row.new-post span').text('220');
            $('.delivery-cost-row.delivery span').text('149');
            break;
        case 'R15C':
            $('.delivery-cost-row.new-post span').text('220');
            $('.delivery-cost-row.delivery span').text('187');
            break;
        case 'R16C':
            $('.delivery-cost-row.new-post span').text('220');
            $('.delivery-cost-row.delivery span').text('187');
            break;
        case 'R17':
            $('.delivery-cost-row.new-post span').text('225');
            $('.delivery-cost-row.delivery span').text('155');
            break;
        case 'R17C':
            $('.delivery-cost-row.new-post span').text('225');
            $('.delivery-cost-row.delivery span').text('187');
            break;
        case 'R18':
        case 'R19':
            $('.delivery-cost-row.new-post span').text('245');
            $('.delivery-cost-row.delivery span').text('171');
            break;
        case 'R20':
        case 'R21':
            $('.delivery-cost-row.new-post span').text('255');
            $('.delivery-cost-row.delivery span').text('181');
            break;
        case 'R22':
        case 'R23':
            $('.delivery-cost-row.new-post span').text('265');
            $('.delivery-cost-row.delivery span').text('187');
            break;
        case 'R24':
            $('.delivery-cost-row.new-post span').text('265');
            if (window.location.pathname.indexOf('uk/') > -1) {
                $('.delivery-cost-row.delivery').text('Делівері - Уточніть вартість доставки у оператора');
            } else {
                $('.delivery-cost-row.delivery').text('Деливери - Уточните стоимость доставки у оператора');
            }
            break;
        default:
            if (window.location.pathname.indexOf('uk/') > -1) {
                $('.delivery-cost-row.new-post').text('Уточніть вартість доставки у оператора');
            } else {
                $('.delivery-cost-row.new-post').text('Уточните стоимость доставки у оператора');
            }
            $('.delivery-cost-row.delivery').hide();
    }

    // Переключатель языка

    $('.current-lang').on('click', function() {
       $(this).toggleClass('up');
       $('.drop-lang').toggleClass('open');
    });

    var cartPhoneFieldInput = $('.checkout-list .field-phone').find('#phone');

    cartPhoneFieldInput.focusout(function() {
        var cartPhoneValue = $(this).val();
        var $form = $('#checkout_form');

        if (window.location.pathname.indexOf('/uk') > -1){
            $.ajax({
                type: "POST",
                url: "/uk/cart/abandoned",
                data: $form.serialize()
            });
        } else{
            $.ajax({
                type: "POST",
                url: "/cart/abandoned",
                data: $form.serialize()
            });
        }


    });

    // Активация карусели брендов

    $(document).ready(function(){
        $(".l-giving-out-seo .seo .owl-carousel").owlCarousel();
    });
})();

(function ($) {
    $( '.contact-form').submit(function (event) {
        event.preventDefault();

        // Сообщения формы
        var successSendText = 'Сообщение успешно отправлено';
        var errorSendText = 'Сообщение не отправлено. Попробуйте еще раз!';
        var requiredFieldsText = 'Заполните поля с именем и телефоном';

        // Сохраняем в переменную класс с параграфом для вывода сообщений об отправке
        var message = $(this).find('.contact-form__message');

        if (window.location.pathname.indexOf('/uk') > -1) {
            var tgaction = '/uk/site/send-telegram';
        } else {
            var tgaction = 'site/send-telegram';
        }

        var form = $('#' + $(this).attr('id'))[0];
        var fd = new FormData(form);
        $.ajax({
                url: tgaction,
                type: 'POST',
                data: fd,
                processData: false,
                contentType: false,
                beforeSend: function() {
                $('.preloader').addClass('preloader_active');
    },
        success: function success(res) {
            $('.preloader').removeClass('preloader_active');

            // Посмотреть на статус ответа, если ошибка
            console.log(res);
            var respond = $.parseJSON(res);

            if (respond === "SUCCESS") {
                message.text(successSendText).css("color", "#21d4bb");
                setTimeout(function() {
                    message.text("");
            }, 4000);
            } else if (respond === "NOTVALID") {
                message.text(requiredFieldsText).css("color", "#d42121");
                setTimeout(function() {
                    message.text("");
            }, 3000);
            } else {
                message.text(errorSendText).css("color", "#d42121");
                setTimeout(function() {
                    message.text("");
            }, 4000);
            }
        }
    });
    });
})(jQuery);

// Бинотел виджет для rezina.cc

// (function(d, w, s) {

    // var widgetHash = 'qhd54wsaz4faavmkxcec', ctw = d.createElement(s); ctw.type =
    //     'text/javascript'; ctw.async = true;

    // ctw.src = '//widgets.binotel.com/calltracking/widgets/'+
    //     widgetHash +'.js';

    // var sn = d.getElementsByTagName(s)[0]; sn.parentNode.insertBefore(ctw, sn);

// })(document, window, 'script');


}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/rezinaMobile.js","/expressions")
},{"../functions/loadBlock":75,"buffer":114,"r7L21G":116}],57:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {
    // Logic for scroll menu BEGIN

    $(document).scroll(function () {
        var $menu = $('.menu');
        var $buyBtn = $('#product-info .btn-buy');
        var offset = $menu.offset();
        var menuPosition;

        if (!$buyBtn.length) {
            $buyBtn = $('#product-info .btn-custom');
        }   
        
        if (offset) {
            menuPosition = offset.top + $menu.height();
        }

        // Show scroll menu

        var $scrollMenu = $('.menu-scroll');
        var $productMenu = $('.product-scroll');
        var $window = $(window);

        if((($productMenu && $productMenu.length === 0) || ($window.width() < 970)) && ($window.scrollTop() >= menuPosition)) {
            $scrollMenu.addClass('is-visible');
        } else {
            $scrollMenu.removeClass('is-visible');
        }

        if ($buyBtn.length) {
            var buyBtnPosition = 100;

            // Show product menu
            if ($window.scrollTop() >= buyBtnPosition) {
                $productMenu.addClass('is-visible');
            } else {
                $productMenu.removeClass('is-visible');
            }
        }
    });

    // Logic for scroll menu END
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/scrollMenu.js","/expressions")
},{"buffer":114,"r7L21G":116}],58:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
/**
 * Created by s.maksimovsky on 12.12.2018.
 */
module.exports = (function () {

    $(document).ready(function() {

        var modificationTab = $('.modification-wrapper .modification-tab');
        var diameterTab = $('.diameter-wrapper .diameter-tab');
        var sizeTab = $('.size-wrapper .size-tab');

        modificationTab.first().addClass('active');
        var currentMod = modificationTab.first().attr('data-modification');

        var aDiam = $('.diameter-wrapper .diameter-tab[data-diameter = "'+currentMod+'"]').addClass('show');
        aDiam.first().addClass('active');
        var firstStat = aDiam.first().attr('data-status');
        var firstDiam = aDiam.first().attr('data-diameter');
        var on = $('.size-wrapper .size-tab[data-size = "'+firstDiam+'"][id2 = "'+firstStat+'"]').addClass('active');
        var loadOn = on.first().addClass('on');
        var dSFirstL = loadOn.attr('data-size');
        var iDtFirstL = loadOn.attr('id2');
        var iDthFirstL = loadOn.attr('id3');
        var firstProdTab = $('.products-wrapper .product-tab[data-product-name = "'+dSFirstL+'"][data-product-radius = "'+iDtFirstL+'"][data-product-type = "'+iDthFirstL+'"]').addClass('current');
        firstProdTab.next().addClass('show');

        for (var i = 0; i < aDiam.length; i++) {
            aDiam.on('click', function() {
                diameterTab.removeClass('active');
                $('.products-wrapper .product-tab').removeClass('current');
                $('.products-wrapper .product-link').removeClass('show');
                $(this).addClass('active');
                var aStat = $(this).attr('data-status');
                var aDiamStat = $(this).attr('data-diameter');
                sizeTab.removeClass('active');
                var c = $('.size-wrapper .size-tab[data-size = "'+aDiamStat+'"][id2 = "'+aStat+'"]').addClass('active');
                var o = c.first().addClass('on');
                var f = o.attr('data-size');
                var g = o.attr('id2');
                var h = o.attr('id3');
                var cc = $('.products-wrapper .product-tab[data-product-name = "'+f+'"][data-product-radius = "'+g+'"][data-product-type = "'+h+'"]').addClass('current');
                cc.next().addClass('show');

                c.on('click', function() {
                    sizeTab.removeClass('on');
                    $('.products-wrapper .product-tab').removeClass('current');
                    $('.products-wrapper .product-link').removeClass('show');
                    $(this).addClass('on');

                    var a = $(this).attr('data-size');
                    var b = $(this).attr('id2');
                    var d = $(this).attr('id3');
                    var dd = $('.products-wrapper .product-tab[data-product-name = "'+a+'"][data-product-radius = "'+b+'"][data-product-type = "'+d+'"]').addClass('current');
                    dd.next().addClass('show');
                });
            })
        };

        for (var j = 0; j < on.length; j++) {
            on.on('click', function() {
                sizeTab.removeClass('on');
                $('.products-wrapper .product-tab').removeClass('current');
                $('.products-wrapper .product-link').removeClass('show');
                $(this).addClass('on');

                var a = $(this).attr('data-size');
                var b = $(this).attr('id2');
                var d = $(this).attr('id3');
                var bb = $('.products-wrapper .product-tab[data-product-name = "'+a+'"][data-product-radius = "'+b+'"][data-product-type = "'+d+'"]').addClass('current');
                bb.next().addClass('show');
            })
        };

        modificationTab.on('click', function () {
            var currentModification = $(this).attr('data-modification');
            $('.modification-wrapper .modification-tab').removeClass('active');
            $(this).addClass('active');

            diameterTab.each(function() {
                var currentDiameter = $(this).attr('data-diameter');

                if (currentModification === currentDiameter) {
                    $('.diameter-wrapper .diameter-tab').removeClass('show').removeClass('active');
                    var modDiameter = $('.diameter-wrapper .diameter-tab[data-diameter = "'+currentModification+'"]').addClass('show');
                    var firstDiam = modDiameter.first().addClass('active');
                    var firstDiamDiam = firstDiam.attr('data-diameter');
                    var firstDiamStatus = firstDiam.attr('data-status');
                    $('.size-wrapper .size-tab').removeClass('active').removeClass('on');
                    var sizeTabeOn = $('.size-wrapper .size-tab[data-size = "'+firstDiamDiam+'"][id2 = "'+firstDiamStatus+'"]').addClass('active');

                    sizeTabeOn.on('click', function() {
                        sizeTab.removeClass('on');
                        $('.products-wrapper .product-tab').removeClass('current');
                        $('.products-wrapper .product-link').removeClass('show');
                        $(this).addClass('on');

                        var dSd = $(this).attr('data-size');
                        var iDtd = $(this).attr('id2');
                        var iDthd = $(this).attr('id3');
                        var iDthdtt = $('.products-wrapper .product-tab[data-product-name = "'+dSd+'"][data-product-radius = "'+iDtd+'"][data-product-type = "'+iDthd+'"]').addClass('current');
                        iDthdtt.next().addClass('show');

                    });

                    var firstSizeTabeOn = sizeTabeOn.first().addClass('on');
                    var dSFirst = firstSizeTabeOn.attr('data-size');
                    var iDtFirst = firstSizeTabeOn.attr('id2');
                    var iDthFirst = firstSizeTabeOn.attr('id3');
                    $('.products-wrapper .product-tab').removeClass('current');
                    $('.products-wrapper .product-link').removeClass('show');
                    var ddtt = $('.products-wrapper .product-tab[data-product-name = "'+dSFirst+'"][data-product-radius = "'+iDtFirst+'"][data-product-type = "'+iDthFirst+'"]').addClass('current');
                    ddtt.next().addClass('show');

                    modDiameter.on('click', function() {
                        $('.diameter-wrapper .diameter-tab').removeClass('active');
                        $(this).addClass('active');
                        var dia = $(this).attr('data-diameter');
                        var diaStatus = $(this).attr('data-status');

                        sizeTab.each(function() {
                            var t = $(this).attr('data-size');

                            if (dia === t) {
                                $('.size-wrapper .size-tab').removeClass('active').removeClass('on');
                                $('.products-wrapper .product-tab').removeClass('current');
                                $('.products-wrapper .product-link').removeClass('show');
                                var sizeTabDiamOn = $('.size-wrapper .size-tab[data-size = "'+t+'"][id2 = "'+diaStatus+'"]').addClass('active');
                                var y = sizeTabDiamOn.first().addClass('on');
                                var p = y.attr('data-size');
                                var k = y.attr('id2');
                                var r = y.attr('id3');
                                var rr = $('.products-wrapper .product-tab[data-product-name = "'+p+'"][data-product-radius = "'+k+'"][data-product-type = "'+r+'"]').addClass('current');
                                rr.next().addClass('show');

                                sizeTabDiamOn.on('click', function() {
                                    sizeTab.removeClass('on');
                                    $(this).addClass('on');
                                    $('.products-wrapper .product-tab').removeClass('current');
                                    $('.products-wrapper .product-link').removeClass('show');
                                    var dS = $(this).attr('data-size');
                                    var iDt = $(this).attr('id2');
                                    var iDth = $(this).attr('id3');
                                    var dss = $('.products-wrapper .product-tab[data-product-name = "'+dS+'"][data-product-radius = "'+iDt+'"][data-product-type = "'+iDth+'"]').addClass('current');
                                    dss.next().addClass('show');
                                })
                            }
                        })
                    })
                }
            });
        });

    });

})();

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/shinyFinder.js","/expressions")
},{"buffer":114,"r7L21G":116}],59:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function () {

    var $slider = $('.control-slider, .control-slider-small'),
        $inputMaxPrice = $('#sliderMaxPrice'),
        currentMaxPrice = parseInt($inputMaxPrice.val()),
        maxPrice = parseInt($inputMaxPrice.data('max-price'));

    $slider.slider({
        range: true,
        min: 100,
        max: maxPrice,
        values: [10, 100],
        slide: function (event, ui) {
            $inputMaxPrice.val(ui.values[1]);
        },
        change: function (event, ui) {
            var csrfToken = $('meta[name="csrf-token"]').attr('content');

            if (window.location.pathname.indexOf('/uk') > -1){
                $.post('/uk/category/update-price-route',
                    {'priceFrom': ui.values[0], 'priceTo': ui.values[1], '_csrf': csrfToken},

                    function (route) {
                        if (route) {
                            var params = route.split('?')[1].split('&').map(function (item) {
                                var items = item.split('=');
                                return {
                                    name: items[0],
                                    value: items[1]
                                };
                            });
                        }
                    });
            } else {
                $.post('/category/update-price-route',
                    {'priceFrom': ui.values[0], 'priceTo': ui.values[1], '_csrf': csrfToken},

                    function (route) {
                        if (route) {
                            var params = route.split('?')[1].split('&').map(function (item) {
                                var items = item.split('=');
                                return {
                                    name: items[0],
                                    value: items[1]
                                };
                            });
                        }
                    });
            }
        }
    });
})();
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/sliderControl.js","/expressions")
},{"buffer":114,"r7L21G":116}],60:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var toggleBrands = (function toggleBrands() {
    $(document).on('click', '.show_all', showAll);
    $(document).on('click', '.show_popular', showPopular);

    function showAll() {
        var $parent = $(this).closest('.accordion-content, .categories-content');
        $parent.find('.hide').addClass('show');
        $parent.find('.hide').removeClass('hide');
        $parent.find('.show_all').addClass('hide');
        $parent.find('.show_popular').removeClass('hide');
    }

    function showPopular() {
        var $parent = $(this).closest('.accordion-content, .categories-content');
        $parent.find('.show').addClass('hide');
        $parent.find('.show').removeClass('show');
        $parent.find('.show_popular').addClass('hide');
        $parent.find('.show_all').removeClass('hide');
    }
})();

module.exports = toggleBrands;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/toggleBrands.js","/expressions")
},{"buffer":114,"r7L21G":116}],61:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var loadBlock = require('../functions/loadBlock');
var disableScroll = window.handleScroll.disableScroll;
var enableScroll = window.handleScroll.enableScroll;

module.exports = (function togglePopups() {
    var $body = $('body');

    $body.on('click', '.popup_toggle', function () {
        window.scrollTo(0, 0);

        $('.jq-selectbox.control-dropdown').css('z-index', '0');

        var $this = $(this),
            $parent = $this.parent();

        showPopup();

        function showPopup() {
            disableScroll(window);
            loadBlock($parent.find('.popup'), $this.attr('data-popup'), function () {
                $this.parent().addClass('open').find('.popup').stop(true, true).slideDown(200);
                onloadCaptchaCallback();
                setInputmask();
                if ($this.closest('div.callback-form').find('input').val()) {
                    $('input#callbackform-phone').val($this.closest('div.callback-form').find('input').val());
                }
            });
        }
    });

    $body.on('click', '.popup-wrapper input.btn, .popup-sign-in input.btn', function (e) {
        var $spiner = $(this).closest('form').find('.spinner-loader');

        if ($spiner.length) {
            $(this).addClass('is-hidden');
            $spiner.removeClass('is-hidden');
        }
    });

    $body.on('click', '.close_popup', closePopup);
    $body.keydown(function (e) {
        if (e.keyCode == 27) {
            closePopup();
        }
    });
    function closePopup() {
        enableScroll(window);
        $('.open .popup').stop(true, true).slideUp(100, function () {
            $(this).html('').parent().removeClass('open').find('.popup_toggle').removeClass('open');
            $('.popup-wrapper').removeClass('is-flex');
        });

        $('body').removeClass('is-modal-open is-nonscrollable');
    }
})();

$(document).ready(function () {
    $("#google_translate_element").on("click", function() {
        $(".goog-te-menu-value span").toggleClass("ua-lang");
        $(".goog-te-menu-frame").contents().find(".goog-te-menu2").css("border", "none").css("height", "auto").css("width", "auto");
        $(".goog-te-menu-frame").contents().find(".goog-te-menu2-item-selected").hide();
        $(".goog-te-menu-frame").contents().find(".goog-te-menu2 table").css("display", "block");
        $(".goog-te-menu-frame").contents().find(".goog-te-menu2 table tbody").css("text-align", "center").css("display", "block");
        $(".goog-te-menu-frame").contents().find(".goog-te-menu2 table tbody tr").css("display", "block");
        $(".goog-te-menu-frame").contents().find(".goog-te-menu2 table tbody tr td").css("display", "block");
        $(".goog-te-menu-frame").contents().find(".goog-te-menu2-item").css("display", "block");
        $(".goog-te-menu-frame").css("bottom", "0").css("top", "50px");
    });
});
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/expressions/togglePopups.js","/expressions")
},{"../functions/loadBlock":75,"buffer":114,"r7L21G":116}],62:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// Entry point to the app

// Modules loading (begin)

// Plugins loading
require('./plugins/jquery.apibest.popup');
require('./plugins/jquery.bxslider.min');
require('./plugins/tooltip');

var facebookBtn = require('./functions/socials/facebookBtn');

$(document).ready(function () {
    slickUsefulArticles();
    slickArticleProducts();
    slickArticlePopular();
});

window.onload = function () {

    var $first = $.noConflict(true);

    // if there are no other jquery libraries
    if (($ === undefined) || ($().jquery !== jQuery().jquery)) {
        $ = $first;
    }

    jQuery = $;

    facebookBtn();
};

// The following plugin doesn't support CommonJS module system.
// It has been loaded as Asset (see @frontend/assets/JqueryPluginsAsset.php)
//require('./plugins/formstyler.min');


// Expressions (begin)
// General modules

// Define global variables because of inline invocation in HTML

window.handleScroll = require('./functions/handleScroll');
window.addToCart = require('./functions/addToCart');
window.productClick = require('./functions/productClick');
window.showProduct = require('./functions/showProduct');
window.onloadCaptchaCallback = require('./functions/onloadCaptchaCallback');
window.editStep = require('./functions/editStep');
window.goToProduct = require('./functions/goToProduct');

window.urlQueryParams = window
    .location
    .search
    .replace('?','')
    .split('&')
    .reduce(
        function(p,e){
            var a = e.split('=');
            p[ decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
            return p;
        },
        {}
    );

require('./functions/glideNavigation')();                   // Invoke because it is function but not expression
require('./expressions/menuBehavior');
require('./expressions/mobileSearch');
require('./expressions/promoCodes');
require('./expressions/autocomplete');
require('./expressions/productPage');
require('./expressions/profilePage');
require('./expressions/modelPage');
require('./expressions/mainPage');
require('./expressions/categoryPage');
require('./expressions/calcPage');
require('./expressions/sliderControl');
require('./expressions/checkout');
require('./expressions/paymentMassage');
require('./expressions/quickBuy');
require('./expressions/cars');
require('./expressions/liqpay');
require('./expressions/otp');
require('./expressions/rezinaMobile');
require('./expressions/shinyFinder');


// Popups
require('./expressions/popups/main');

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/fake_1822e7da.js","/")
},{"./expressions/autocomplete":9,"./expressions/calcPage":11,"./expressions/cars":12,"./expressions/categoryPage":14,"./expressions/checkout":16,"./expressions/liqpay":23,"./expressions/mainPage":25,"./expressions/menuBehavior":27,"./expressions/mobileSearch":28,"./expressions/modelPage":29,"./expressions/otp":30,"./expressions/paymentMassage":31,"./expressions/popups/main":41,"./expressions/productPage":49,"./expressions/profilePage":50,"./expressions/promoCodes":51,"./expressions/quickBuy":52,"./expressions/rezinaMobile":56,"./expressions/shinyFinder":58,"./expressions/sliderControl":59,"./functions/addToCart":63,"./functions/editStep":66,"./functions/glideNavigation":68,"./functions/goToProduct":69,"./functions/handleScroll":70,"./functions/onloadCaptchaCallback":77,"./functions/productClick":78,"./functions/showProduct":83,"./functions/socials/facebookBtn":91,"./plugins/jquery.apibest.popup":110,"./plugins/jquery.bxslider.min":111,"./plugins/tooltip":112,"buffer":114,"r7L21G":116}],63:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var updateCartBlock = require('./updateCartBlock');

var addToCart = function(element) {
    var $a = $(element);
    var data = $a.data('ga');
    var get = {'id': $a.data('product-id')};

    if ($a.data('sets') !== undefined) {
        get.sets = $a.data('sets');
        get.set = $a.data('set-id');
    }

    if (window.location.pathname.indexOf('/uk') > -1) {
        var cartLinkAdd = '/uk/cart/add';
    } else {
        var cartLinkAdd = '/cart/add';
    }
    
    $.get(cartLinkAdd, get, function () {
        var showCart = function () {
            var slide;
            updateCartBlock();
            $('.cart-wrapper').eq(1).addClass('is-flex');

            slide = function () {
                var $popup = $('.popup-cart').eq(1);
                $popup.addClass('is-visible');
                $popup.removeClass('is-hidden');
            };

            setTimeout(slide, 100);
        };

        if (typeof dataLayer !== 'undefined' && typeof data !== 'undefined') {

            $(document).toggle(dataLayer.push(data), showCart());

        } else {
            showCart();
        }
    });
};

module.exports = addToCart;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/addToCart.js","/functions")
},{"./updateCartBlock":98,"buffer":114,"r7L21G":116}],64:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){

var allowDeliveryRequest = function allowDeliveryRequest() {
    return $('#totalsBlock').is(':hidden');
};

module.exports = allowDeliveryRequest;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/allowDeliveryRequest.js","/functions")
},{"buffer":114,"r7L21G":116}],65:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = function changeListItem(fromClass, toClass, listFrom, listTo) {

    var $this = $(this);
    $this.closest('.giving-out')
        .find('.l-goods .' + listFrom)
        .addClass(listTo)
        .removeClass(listFrom)
        .find('> li')
        .addClass(toClass)
        .removeClass(fromClass);

    $( ".advice-articles" ).insertAfter( $(".tile-item:nth-child(8)") );

};
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/changeListItem.js","/functions")
},{"buffer":114,"r7L21G":116}],66:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// Loading dependencies
var toggleTotals = require('./toggleTotals');

editStep = function editStep(element) {
    var $a = $(element),
        $parent = $a.parents('.step');
        $form = $a.closest('#checkout_form');

    $form.removeClass('table-second');

    $.when($parent.find('.step-content').slideDown(250, function () {
        $parent.removeClass('checked').addClass('active');
        $parent.next('.step').find('.step-content').slideUp(250, function () {
            $parent.next('.step').removeClass('active');
        });
    })).done(toggleTotals(false));
};

module.exports = editStep;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/editStep.js","/functions")
},{"./toggleTotals":94,"buffer":114,"r7L21G":116}],67:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var extend =  function(Parent, Child){
    var F = function(){};
    F.prototype = Parent.prototype;
    Child.prototype = new F();
    Child.prototype.constructor = Child;
    Child.prototype.superclass = Parent.prototype;
};

 module.exports = extend;

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/extend.js","/functions")
},{"buffer":114,"r7L21G":116}],68:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var glideNavigation = function () {
    $('a[href*="#"]:not([href="#"])').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                var $el = $('html,body');

                // Stop all animations
                $el.stop(true);

                // Add new one to the fx queue
                $('html,body').animate({
                    scrollTop: target.offset().top - 100         // Higher to make all anchored content visible
                }, 1000);
                return false;
            }
        }
    });
};

module.exports = glideNavigation;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/glideNavigation.js","/functions")
},{"buffer":114,"r7L21G":116}],69:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = function (url) {
    var adr = $(url).data('id');
    window.location.href = adr;
};
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/goToProduct.js","/functions")
},{"buffer":114,"r7L21G":116}],70:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var handleScroll = {};

handleScroll.preventHandler = function (e) {
    e.preventDefault();
};


handleScroll.enableScroll = function enableScroll(element) {
    if (element.removeEventListener)
        element.removeEventListener('DOMMouseScroll', handleScroll.preventHandler, false);
    element.onmousewheel = document.onmousewheel = null;
    element.onwheel = null;
    element.ontouchmove = null;
};


handleScroll.disableScroll =  function disableScroll(element) {
    if (element.addEventListener) // older FF
        element.addEventListener('DOMMouseScroll', handleScroll.preventHandler, false);
    element.onwheel = handleScroll.preventHandler; // modern standard
    element.onmousewheel = document.onmousewheel = handleScroll.preventHandler; // older browsers, IE
    element.ontouchmove  = handleScroll.preventHandler; // mobile
};

module.exports = handleScroll;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/handleScroll.js","/functions")
},{"buffer":114,"r7L21G":116}],71:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// Hide block buy together, if there is no items for displaying
hideBuyTogether = function() {
    var arrTogetherLength = $(document).find('.product-special-offer .special-offer-wrapper li').length;
    arrTogetherLength = parseInt(arrTogetherLength);
    if (arrTogetherLength < 1) {
        $(document).find('.product-special-offer').hide();
    }
};
module.exports = hideBuyTogether;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/hideBuyTogether.js","/functions")
},{"buffer":114,"r7L21G":116}],72:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var hideMenu = function () {
    var firstLevelItems = $('.menu > .item');
    var secondLevelItems = $('.menu-second > .item');

    // Make all items of the second level inactive
    secondLevelItems.removeClass('is-expanded').addClass('is-collapsed');

    // Make all items of the first level inactive
    firstLevelItems.removeClass('is-expanded').addClass('is-collapsed');
};

module.exports = hideMenu;

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/hideMenu.js","/functions")
},{"buffer":114,"r7L21G":116}],73:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var initPriceSlider = function initPriceSlider() {

    var $slider = $('#slider'),
        $inputMinPrice = $('#sliderMinPrice'),
        $inputMaxPrice = $('#sliderMaxPrice'),
        currentMinPrice = parseInt($inputMinPrice.val()),
        currentMaxPrice = parseInt($inputMaxPrice.val()),
        minPrice = parseInt($inputMinPrice.data('min-price')),
        maxPrice = parseInt($inputMaxPrice.data('max-price'));

    $slider.slider({
        range: true,
        min: minPrice,
        max: maxPrice,
        values: [currentMinPrice, currentMaxPrice],
        slide: function (event, ui) {
            $inputMinPrice.val(ui.values[0]);
            $inputMaxPrice.val(ui.values[1]);
        },
        change: function (event, ui) {
            var csrfToken = $('meta[name="csrf-token"]').attr('content');

            if (window.location.pathname.indexOf('/uk') > -1){
                $.post('/uk/category/update-price-route',
                    {'priceFrom': ui.values[0], 'priceTo': ui.values[1], '_csrf': csrfToken},
                    function (route) {
                        var route = route;
                        var validatedUrl = route.replace(/\s/g, "%20"); // in the URL spaces are replaced by %20

                        loadUrl(validatedUrl);
                    }
                );
            } else {
                $.post('/category/update-price-route',
                    {'priceFrom': ui.values[0], 'priceTo': ui.values[1], '_csrf': csrfToken},
                    function (route) {
                        var route = route;
                        var validatedUrl = route.replace(/\s/g, "%20"); // in the URL spaces are replaced by %20

                        loadUrl(validatedUrl);
                    }
                );
            }

            function loadUrl(validatedUrl) {

                $('.filter').load(validatedUrl + " .filter-group", function() {
                    var filterPosition = $('.filter').offset().top;
                    var windowPosition = $(window).scrollTop();
                    var t = $('.accordion.filters').height();
                    var builderHeight = $('.l-tires-wheels-builder').height() === null ? 0 : $('.l-tires-wheels-builder').height();
                    var lBanner = $('.l-banner').height();

                    if (builderHeight > 1 && $(window).width() > 600) {
                        windowPosition = windowPosition - builderHeight;
                        filterPosition = filterPosition - builderHeight;
                    }

                    if (lBanner > 1 && $(window).width() > 600) {
                        windowPosition = windowPosition - lBanner;
                        filterPosition = filterPosition - lBanner;
                    }

                    if (window.location.pathname.indexOf('/uk') > -1){
                        $('.filter').append('<a class="filter-link" href="'+validatedUrl+'">Підібрати</a>');
                    }else {
                        $('.filter').append('<a class="filter-link" href="'+validatedUrl+'">Подобрать</a>');
                    }

                    if (filterPosition <= windowPosition) {
                        $('.filter-link').css('top', windowPosition + 'px');
                    } else if (filterPosition >= windowPosition) {
                        $('.filter-link').css('top', filterPosition - 150 + 'px');
                    }

                    if (filterPosition <= windowPosition && $(window).width() < 600) {
                        $('.filter-link').css('top', windowPosition + 200 + 'px');
                    } else if (filterPosition >= windowPosition && $(window).width() < 600) {
                        $('.filter-link').css('top', filterPosition + t + 'px');
                    }

                    if (filterPosition <= windowPosition && $(window).height() < 500) {
                        $('.filter-link').css('top', windowPosition + builderHeight + t + 'px');
                    } else if (filterPosition >= windowPosition && $(window).height() < 500) {
                        $('.filter-link').css('top', filterPosition + builderHeight + t + 'px');
                    }

                    scrollButton();

                    initPriceSlider();
                });
            }

            function scrollButton() {
                $(window).scroll(function () {
                    var filterPosition = $('.filter').offset().top;
                    var windowPosition = $(window).scrollTop();
                    var filterHeight = $('.filter').height();
                    var builderHeight = $('.l-tires-wheels-builder').height() === null ? 0 : $('.l-tires-wheels-builder').height();
                    var t = $('.accordion.filters').height();
                    var lBanner = $('.l-banner').height();

                    if (builderHeight > 1) {
                        windowPosition = windowPosition - builderHeight;
                        filterPosition = filterPosition - builderHeight;
                    }

                    if (lBanner > 1) {
                        windowPosition = windowPosition - lBanner;
                        filterPosition = filterPosition - lBanner;
                    }

                    var outArea = (filterPosition + filterHeight) - 200;


                    if (filterPosition <= windowPosition) {
                        $('.filter-link').css('top', windowPosition + 'px');
                    } else if (filterPosition >= windowPosition) {
                        $('.filter-link').css('top', filterPosition - 150 + 'px');
                    }

                    if (filterPosition <= windowPosition && $(window).width() < 600) {
                        $('.filter-link').css('top', windowPosition + builderHeight + 200 + 'px');
                    } else if (filterPosition >= windowPosition && $(window).width() < 600) {
                        $('.filter-link').css('top', filterPosition + t + builderHeight + 'px');
                    }

                    if (filterPosition <= windowPosition && $(window).height() < 500) {
                        $('.filter-link').css('top', windowPosition + builderHeight + t + 'px');
                    } else if (filterPosition >= windowPosition && $(window).height() < 500) {
                        $('.filter-link').css('top', filterPosition + builderHeight + t + 'px');
                    }

                    if (windowPosition >= outArea) {
                        $('.filter-link').css('top', filterPosition + 'px');
                    }

                });
            }
                    // if (route) {
                    //     var params = route.split('?')[1].split('&').map(function (item) {
                    //         var items = item.split('=');
                    //         if (items[0] !== 'page') {
                    //             return {
                    //                 name: items[0],
                    //                 value: items[1]
                    //             };
                    //         }
                    //     }).filter(function (item) {                     // Drop undefined elements
                    //         return item;
                    //     });
                    //
                    //     // Set to location sorted sequence of parameters
                    //     // window.location.search = decodeURIComponent($.param(params.sort(function (a, b) {
                    //     //     var prev = a.name;
                    //     //     var curr = b.name;
                    //     //     if (prev < curr) {
                    //     //         return -1;
                    //     //     } else if (prev > curr) {
                    //     //         return 1;
                    //     //     } else {
                    //     //         return 0;
                    //     //     }
                    //     // })));
                    // }

        }
    });

};

module.exports = initPriceSlider;

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/initPriceSlider.js","/functions")
},{"buffer":114,"r7L21G":116}],74:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var toggleRadio = require('./toggleRadio');

var initRadio = function initRadio()
{
    $('.radio').each(toggleRadio);
};

module.exports = initRadio;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/initRadio.js","/functions")
},{"./toggleRadio":93,"buffer":114,"r7L21G":116}],75:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){

var loadBlock = function loadBlock(wrapper, path, callback) {
    callback = callback || 0;
    $(wrapper).load(path, callback);
};

module.exports = loadBlock;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/loadBlock.js","/functions")
},{"buffer":114,"r7L21G":116}],76:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var enableScroll = window.handleScroll.enableScroll;

var onClickPopupWrapper = function () {
    var context = $(this);
    var cartPopup = $('.popup-cart', context);
    cartPopup.addClass('is-hidden');
    cartPopup.removeClass('is-visible');

    var hideWrapper = function () {
        enableScroll(window);
        context.removeClass('is-flex');
        $('body').removeClass('is-nonscrollable is-modal-open');
    };

    setTimeout(hideWrapper, 100);
};

module.exports = onClickPopupWrapper;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/onClickPopupWrapper.js","/functions")
},{"buffer":114,"r7L21G":116}],77:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var onloadCaptchaCallback = function() {
    $(document).find('.captcha-render').each(function () {
        try {
            grecaptcha.render(this, {
                'sitekey': $(this).data('key')
            });
        } catch (e) {}
    });
};

module.exports = onloadCaptchaCallback;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/onloadCaptchaCallback.js","/functions")
},{"buffer":114,"r7L21G":116}],78:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var productClick = function productClick(element) {
    var $a = $(element);

    if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
            'event': 'productClick',
            'ecommerce': {
                'click': {
                    'actionField': {'list': $a.data('ga').list, action: 'click'},      // Optional list property.
                    'products': [{
                        'name': $a.data('ga').name,                      // Name or ID is required.
                        'id': $a.data('ga').id,
                        'price': $a.data('ga').price,
                        'brand': $a.data('ga').brand,
                        'category': $a.data('ga').category
                    }]
                }
            }
        });
    }
};

module.exports = productClick;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/productClick.js","/functions")
},{"buffer":114,"r7L21G":116}],79:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var updateCartBlock = require('./updateCartBlock');

var removeProduct = (function () {
    $(document).on('click', '.popup-cart .remove-product', function () {
        var $a = $(this),
            data = {};

        if ($a.data('product-id') !== undefined) {
            data.id = $a.data('product-id');
        } else {
            data.key = $a.data('key');
            data.set = $a.data('set-id');
        }

        if (window.location.pathname.indexOf('/uk') > -1) {
            $.get('/uk/cart/remove-product-in-small-cart', data, function () {
                $a.closest('li.item').remove();
                updateCartBlock();
            });
        } else {
            $.get('/cart/remove-product-in-small-cart', data, function () {
                $a.closest('li.item').remove();
                updateCartBlock();
            });
        }
    });
})();

module.exports = removeProduct;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/removeProduct.js","/functions")
},{"./updateCartBlock":98,"buffer":114,"r7L21G":116}],80:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var setViewType = function setViewType(type) {

    // Define the page where request will be made
    var method,
        $el = $('.l-goods > .container > ul');

    if (location.pathname === '/search' 
        || location.pathname === '/selection' 
        || location.pathname === '/builder') {
        
        method = '/search/update-product-list';
    } else {
        method = '/category/update-product-list';
    }

    if ($el.length == 0) {
        $el = $('.l-goods > ul');
    }
    
    var params = decodeURIComponent(location.search.substr(1)).split('&');
    var query = [];
    
    params.forEach(function (item) {
        var p = item.split('=');
        query[p[0]] = p[1]; 
    });

    var page_to = Number($('.settings .pages .active').last().find('a').attr('data-page')) + 1 || 1;

    $.get(window.location.href, {
        "view_type": type,
        "page_to": page_to,
        "view": 'partial'
    }, function (response) {
        $el.html(response);
        localStorage.setItem('view', type + '_view');
        $('.display-list > li > div').toggleClass('is-active inactive');
    });
};

module.exports = setViewType;

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/setViewType.js","/functions")
},{"buffer":114,"r7L21G":116}],81:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = function showFilter() {
    var updateSizeOfFilter = require('./updateSizeOfFilter');

    var overlay = $('.overlay');

    updateSizeOfFilter();

    overlay.removeClass('is-hidden');
    overlay.addClass('is-visible');
};

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/showFilter.js","/functions")
},{"./updateSizeOfFilter":101,"buffer":114,"r7L21G":116}],82:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = function ($el) {
    $el.addClass('is-hidden');
    $el.closest('form').find('.spinner-loader').removeClass('is-hidden');
};
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/showLoader.js","/functions")
},{"buffer":114,"r7L21G":116}],83:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var updateModel = require('./updateModel');
var productClick = require('./productClick');

module.exports = function(element) {
    var $el = $($(element).closest('.row')[0]);

    updateModel($el.data('id'), $el);
    productClick($el);
};
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/showProduct.js","/functions")
},{"./productClick":78,"./updateModel":100,"buffer":114,"r7L21G":116}],84:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
slickArticlePopular = function slickArticlePopular() {
    $(document).find('.popular-articles-slider .goods-list').not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true
                }
            }]
    });
};

module.exports = slickArticlePopular;

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/slick/slickArticlePopular.js","/functions/slick")
},{"buffer":114,"r7L21G":116}],85:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
slickArticleProducts = function slickArticleProducts() {
    $(document).find('.goods-articles-slider .goods-list').not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true
                }
            }]
    });
};

module.exports = slickArticleProducts;

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/slick/slickArticleProducts.js","/functions/slick")
},{"buffer":114,"r7L21G":116}],86:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){

slickOffer = function slickOffer() {
        $(document).find('.offer-item .goods-list').not('.slick-initialized').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            vertical: true
        });
};

module.exports = slickOffer;

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/slick/slickOffer.js","/functions/slick")
},{"buffer":114,"r7L21G":116}],87:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
slickPhoto = function slickPhoto() {
    $(document).find('.product-slider.tyre .list').not('.slick-initialized').slick({
        infinite: false,
        slidesToShow: 3,
        vertical: false,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1181,
                settings: {
                    vertical: false,
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1050,
                settings: {
                    vertical: false,
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    vertical: false,
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 691,
                settings: {
                    vertical: false,
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 400,
                settings: {
                    vertical: false,
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $(document).find('.product-slider .list').not('.slick-initialized').slick({
        infinite: false,
        slidesToShow: 4,
        vertical: true,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1181,
                settings: {
                    vertical: false,
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1050,
                settings: {
                    vertical: false,
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    vertical: false,
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 691,
                settings: {
                    vertical: false,
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 400,
                settings: {
                    vertical: false,
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });
};


module.exports = slickPhoto;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/slick/slickPhoto.js","/functions/slick")
},{"buffer":114,"r7L21G":116}],88:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
slickProductList = function slickProductList() {
    $(document).find('.l-products-list.tyre .goods-list').not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: true,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true

                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true

                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true
                }
            }]
    });

    $(document).find('.l-products-list .goods-list').not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true

                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true
                }
            }]
    });
};


module.exports = slickProductList;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/slick/slickProductList.js","/functions/slick")
},{"buffer":114,"r7L21G":116}],89:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var slickSaleSets = function slickSaleSets() {
    $(document).find('.product-special-offer .special-offer-wrapper').not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1
    });
};

module.exports = slickSaleSets;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/slick/slickSaleSets.js","/functions/slick")
},{"buffer":114,"r7L21G":116}],90:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
slickUsefulArticles = function slickUsefulArticles() {
    $(document).find('.useful-articles .goods-list').not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true

                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true

                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true
                }
            }]
    });
};

module.exports = slickUsefulArticles;

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/slick/slickUsefulArticles.js","/functions/slick")
},{"buffer":114,"r7L21G":116}],91:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var facebookBtn = function facebookBtn() {
    setTimeout(function () {
        var d = document, js, fjs = d.getElementsByTagName('script')[0];
        if (d.getElementById('facebook-jssdk')) return;
        js = d.createElement('script');
        js.id = 'facebook-jssdk';
        js.src = "//connect.facebook.net/ru_RU/sdk.js#xfbml=1&version=v2.5";
        fjs.parentNode.insertBefore(js, fjs);
    }, 300);

};

module.exports = facebookBtn;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/socials/facebookBtn.js","/functions/socials")
},{"buffer":114,"r7L21G":116}],92:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var twitterBtn = function twitterBtn() {
    setTimeout(function () {
        var d = document, js, fjs = d.getElementsByTagName('script')[0];
        if (d.getElementById('twitter-wjs')) return;
        js = d.createElement('script');
        js.id = 'twitter-wjs';
        js.src = "//platform.twitter.com/widgets.js";
        fjs.parentNode.insertBefore(js, fjs);
    }, 300);
};

module.exports = twitterBtn;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/socials/twitterBtn.js","/functions/socials")
},{"buffer":114,"r7L21G":116}],93:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var toggleRadio = function toggleRadio() {
    if ($(this).is(':checked')) {
        $(this).parent().addClass('active').parent().siblings().find('label').removeClass('active');
    } else {
        $(this).parent().removeClass('active');
    }
};

module.exports = toggleRadio;

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/toggleRadio.js","/functions")
},{"buffer":114,"r7L21G":116}],94:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var toggleTotals = function toggleTotals(isOpen) {

    var $totals = $('#totalsBlock');

    isOpen = isOpen || true;
    
    if (isOpen && $totals.is(':hidden')) {
        $totals.removeClass('hidden').slideDown(500);

    } else {
        $totals.addClass('hidden').slideUp(500);
    }
};

module.exports = toggleTotals;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/toggleTotals.js","/functions")
},{"buffer":114,"r7L21G":116}],95:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){

module.exports = {
    show: show,
    hide: hide
};

var overlay = $('#totalsBlock .overlay');

function show() {
    var height = $('#totals').height(),
        width = $('#totals').width();

    if (height != 0 && width != 0) {
        overlay.css({
            width: width,
            height: height
        });

        overlay.removeClass('is-hidden');
    }
}

function hide() {
    overlay.addClass('is-hidden');
}
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/totalsOverlay.js","/functions")
},{"buffer":114,"r7L21G":116}],96:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
cityTypehead = function cityTypehead() {
    var $elements = $('.city-load-field');

    if (window.location.pathname.indexOf('/uk') > -1) {
        var cartLinkUpdate = '/uk/cart/get-cities?query=%QUERY&limit=';
    } else {
        var cartLinkUpdate = 'cart/get-cities?query=%QUERY&limit=';
    }

    var suggestionsLimit = 10,
        cartCity = new Bloodhound({
            limit: suggestionsLimit,
            identify: function (obj) {
                return obj.id;
            },
            remote: {
                url: cartLinkUpdate + suggestionsLimit,
                wildcard: '%QUERY'
            },
            datumTokenizer: function (d) {
                return Bloodhound.tokenizers.whitespace(d.val);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace
        });

    $elements.typeahead({
        highlight: true
    }, {
        name: 'products',
        limit: suggestionsLimit,
        source: cartCity.ttAdapter(),
        templates: {
            suggestion: function (data) {
                return ' <div class="city-item">' +
                    '<a class="city" href="javascript: void(0);" data-id="' + data.id + '" data-name="' + data.name + '">' +
                    '<span class="name">' + data.name + '</span>' +
                    '</a>' +
                    ' </div>';
            }
        }
    });
};

module.exports = cityTypehead;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/typehead/city.js","/functions/typehead")
},{"buffer":114,"r7L21G":116}],97:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
searchTypehead = function searchTypehead() {
    var queryLength = 3,
        suggestionsLimit = 5;

    if (window.location.pathname.indexOf('uk') > -1) {
        var engineUkr = new Bloodhound({
            limit: suggestionsLimit,
            identify: function (obj) {
                return obj.id;
            },
            remote: {
                url: '/uk/search/products?query=%QUERY&length=' + queryLength + '&limit=' + suggestionsLimit,
                wildcard: '%QUERY'
            },
            datumTokenizer: function (d) {
                return Bloodhound.tokenizers.whitespace(d.val);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace
        });
        engineUkr.initialize();

        $('.search-control input').typeahead({
            minLength:  queryLength,
            highlight: true
        }, {
            name: 'products',
            display: function (item) { item.name + ' ' + item.mode; },
            source: engineUkr.ttAdapter(),
            templates: {
                suggestion: function (data) {
                    name = data.name;

                    var cl = data.class ? data.class : '',
                        str = '<div id="column-content" class="tt-menu-item ' + cl + '">' +
                            '<a class="product" href="' + data.route + '">';

                    if (data.image) {
                        str += '<img src="' + data.image + '" alt="img">';
                    }

                    str += '<span class="name">' + name + '</span>';

                    if (data.price) {
                        str += '<div class="price">' + data.price + '<span class="small">' + data.currency + '</span></div>';
                    }

                    str += '</a></div>';

                    return str;
                },
                footer: '<input class="view_all_results" type="submit" value="всі результати пошуку">'
            }
        });

    } else {
        var engine = new Bloodhound({
            limit: suggestionsLimit,
            identify: function (obj) {
                return obj.id;
            },
            remote: {
                url: '/search/products?query=%QUERY&length=' + queryLength + '&limit=' + suggestionsLimit,
                wildcard: '%QUERY'
            },
            datumTokenizer: function (d) {
                return Bloodhound.tokenizers.whitespace(d.val);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace
        });
        engine.initialize();

        $('.search-control input').typeahead({
            minLength:  queryLength,
            highlight: true
        }, {
            name: 'products',
            display: function (item) { item.name + ' ' + item.mode; },
            source: engine.ttAdapter(),
            templates: {
                suggestion: function (data) {
                    name = data.name;

                    var cl = data.class ? data.class : '',
                        str = '<div id="column-content" class="tt-menu-item ' + cl + '">' +
                            '<a class="product" href="' + data.route + '">';

                    if (data.image) {
                        str += '<img src="' + data.image + '" alt="img">';
                    }

                    str += '<span class="name">' + name + '</span>';

                    if (data.price) {
                        str += '<div class="price">' + data.price + '<span class="small">' + data.currency + '</span></div>';
                    }

                    str += '</a></div>';

                    return str;
                },
                footer: '<input class="view_all_results" type="submit" value="все результаты поиска">'
            }
        });
    }
};

module.exports = searchTypehead;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/typehead/search.js","/functions/typehead")
},{"buffer":114,"r7L21G":116}],98:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = function updateCartBlock() {

    if (window.location.pathname.indexOf('/uk') > -1) {
        $.get('/uk/cart/update-cart-block', function (response) {
            cart.updateProperties(JSON.parse(response));
            cart.emit('change');
        });
    } else {
        $.get('/cart/update-cart-block', function (response) {
            cart.updateProperties(JSON.parse(response));
            cart.emit('change');
        });
    }
};
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/updateCartBlock.js","/functions")
},{"buffer":114,"r7L21G":116}],99:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = function updateIsLegal() {
    var $a = $(this).find('a'),
        $containerLink = $(this),
        $form = $(this).closest('form'),
        $toggleField = $form.find('#companyName'),
        $fieldBlock = $toggleField.closest('.form-group'),
        $containerField = $toggleField.closest('div'),
        $isLegalField = $form.find('#isLegal'),
        isLegal = $a.data('is-legal');

    $isLegalField.val(isLegal);

    if (isLegal) {
        $containerField.removeClass('is-hidden');
        $toggleField.addClass('required_company');
        $containerLink.prev().removeClass('active');

    } else {
        $containerField.addClass('is-hidden');
        $toggleField.removeClass('required_company');
        $containerLink.next().removeClass('active');
        $fieldBlock.removeClass('has-error');
    }

    $containerLink.addClass('active');
};
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/updateIsLegal.js","/functions")
},{"buffer":114,"r7L21G":116}],100:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var slickPhoto = require('./slick/slickPhoto');
var slickProductList = require('./slick/slickProductList');
var slickOffer = require('./slick/slickOffer');
var slickSaleSets = require('../functions/slick/slickSaleSets');
var facebookBtn = require('./socials/facebookBtn');
var twitterBtn = require('./socials/twitterBtn');
var Slider = require('../models/Slider');

module.exports = function updateModel($id, $el) {
    if ($el.length) {
        var data = $el.data(),
            options = [];

        delete data.ga;
        delete data.id;

        for (var key in data) {
            var $option = $('#tab-buttons ul[data-param="' + key + '"] a[data-name="' + data[key] + '"]');

            if (!$option.hasClass('active')) {
                options[options.length] = $option;
            }
        }

        for (var i = 0; i < options.length; i++) {
            if (i + 1 == options.length) {
                $option.click()
            } else {
                if ($option.find('img').length) {
                    $option.addClass('btn-dark').removeClass('btn')
                }

                $option.addClass('active')
            }
        }

        $el.closest('#tab-contents').find('.row.active').removeClass('active');
        $el.addClass('active');
    }

    $.get('product/show-product',
        {
            action: 'product',
            id: $id,
            model: window.location.pathname
        },

        function (json) {
            var $product = $(document).find('.l-product');
            var $info = $(document).find('.l-info-product');
            var $title = $(document).find('title');
            var $description = $(document).find('meta[name="description"]');
            var $keywords = $(document).find('meta[name="keywords"]');
            var $retargeting = $(document).find('#retargeting');

            console.log("3");

            if (!$info.length) {
                $info = $(document).find('.l-info');
            } else {
                $(document).find('.l-info').remove();
            }

            if (json.redirect != undefined) {
                window.location = json.redirect;
            }

            $product.fadeOut(300, function () {
                $product.replaceWith(json.product);
                slickPhoto();

                $info.replaceWith(json.info);
                hideBuyTogether();
                slickOffer();
                slickSaleSets();

                var productPhotoSlider = new Slider({
                    $prevSlide: $(document).find('.l-product .slider-controls .slider-prev'),
                    $nextSlide: $(document).find('.l-product .slider-controls .slider-next'),
                    $slides: $(document).find('.l-product .product-photos')
                });

                $title.html(json.title);
                $('#another-parameters h2').html(json.productsModelTitle);
                $description.attr('content', json.description);
                $keywords.attr('content', json.keywords);
                $retargeting.html(json.retargeting);
                $('.l-callback').css('display', 'none');
                $('.l-giving-out-seo').css('display', 'none');

                if (!json.showModelBlock) {
                    $('#products-model').css('display', 'none');
                }

                $product.fadeIn(300, function () {
                    facebookBtn();
                    twitterBtn();
                });

            });

            if (typeof GDR_ENABLE != 'undefined' && typeof window.google_trackConversion === "function") {
                window.google_trackConversion({
                    google_conversion_id: GDR_CONVERSION_ID,
                    google_custom_params: window.google_tag_params,
                    google_remarketing_only: true
                });
            }

            $(".tab_item").not(":first").hide();
        }
    );


    // $.get('product/show-product',
    //     {
    //         action: 'similar',
    //         id: $id,
    //         model: window.location.pathname
    //     },
    //     function (json) {
    //         var $similar = $(document).find('#similar');
    //
    //         pasteContent($similar, json.similar);
    //     }
    // );

    // function pasteContent($el, response) {
    //         $el.fadeOut(300, function () {
    //             $.when($el.replaceWith(response)).then(slickProductList());
    //         });
    //     $el.fadeIn(300);
    // }

    if  ($(window).scrollTop() > 500) {
        $('html, body').animate({
            scrollTop: 0
        }, {
            duration: 500
        });
    }

};
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/updateModel.js","/functions")
},{"../functions/slick/slickSaleSets":89,"../models/Slider":108,"./slick/slickOffer":86,"./slick/slickPhoto":87,"./slick/slickProductList":88,"./socials/facebookBtn":91,"./socials/twitterBtn":92,"buffer":114,"r7L21G":116}],101:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = function updateSizeOfFilter() {

    var height = $('.filter').height();
    var width = $('.filter').width();

    var overlay = $('.overlay');
    overlay.css({
        width: width,
        height: height
    });
};

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/updateSizeOfFilter.js","/functions")
},{"buffer":114,"r7L21G":116}],102:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var cityTypehead = require('./typehead/city');
var updateTotals = require('./updateTotals');

var updateStep2 = function updateStep2($el, updateTotal) {
    var pickupCity = $('input[name=\'OrderForm[cityId]\']').val(),
        $form = $el.closest('form'),
        overlay = $('#delivery .overlay'),
        height = $('#delivery').height(),
        width = $('#delivery').width(),
        deliveryMethod = $('#deliveryMethod input[type=\'radio\']:checked').val(),
        paymentMethod = $('#paymentMethod input[type=\'radio\']:checked').val();


    updateTotal = updateTotal || false;

    overlay.css({
        width: width,
        height: height
    });
    overlay.toggleClass('is-hidden');

        if (window.location.pathname.indexOf('/uk') > -1) {
            var cartLinkUpdate = '/uk/cart/delivery';
        } else {
            var cartLinkUpdate = 'cart/delivery';
        }

        return $.post(cartLinkUpdate, $form.serialize(), function (response) {
            $('#deliveryBlock').replaceWith(response);

            $('.control-dropdown').styler({
                selectSearch: false,
                selectSmartPositioning: false
            });

            if (pickupCity != 20772 && pickupCity != 34241 && pickupCity != 14133 && pickupCity != 24334 && pickupCity != 21304) {
                $(document).find('[id="5_topickup"]').hide();
            } else {
                $(document).find('[id="5_topickup"]').show();
            }


            if (paymentMethod == 9) {
                $('#checkout_form').find('#orderform-panend').closest('.form-group').css('display', 'inline-block');
            } else {
                $('#checkout_form').find('#orderform-panend').closest('.form-group').hide();
            }

            if (deliveryMethod == 5) {
                // $(document).find('[id="3_paymenthide"]').hide();
                $(document).find('[id="nocalling"]').hide();
            } else {
                // $(document).find('[id="3_paymenthide"]').show();
                $(document).find('[id="nocalling"]').show();
            }

            cityTypehead();

            overlay.toggleClass('is-hidden');

            if (updateTotal) {
                updateTotals()
            }

            $(document).find('[data-toggle="tooltip"]').tooltip({
                html: true
            });
        });
};

module.exports = updateStep2;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/updateStep2.js","/functions")
},{"./typehead/city":96,"./updateTotals":103,"buffer":114,"r7L21G":116}],103:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var totalsOverlay = require('./totalsOverlay');

$(document).ready(function() {
    var paymentMethodR = $('#paymentMethod input[type=\'radio\']:checked').val();

    if (paymentMethodR == 3 || paymentMethodR == 7 || paymentMethodR == 8 || paymentMethodR == 9 || paymentMethodR == 10) {
        $(document).find('[id="liqpay-link"]').show();
        $(document).find('[id="standart-button"]').hide();
        $(document).find('[id="priceWithLiqpay"]').show();
        $(document).find('[id="totalPrice"]').hide();
        $(document).find('[id="liqpayTax"]').show();
        $(document).find('[id="otp-link"]').hide();
    } else if(paymentMethodR == 11) {
        $(document).find('[id="otp-link"]').show();
        $(document).find('[id="liqpay-link"]').hide();
        $(document).find('[id="standart-button"]').hide();
        $(document).find('[id="priceWithLiqpay"]').hide();
        $(document).find('[id="totalPrice"]').show();
        $(document).find('[id="liqpayTax"]').hide();
    } else {
        $(document).find('[id="liqpay-link"]').hide();
        $(document).find('[id="standart-button"]').show();
        $(document).find('[id="priceWithLiqpay"]').hide();
        $(document).find('[id="totalPrice"]').show();
        $(document).find('[id="liqpayTax"]').hide();
        $(document).find('[id="otp-link"]').hide();
    }
});

var updateTotals = function updateTotals() {
    var paymentMethod = $('#paymentMethod input[type=\'radio\']:checked').val(),
        deliveryMethod = $('#deliveryMethod input[type=\'radio\']:checked').val(),
        coupon = $('.promo-code-block input[type="text"]').val() || '',
        data = {
            'paymentMethod': paymentMethod,
            'deliveryMethod': deliveryMethod,
            'city_id': $('input[name=\'OrderForm[cityId]\']').val(),
            'carrier': $('#carrier').val(),
            'branch': $('#branch').val()
        };

    totalsOverlay.show();

    var productInsuranceCheckbox = $('#product-insurance');
    if (productInsuranceCheckbox.length > 0) {
        data.productInsurance = productInsuranceCheckbox.is(':checked') ? 1 : 0;
    }

    if (coupon.length > 0) {
        data.coupon_id = coupon;
    }

    if (window.location.pathname.indexOf('/uk') > -1) {
        var cartLinkUpdate = '/uk/cart/update-totals';
    } else {
        var cartLinkUpdate = 'cart/update-totals';
    }

    return $.get(cartLinkUpdate, data, function (response) {
        var json = $.parseJSON(response);
        $('#totals').html(json.totals);

        if (json.productPriceOld !== "0") {
            $('#totalsFirst .price-old .number').html(json.productPriceOld).closest('.price-old').css('display', 'block');
        } else {
            $('#totalsFirst .price-old').css('display', 'none');
        }
        $('#totalsFirst .price .number').html(json.productPrice);

        $(document).find('[data-toggle="tooltip"]').tooltip({
            html: true
        });

        if (paymentMethod == 3 || paymentMethod == 7 || paymentMethod == 8 || paymentMethod == 9 || paymentMethod == 10) {
            $(document).find('[id="liqpay-link"]').show();
            $(document).find('[id="standart-button"]').hide();
            $(document).find('[id="priceWithLiqpay"]').show();
            $(document).find('[id="totalPrice"]').hide();
            $(document).find('[id="liqpayTax"]').show();
            $(document).find('[id="otp-link"]').hide();
        } else if (paymentMethod == 11) {
            $(document).find('[id="otp-link"]').show();
            $(document).find('[id="liqpay-link"]').hide();
            $(document).find('[id="standart-button"]').hide();
            $(document).find('[id="priceWithLiqpay"]').hide();
            $(document).find('[id="totalPrice"]').show();
            $(document).find('[id="liqpayTax"]').hide();
        } else {
            $(document).find('[id="liqpay-link"]').hide();
            $(document).find('[id="standart-button"]').show();
            $(document).find('[id="priceWithLiqpay"]').hide();
            $(document).find('[id="totalPrice"]').show();
            $(document).find('[id="liqpayTax"]').hide();
            $(document).find('[id="otp-link"]').hide();
        }

        totalsOverlay.hide();
    });

};

module.exports = updateTotals;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/updateTotals.js","/functions")
},{"./totalsOverlay":95,"buffer":114,"r7L21G":116}],104:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var validate = function ($this, callback) {

    var email = new RegExp('^([0-9a-zA-Z]+[-._+&amp;])*[0-9a-zA-Z]+@([-0-9a-zA-Z]+[.])+[a-zA-Z]{2,6}$'),
        email_value,
        required = new RegExp('^[0-9А-ЯЁЄІЇҐа-яёєіїґ ]{1,32}$'),
        required_value,
        letters_only = new RegExp('^[A-Za-zА-ЯЁЄІЇҐа-яёєіїґ’ ]{3,100}$'),
        letters_only_value,
        required_textarea = new RegExp('^[A-Za-zА-ЯЁЄІЇҐа-яёєіїґ ]{10,100}$'),
        required_textarea_value,
        phone = new RegExp('^[+][0-9]{1,2} [(][0-9]{3}[)] [0-9]{3}-[0-9]{2}-[0-9]{2}$'),
        phoneMobile = new RegExp('^[+][0-9]{12}$'),
        phone_value,
        nonCyrillic = /[^а-яА-ЯёЁіІїЇЄєґҐ'\s]|^$/,
        allowLatin = /[^A-Za-zа-яА-ЯёЁіІїЇЄєґҐ'\s]|^$/;
    errors = [];

    $this.find('.cyrillic_only').each(function () {
        var nameValue = $(this).val();

        if (nameValue && nonCyrillic.test(nameValue)) {
            $(this).parents('.form-group').addClass('has-error error');
            errors.push($(this));

        } else {
            $(this).parents('.form-group').removeClass('has-error error');
        }
    });

    $this.find('.latin_allow').each(function () {
        var nameValue = $(this).val();

        if (nameValue && allowLatin.test(nameValue)) {
            $(this).parents('.form-group').addClass('has-error error');
            errors.push($(this));

        } else {
            $(this).parents('.form-group').removeClass('has-error error');
        }
    });


    $this.find('.email-field').each(function () {
        email_value = $(this).val();
        if (email_value.length && !email.test(email_value)) {
            $(this).parents('.form-group').addClass('has-error error');
            errors.push($(this));

        } else {
            $(this).parents('.form-group').removeClass('has-error error');
        }
    });

    $this.find('.required_phone').each(function () {
        phone_value = $(this).val();
        if (!phone.test(phone_value) && !phoneMobile.test(phone_value)) {
            $(this).parents('.form-group').addClass('has-error error');
            errors.push($(this));

        } else {
            $(this).parents('.form-group').removeClass('error has-error');
        }
    });

    $this.find('.required_textarea').each(function () {
        required_textarea_value = $(this).val();
        if (!required_textarea.test(required_textarea_value)) {
            $(this).parents('.form-group').addClass('error has-error');
            errors.push($(this));

        } else {
            $(this).parents('.form-group').removeClass('has-error error');
        }
    });

    //вместо просто .required что бы не брало клас стилизованного селекта
    $this.find('input.required, select.required').each(function () {
        required_value = $(this).val();
        if (!required.test(required_value)) {
            $(this).parents('.form-group').addClass('has-error error');
            errors.push($(this));

        } else {
            $(this).parents('.form-group').removeClass('error has-error');
        }
    });

    $this.find('.required_company').each(function () {
        var $el = $(this);

        if ($el.val().length < 3) {
            $el.parents('.form-group').addClass('has-error error');
            errors.push($el);
        } else {
            // Remove an error flag if exists
            $(this).parents('.form-group').removeClass('error has-error');
        }
    });

    $this.find('.letters_only').each(function () {
        letters_only_value = $(this).val();
        if (!letters_only.test(letters_only_value)) {
            $(this).parents('.form-group').addClass('has-error error');
            errors.push($(this));

        } else {
            $(this).parents('.form-group').removeClass('error has-error');
        }
    });

    $this.find('.required_radio').each(function () {
        var radio = $(this).find('input[type="radio"]:checked');
        if (!radio.length) {
            errors.push($(this));
        }
    });

    $this.find('.pass').each(function () {
        var pass = $(this).val();
        var confirm = $(this).parents('form').find('.confirm').val();
        if (pass !== confirm || !pass.length) {
            $('.pass').parents('.form-group').addClass('has-error error');
            $('.confirm').parents('.form-group').addClass('error has-error');
            errors.push($(this));
        } else {
            $('.pass').parents('.form-group').removeClass('has-error error');
            $('.confirm').parents('.form-group').removeClass('error has-error');
        }
    });

    if (errors.length > 0) {
        return false;
    } else {
        callback();
    }
};

module.exports = validate;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/functions/validate.js","/functions")
},{"buffer":114,"r7L21G":116}],105:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var Product = require('./Product');

// Cart definition BEGIN

var Cart = function (options) {
    this.subscribers = [];
    this.properties = {};
    this.updateProperties(options);
};

Cart.prototype.emit = function (event) {
    var subscribers = this.subscribers;

    // Generate cusom event
    var customEvent = new CustomEvent(event, {
        detail: {
            model: this
        },
        bubbles: true,
        cancelable: false
    });

    // If element can dispatch events - emit it, otherwise return no result
    for (var i = 0, length = subscribers.length; i < length; i += 1) {
        if (subscribers[i].dispatchEvent) {
            subscribers[i].dispatchEvent(customEvent);
        }
    }
};

Cart.prototype.updateProperties = function (options) {
    var properties = this.properties;

    if (options) {
        var products = options.products;
        properties.products = [];

        if (products) {

            for( var item in products ) {
                properties.products[item] = [];

                for( var data in products[item] ) {

                    if ('article' in products[item][data]) {
                        properties.products[item][data] = new Product(products[item][data]);
                    } else {
                        properties.products[item][data] = [];
                        
                        for( var product in products[item][data] ) {
                            properties.products[item][data][product] = new Product(products[item][data][product]);
                        }
                    }
                }
            }
        }

        properties.count = options.count || 0;
        properties.countString = options.countString || '';
        properties.totalPrice = options.totalPrice || 0;
        properties.currency = options.currency || '';

    } else {
        this.properties = {
            products: [],
            count: 0,
            countString: '',
            totalPrice: 0,
            currency: ''
        };
    }
};

Cart.prototype.subscribe = function (element) {
    var length = this.subscribers.length;
    this.subscribers[length] = element;
};

Cart.prototype.addProduct = function (product) {
    var length = this.products.length;
    this.products[length] = product;
};

Cart.prototype.removeProduct = function (product) {
    if (product in this.products) {
        // Implement removing
        return true;
    }  else {
        return null;
    }
};

Cart.prototype.listenTo = function (event, element, cb) {
    if (element.addEventListener) {
        element.addEventListener(event, cb);
    } else if (element.attachEvent) {
        element.attachEvent(event, cb);
    } else {
        return null;
    }
};

// Cart definition END

module.exports = Cart;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/models/Cart.js","/models")
},{"./Product":107,"buffer":114,"r7L21G":116}],106:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// Present builder module (begin)

var PresentBuilder = function (options) {
    var controls = {};
    options = options || {};

    this.controller = options.controller || {};

    this.pol2 = options.pol2 || 'boy';

    this.maxPrice = options.maxPrice || 10000;

    this['vozrast-rebenka'] = options['vozrast-rebenka'] || '';

    this.reason = options.reason || '';

    this.price_to = options.price_to || 0;

    this.controls = controls;

    this.parseUrl();

};

PresentBuilder.prototype.parseUrl = function () {
    // If there is info in location then parse it
    var params = location.search.slice(1).split('&');
    var tmp;

    // Split by key and value
    for (var i in params) {
        tmp = params[i].split('=');
        // Parameter is a key, value - corresponding value
        if (this[tmp[0]]) {
            this[tmp[0]] = tmp[1];
        }
    }
};

PresentBuilder.prototype.composeLink = function () {
    var that = this;

    var link = $.param({
        action: 'present',
        reason: that.reason,
        pol2: that.pol2,
        price_to: that.price_to,
        'vozrast-rebenka': that['vozrast-rebenka']
    });

    return location.protocol + '//' + location.hostname + '/builder?' + link;
};

module.exports = PresentBuilder;

// Present builder module (end)
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/models/PresentBuilder.js","/models")
},{"buffer":114,"r7L21G":116}],107:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// Product definition BEGIN

var Product = function (options) {
    if (options) {
        var properties;
        this.properties = {};
        properties = this.properties;
        properties.title = options.title || '';
        properties.productId = options.productId || 0;
        properties.url = options.url || '';
        properties.image = options.image || '';
        properties.quantity = options.quantity || 0;
        properties.price = options.price || 0;
        properties.titleAdaptive = options.titleAdaptive || '';
        properties.article = options.article || '';
        properties.key = options.key || '';
        properties.priceOld = options.priceOld || 0;
    } else {
        this.properties = {
            title: '',
            productId: 0,
            image: '',
            url: '',
            quantity: 0,
            price: 0,
            titleAdaptive: '',
            article: '',
            key: '',
            priceOld: 0
        };
    }

};

// Product definition END

module.exports = Product;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/models/Product.js","/models")
},{"buffer":114,"r7L21G":116}],108:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// Banner-slider module (begin)

var Slider = function (options) {
    options = options || {};
    var slidesNum;

    // Definition of the "Prev slide" control
    this.$prevSlide = options.$prevSlide;

    // Definition of the "Next slide" control
    this.$nextSlide = options.$nextSlide;

    // Definition of the slides control
    this.$slides = options.$slides;

    slidesNum = parseInt(this.$slides.data('slides'));

    // Three is the minimal length of slider
    this.slidesNum = options.slidesNum || slidesNum;

    this.isBusy = false;

    // Init slider
    this.init();

};

Slider.prototype.init = function () {
    // Mark slides according to current

    this.$slidesDots = this.$slides.parent().find('.slider-dots');

    this.$slides.children().each(function (index, value) {
        $(value).attr('data-slider-number', index);
    });

    this.$slidesDots.children().each(function (index, value) {
        $(value).attr('data-dot-number', index);

    });

    this.setSlide(0);

    // Define handler for the next slider transition
    this.$nextSlide.click(this.nextSlide.bind(this));

    // Define handler for the prev slider transition
    this.$prevSlide.click(this.prevSlide.bind(this));

    this.dotsHandler();

    //Disable controls
    if (this.slidesNum < 2) {
        this.$prevSlide.hide();
        this.$nextSlide.hide();
    }

    // Define partial case when num of slides is less than 3
    if (this.slidesNum < 3) {
        this._partialCase(0);
    }

};

Slider.prototype._partialCase = function (num) {
    this.$slides.children()
        .removeClass('is-active is-prev is-next')  // Remove all marks
        .eq(num)
        .addClass('is-active');                  // Mark current slide as "is-active"
};

Slider.prototype.findNext = function () {
    var next;

    if ((this.currentSlide + 1) >= this.slidesNum) {
        next = 0;
    } else {
        next = this.currentSlide + 1;
    }

    return next;
};

Slider.prototype.dotsHandler = function () {
    var that = this;
    this.$slidesDots.children('.item').click(function () {
        that.setSlide($(this).data('dot-number'));
    });

};

Slider.prototype.findPrev = function () {
    var prev;

    if ((this.currentSlide - 1) < 0) {
        prev = this.slidesNum - 1;
    } else {
        prev = this.currentSlide - 1;
    }

    return prev;
};

Slider.prototype.setSlide = function (num) {
    if (!this.isBusy) {
        var that = this;
        this.isBusy = true;

        this.currentSlide = num;

        // Set it busy for one second
        setTimeout(function () {
            that.isBusy = false;
        }, 300);


        // Define next and prev slide
        var prev = this.findPrev();
        var next = this.findNext();

        // Mark slides according to current
        this.$slides.children()
            .removeClass('is-active is-prev is-next')  // Remove all marks
            .eq(num)
            .addClass('is-active')                  // Mark current slide as "is-active"
            .end()
            .eq(prev)
            .addClass('is-prev')                    // Mark previous slide as "is-prev"
            .end()
            .eq(next)
            .addClass('is-next');                    // Mark the next slide as "is-next"

        var dots = this.$slidesDots.children('.item');
        var activeSlideData = this.$slides.find('.is-active').data('slider-number');

        if (activeSlideData !== undefined) {
            dots.removeClass('is-active');
            this.$slidesDots.find("[data-dot-number='" + activeSlideData + "']").addClass('is-active');
        }
        // Provide handling if there are less than 3 slides
        if (this.slidesNum < 3) {
            this._partialCase(num);
        }
    }
};

Slider.prototype.nextSlide = function () {
    this.setSlide(this.findNext());
};

Slider.prototype.prevSlide = function () {
    this.setSlide(this.findPrev());
};

// Banner-slider module (end)

module.exports = Slider;
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/models/Slider.js","/models")
},{"buffer":114,"r7L21G":116}],109:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// Present builder module (begin)

var SportsNutrition = function (options) {
    var controls = {};
    options = options || {};

    this.controller = options.controller || {};

    this.reason = options.reason || '';

    this.sex = options.sex || 'man';

    this.age = options.age || 'teen';

    this.controls = controls;

    this.parseUrl();

};

SportsNutrition.prototype.parseUrl = function () {
    // If there is info in location then parse it
    var params = location.search.slice(1).split('&');
    var tmp;

    // Split by key and value
    for (var i in params) {
        tmp = params[i].split('=');
        // Parameter is a key, value - corresponding value
        if (this[tmp[0]]) {
            this[tmp[0]] = tmp[1];
        }
    }
};

SportsNutrition.prototype.composeLink = function () {
    var that = this;

    var link = $.param({
        action: 'sports-nutrition',
        reason: that.reason,
        sex: that.sex,
        age: that.age
    });

    return location.protocol + '//' + location.hostname + '/builder?' + link;
};

module.exports = SportsNutrition;

// Present builder module (end)
}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/models/SportsNutrition.js","/models")
},{"buffer":114,"r7L21G":116}],110:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = (function ($) {
    // Define variables
    var defaults;
    var methods;
    var Plugin;
    var init;
    var show;
    var destroy;
    var hide;
    var setHtml;
    var removeHandlers;
    var initHandlers;

    // Set default settings
    defaults = {
        type: 'json',
        content: 'Popup text',
        allowScrolling: false
    };

    // Definition of the event handlers

    removeHandlers = function () {
        this.$el.off('.popup')
            .find('.close-popup, .btn')
            .off('.popup');

        return this;
    };

    initHandlers = function () {
        var self = this;

        this.$el.find('.popup').on('click.popup', function (e) {
            e.stopPropagation();
        });

        this.$el.find('.close_popup, .popup-wrapper')
        .on('click.popup', function (e) {
            e.stopPropagation();
            methods['hide'].apply(self);
        });

        this.$el.closest('body').keydown(function (e) {
            if (e.keyCode == 27) {
                methods['hide'].apply(self);
            }
        });

        return this;
    };

    setHtml = function (html) {
        // Remove old event handlers
        methods.removeHandlers.apply(this);

        this.$el.find('.popup').html('<a class="close_popup" href="javascript:void(0);"></a>').append(html);

        // Init them again
        methods.initHandlers.apply(this);

        return this;
    };

    init = function () {
        // Put popup into the DOM
        if (this.options.allowScrolling) {
            this.$el.append('<div class="popup-wrapper"><div class="popup is-scrollable is-inactive"><a href="javascript:void(0);" class="close_popup"></a></div></div>');
        } else {
            this.$el.append('<div class="popup-wrapper"><div class="popup is-inactive"><a href="javascript:void(0);" class="close_popup"></a></div></div>');
        }

        // Set event handlers on popup elements
        methods.initHandlers.apply(this);

        // Return instance for chaining
        return this;
    };

    destroy = function () {
        // Clear event handlers
        methods.removeHandlers.apply(this);

        // Remove element from the DOM
        this.$el.removeData('init')
            .find('.popup-wrapper')
            .remove();

        // Return instance for chaining
        return this;
    };

    show = function () {
        // Toggle popup in shown state
        this.$el
            .find('.popup-wrapper')
            .addClass('is-flex')
            .end()
            .delay(150)
            .find('.popup').animate({}, 300, function () {
                $(this).addClass('is-active')
                    .removeClass('is-inactive');
            });

        $('body').addClass('is-modal-open');
        // Return instance for chaining
        return this;
    };

    hide = function () {
        // Toggle popup in hidden state
        this.$el.find('.popup')
            .addClass('is-inactive')
            .removeClass('is-active')
            .end()
            .find('.popup-wrapper').animate({}, 500, function () {
                $(this).removeClass('is-flex');
            });

        $('body').removeClass('is-modal-open');

        // Return instance for chaining
        return this;
    };

    // Object containing all plugin's methods
    methods = {
        init: init,
        destroy: destroy,
        show: show,
        hide: hide,
        setHtml: setHtml,
        removeHandlers: removeHandlers,
        initHandlers: initHandlers
    };

    // Definition of the plugin constuctor
    Plugin = function (options, element) {
        this.options = {};
        this.$el = element;

        if (this.$el.data('init')) {
            throw new Error('You have been initialized popup already!');
        }

        this.$el.data('init', true);

        // Merge default parameters by custom ones
        $.extend(this.options, defaults, options);

        // Define the type of data
        if (this.options.type === 'json' || this.options.type === 'html') {
            // Initialize plugin instance
            methods['init'].apply(this);
        } else {
            throw new Error('An unknown type of data!');
        }
    };

    // Define common method for invocation
    Plugin.prototype.method = function (methodName, value) {
        if (methods.hasOwnProperty(methodName)) {
            // Invoke the method in the context of the plugin instance
            return methods[methodName].call(this, value);
        } else {
            throw new Error('Unknown method has been invoked!');
        }

    };

    // Bind plugin to jQuery
    $.fn.popup = function (options) {
        return new Plugin(options, this);
    };
})(jQuery);

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/plugins/jquery.apibest.popup.js","/plugins")
},{"buffer":114,"r7L21G":116}],111:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
/**
 * BxSlider v4.1.1 - Fully loaded, responsive content slider
 * http://bxslider.com
 *
 * Copyright 2013, Steven Wanderski - http://stevenwanderski.com - http://bxcreative.com
 * Written while drinking Belgian ales and listening to jazz
 *
 * Released under the MIT license - http://opensource.org/licenses/MIT
 */
!function (t) {var e = {},s = {mode:'horizontal',slideSelector:'',infiniteLoop:!0,hideControlOnEnd:!1,speed:500,easing:null,slideMargin:0,startSlide:0,randomStart:!1,captions:!1,ticker:!1,tickerHover:!1,adaptiveHeight:!1,adaptiveHeightSpeed:500,video:!1,useCSS:!0,preloadImages:'visible',responsive:!0,touchEnabled:!0,swipeThreshold:50,oneToOneTouch:!0,preventDefaultSwipeX:!0,preventDefaultSwipeY:!1,pager:!0,pagerType:'full',pagerShortSeparator:' / ',pagerSelector:null,buildPager:null,pagerCustom:null,controls:!0,nextText:'Next',prevText:'Prev',nextSelector:null,prevSelector:null,autoControls:!1,startText:'Start',stopText:'Stop',autoControlsCombine:!1,autoControlsSelector:null,auto:!1,pause:4e3,autoStart:!0,autoDirection:'next',autoHover:!1,autoDelay:0,minSlides:1,maxSlides:1,moveSlides:0,slideWidth:0,onSliderLoad:function () {},onSlideBefore:function () {},onSlideAfter:function () {},onSlideNext:function () {},onSlidePrev:function () {}};t.fn.bxSlider = function (n) {if (0 == this.length)return this;if (this.length > 1)return this.each(function () {t(this).bxSlider(n)}),this;var o = {},r = this;e.el = this;var a = t(window).width(),l = t(window).height(),d = function () {o.settings = t.extend({}, s, n),o.settings.slideWidth = parseInt(o.settings.slideWidth),o.children = r.children(o.settings.slideSelector),o.children.length < o.settings.minSlides && (o.settings.minSlides = o.children.length),o.children.length < o.settings.maxSlides && (o.settings.maxSlides = o.children.length),o.settings.randomStart && (o.settings.startSlide = Math.floor(Math.random() * o.children.length)),o.active = {index:o.settings.startSlide},o.carousel = o.settings.minSlides > 1 || o.settings.maxSlides > 1,o.carousel && (o.settings.preloadImages = 'all'),o.minThreshold = o.settings.minSlides * o.settings.slideWidth + (o.settings.minSlides - 1) * o.settings.slideMargin,o.maxThreshold = o.settings.maxSlides * o.settings.slideWidth + (o.settings.maxSlides - 1) * o.settings.slideMargin,o.working = !1,o.controls = {},o.interval = null,o.animProp = 'vertical' == o.settings.mode ? 'top' : 'left',o.usingCSS = o.settings.useCSS && 'fade' != o.settings.mode && function () {var t = document.createElement('div'),e = ['WebkitPerspective','MozPerspective','OPerspective','msPerspective'];for (var i in e)if (void 0 !== t.style[e[i]])return o.cssPrefix = e[i].replace('Perspective', '').toLowerCase(),o.animProp = '-' + o.cssPrefix + '-transform',!0;return !1}(),'vertical' == o.settings.mode && (o.settings.maxSlides = o.settings.minSlides),r.data('origStyle', r.attr('style')),r.children(o.settings.slideSelector).each(function () {t(this).data('origStyle', t(this).attr('style'))}),c()},c = function () {r.wrap('<div class="bx-wrapper"><div class="bx-viewport"></div></div>'),o.viewport = r.parent(),o.loader = t('<div class="bx-loading" />'),o.viewport.prepend(o.loader),r.css({width:'horizontal' == o.settings.mode ? 100 * o.children.length + 215 + '%' : 'auto',position:'relative'}),o.usingCSS && o.settings.easing ? r.css('-' + o.cssPrefix + '-transition-timing-function', o.settings.easing) : o.settings.easing || (o.settings.easing = 'swing'),f(),o.viewport.css({width:'100%',overflow:'hidden',position:'relative'}),o.viewport.parent().css({maxWidth:v()}),o.settings.pager || o.viewport.parent().css({margin:'0 auto 0px'}),o.children.css({'float':'horizontal' == o.settings.mode ? 'left' : 'none',listStyle:'none',position:'relative'}),o.children.css('width', u()),'horizontal' == o.settings.mode && o.settings.slideMargin > 0 && o.children.css('marginRight', o.settings.slideMargin),'vertical' == o.settings.mode && o.settings.slideMargin > 0 && o.children.css('marginBottom', o.settings.slideMargin),'fade' == o.settings.mode && (o.children.css({position:'absolute',zIndex:0,display:'none'}),o.children.eq(o.settings.startSlide).css({zIndex:50,display:'block'})),o.controls.el = t('<div class="bx-controls" />'),o.settings.captions && P(),o.active.last = o.settings.startSlide == x() - 1,o.settings.video && r.fitVids();var e = o.children.eq(o.settings.startSlide);'all' == o.settings.preloadImages && (e = o.children),o.settings.ticker ? o.settings.pager = !1 : (o.settings.pager && T(),o.settings.controls && C(),o.settings.auto && o.settings.autoControls && E(),(o.settings.controls || o.settings.autoControls || o.settings.pager) && o.viewport.after(o.controls.el)),g(e, h)},g = function (e,i) {var s = e.find('img, iframe').length;if (0 == s)return i(),void 0;var n = 0;e.find('img, iframe').each(function () {t(this).one('load', function () {++n == s && i()}).each(function () {this.complete && t(this).load()})})},h = function () {if (o.settings.infiniteLoop && 'fade' != o.settings.mode && !o.settings.ticker){var e = 'vertical' == o.settings.mode ? o.settings.minSlides : o.settings.maxSlides,i = o.children.slice(0, e).clone().addClass('bx-clone'),s = o.children.slice(-e).clone().addClass('bx-clone');r.append(i).prepend(s)}o.loader.remove(),S(),'vertical' == o.settings.mode && (o.settings.adaptiveHeight = !0),o.viewport.height(p()),r.redrawSlider(),o.settings.onSliderLoad(o.active.index),o.initialized = !0,o.settings.responsive && t(window).bind('resize', B),o.settings.auto && o.settings.autoStart && H(),o.settings.ticker && L(),o.settings.pager && I(o.settings.startSlide),o.settings.controls && W(),o.settings.touchEnabled && !o.settings.ticker && O()},p = function () {var e = 0,s = t();if ('vertical' == o.settings.mode || o.settings.adaptiveHeight)if (o.carousel){var n = 1 == o.settings.moveSlides ? o.active.index : o.active.index * m();for (s = o.children.eq(n),i = 1;i <= o.settings.maxSlides - 1;i++)s = n + i >= o.children.length ? s.add(o.children.eq(i - 1)) : s.add(o.children.eq(n + i))}else s = o.children.eq(o.active.index);else s = o.children;return 'vertical' == o.settings.mode ? (s.each(function () {e += t(this).outerHeight()}),o.settings.slideMargin > 0 && (e += o.settings.slideMargin * (o.settings.minSlides - 1))) : e = Math.max.apply(Math, s.map(function () {return t(this).outerHeight(!1)}).get()),e},v = function () {var t = '100%';return o.settings.slideWidth > 0 && (t = 'horizontal' == o.settings.mode ? o.settings.maxSlides * o.settings.slideWidth + (o.settings.maxSlides - 1) * o.settings.slideMargin : o.settings.slideWidth),t},u = function () {var t = o.settings.slideWidth,e = o.viewport.width();return 0 == o.settings.slideWidth || o.settings.slideWidth > e && !o.carousel || 'vertical' == o.settings.mode ? t = e : o.settings.maxSlides > 1 && 'horizontal' == o.settings.mode && (e > o.maxThreshold || e < o.minThreshold && (t = (e - o.settings.slideMargin * (o.settings.minSlides - 1)) / o.settings.minSlides)),t},f = function () {var t = 1;if ('horizontal' == o.settings.mode && o.settings.slideWidth > 0)if (o.viewport.width() < o.minThreshold)t = o.settings.minSlides;else if (o.viewport.width() > o.maxThreshold)t = o.settings.maxSlides;else {var e = o.children.first().width();t = Math.floor(o.viewport.width() / e)}else 'vertical' == o.settings.mode && (t = o.settings.minSlides);return t},x = function () {var t = 0;if (o.settings.moveSlides > 0)if (o.settings.infiniteLoop)t = o.children.length / m();else for (var e = 0,i = 0;e < o.children.length;)++t,e = i + f(),i += o.settings.moveSlides <= f() ? o.settings.moveSlides : f();else t = Math.ceil(o.children.length / f());return t},m = function () {return o.settings.moveSlides > 0 && o.settings.moveSlides <= f() ? o.settings.moveSlides : f()},S = function () {if (o.children.length > o.settings.maxSlides && o.active.last && !o.settings.infiniteLoop){if ('horizontal' == o.settings.mode){var t = o.children.last(),e = t.position();b(-(e.left - (o.viewport.width() - t.width())), 'reset', 0)}else if ('vertical' == o.settings.mode){var i = o.children.length - o.settings.minSlides,e = o.children.eq(i).position();b(-e.top, 'reset', 0)}}else {var e = o.children.eq(o.active.index * m()).position();o.active.index == x() - 1 && (o.active.last = !0),void 0 != e && ('horizontal' == o.settings.mode ? b(-e.left, 'reset', 0) : 'vertical' == o.settings.mode && b(-e.top, 'reset', 0))}},b = function (t,e,i,s) {if (o.usingCSS){var n = 'vertical' == o.settings.mode ? 'translate3d(0, ' + t + 'px, 0)' : 'translate3d(' + t + 'px, 0, 0)';r.css('-' + o.cssPrefix + '-transition-duration', i / 1e3 + 's'),'slide' == e ? (r.css(o.animProp, n),r.bind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {r.unbind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd'),D()})) : 'reset' == e ? r.css(o.animProp, n) : 'ticker' == e && (r.css('-' + o.cssPrefix + '-transition-timing-function', 'linear'),r.css(o.animProp, n),r.bind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {r.unbind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd'),b(s.resetValue, 'reset', 0),N()}))}else {var a = {};a[o.animProp] = t,'slide' == e ? r.animate(a, i, o.settings.easing, function () {D()}) : 'reset' == e ? r.css(o.animProp, t) : 'ticker' == e && r.animate(a, speed, 'linear', function () {b(s.resetValue, 'reset', 0),N()})}},w = function () {for (var e = '',i = x(),s = 0;i > s;s++){var n = '';o.settings.buildPager && t.isFunction(o.settings.buildPager) ? (n = o.settings.buildPager(s),o.pagerEl.addClass('bx-custom-pager')) : (n = s + 1,o.pagerEl.addClass('bx-default-pager')),e += '<div class="bx-pager-item"><a href="" data-slide-index="' + s + '" class="bx-pager-link">' + n + '</a></div>'}o.pagerEl.html(e)},T = function () {o.settings.pagerCustom ? o.pagerEl = t(o.settings.pagerCustom) : (o.pagerEl = t('<div class="bx-pager" />'),o.settings.pagerSelector ? t(o.settings.pagerSelector).html(o.pagerEl) : o.controls.el.addClass('bx-has-pager').append(o.pagerEl),w()),o.pagerEl.delegate('a', 'click', q)},C = function () {o.controls.next = t('<a class="bx-next" href="">' + o.settings.nextText + '</a>'),o.controls.prev = t('<a class="bx-prev" href="">' + o.settings.prevText + '</a>'),o.controls.next.bind('click', y),o.controls.prev.bind('click', z),o.settings.nextSelector && t(o.settings.nextSelector).append(o.controls.next),o.settings.prevSelector && t(o.settings.prevSelector).append(o.controls.prev),o.settings.nextSelector || o.settings.prevSelector || (o.controls.directionEl = t('<div class="bx-controls-direction" />'),o.controls.directionEl.append(o.controls.prev).append(o.controls.next),o.controls.el.addClass('bx-has-controls-direction').append(o.controls.directionEl))},E = function () {o.controls.start = t('<div class="bx-controls-auto-item"><a class="bx-start" href="">' + o.settings.startText + '</a></div>'),o.controls.stop = t('<div class="bx-controls-auto-item"><a class="bx-stop" href="">' + o.settings.stopText + '</a></div>'),o.controls.autoEl = t('<div class="bx-controls-auto" />'),o.controls.autoEl.delegate('.bx-start', 'click', k),o.controls.autoEl.delegate('.bx-stop', 'click', M),o.settings.autoControlsCombine ? o.controls.autoEl.append(o.controls.start) : o.controls.autoEl.append(o.controls.start).append(o.controls.stop),o.settings.autoControlsSelector ? t(o.settings.autoControlsSelector).html(o.controls.autoEl) : o.controls.el.addClass('bx-has-controls-auto').append(o.controls.autoEl),A(o.settings.autoStart ? 'stop' : 'start')},P = function () {o.children.each(function () {var e = t(this).find('img:first').attr('title');void 0 != e && ('' + e).length && t(this).append('<div class="bx-caption"><span>' + e + '</span></div>')})},y = function (t) {o.settings.auto && r.stopAuto(),r.goToNextSlide(),t.preventDefault()},z = function (t) {o.settings.auto && r.stopAuto(),r.goToPrevSlide(),t.preventDefault()},k = function (t) {r.startAuto(),t.preventDefault()},M = function (t) {r.stopAuto(),t.preventDefault()},q = function (e) {o.settings.auto && r.stopAuto();var i = t(e.currentTarget),s = parseInt(i.attr('data-slide-index'));s != o.active.index && r.goToSlide(s),e.preventDefault()},I = function (e) {var i = o.children.length;return 'short' == o.settings.pagerType ? (o.settings.maxSlides > 1 && (i = Math.ceil(o.children.length / o.settings.maxSlides)),o.pagerEl.html(e + 1 + o.settings.pagerShortSeparator + i),void 0) : (o.pagerEl.find('a').removeClass('active'),o.pagerEl.each(function (i,s) {t(s).find('a').eq(e).addClass('active')}),void 0)},D = function () {if (o.settings.infiniteLoop){var t = '';0 == o.active.index ? t = o.children.eq(0).position() : o.active.index == x() - 1 && o.carousel ? t = o.children.eq((x() - 1) * m()).position() : o.active.index == o.children.length - 1 && (t = o.children.eq(o.children.length - 1).position()),'horizontal' == o.settings.mode ? b(-t.left, 'reset', 0) : 'vertical' == o.settings.mode && b(-t.top, 'reset', 0)}o.working = !1,o.settings.onSlideAfter(o.children.eq(o.active.index), o.oldIndex, o.active.index)},A = function (t) {o.settings.autoControlsCombine ? o.controls.autoEl.html(o.controls[t]) : (o.controls.autoEl.find('a').removeClass('active'),o.controls.autoEl.find('a:not(.bx-' + t + ')').addClass('active'))},W = function () {1 == x() ? (o.controls.prev.addClass('disabled'),o.controls.next.addClass('disabled')) : !o.settings.infiniteLoop && o.settings.hideControlOnEnd && (0 == o.active.index ? (o.controls.prev.addClass('disabled'),o.controls.next.removeClass('disabled')) : o.active.index == x() - 1 ? (o.controls.next.addClass('disabled'),o.controls.prev.removeClass('disabled')) : (o.controls.prev.removeClass('disabled'),o.controls.next.removeClass('disabled')))},H = function () {o.settings.autoDelay > 0 ? setTimeout(r.startAuto, o.settings.autoDelay) : r.startAuto(),o.settings.autoHover && r.hover(function () {o.interval && (r.stopAuto(!0),o.autoPaused = !0)}, function () {o.autoPaused && (r.startAuto(!0),o.autoPaused = null)})},L = function () {var e = 0;if ('next' == o.settings.autoDirection)r.append(o.children.clone().addClass('bx-clone'));else {r.prepend(o.children.clone().addClass('bx-clone'));var i = o.children.first().position();e = 'horizontal' == o.settings.mode ? -i.left : -i.top}b(e, 'reset', 0),o.settings.pager = !1,o.settings.controls = !1,o.settings.autoControls = !1,o.settings.tickerHover && !o.usingCSS && o.viewport.hover(function () {r.stop()}, function () {var e = 0;o.children.each(function () {e += 'horizontal' == o.settings.mode ? t(this).outerWidth(!0) : t(this).outerHeight(!0)});var i = o.settings.speed / e,s = 'horizontal' == o.settings.mode ? 'left' : 'top',n = i * (e - Math.abs(parseInt(r.css(s))));N(n)}),N()},N = function (t) {speed = t ? t : o.settings.speed;var e = {left:0,top:0},i = {left:0,top:0};'next' == o.settings.autoDirection ? e = r.find('.bx-clone').first().position() : i = o.children.first().position();var s = 'horizontal' == o.settings.mode ? -e.left : -e.top,n = 'horizontal' == o.settings.mode ? -i.left : -i.top,a = {resetValue:n};b(s, 'ticker', speed, a)},O = function () {o.touch = {start:{x:0,y:0},end:{x:0,y:0}},o.viewport.bind('touchstart', X)},X = function (t) {if (o.working)t.preventDefault();else {o.touch.originalPos = r.position();var e = t.originalEvent;o.touch.start.x = e.changedTouches[0].pageX,o.touch.start.y = e.changedTouches[0].pageY,o.viewport.bind('touchmove', Y),o.viewport.bind('touchend', V)}},Y = function (t) {var e = t.originalEvent,i = Math.abs(e.changedTouches[0].pageX - o.touch.start.x),s = Math.abs(e.changedTouches[0].pageY - o.touch.start.y);if (3 * i > s && o.settings.preventDefaultSwipeX ? t.preventDefault() : 3 * s > i && o.settings.preventDefaultSwipeY && t.preventDefault(),'fade' != o.settings.mode && o.settings.oneToOneTouch){var n = 0;if ('horizontal' == o.settings.mode){var r = e.changedTouches[0].pageX - o.touch.start.x;n = o.touch.originalPos.left + r}else {var r = e.changedTouches[0].pageY - o.touch.start.y;n = o.touch.originalPos.top + r}b(n, 'reset', 0)}},V = function (t) {o.viewport.unbind('touchmove', Y);var e = t.originalEvent,i = 0;if (o.touch.end.x = e.changedTouches[0].pageX,o.touch.end.y = e.changedTouches[0].pageY,'fade' == o.settings.mode){var s = Math.abs(o.touch.start.x - o.touch.end.x);s >= o.settings.swipeThreshold && (o.touch.start.x > o.touch.end.x ? r.goToNextSlide() : r.goToPrevSlide(),r.stopAuto())}else {var s = 0;'horizontal' == o.settings.mode ? (s = o.touch.end.x - o.touch.start.x,i = o.touch.originalPos.left) : (s = o.touch.end.y - o.touch.start.y,i = o.touch.originalPos.top),!o.settings.infiniteLoop && (0 == o.active.index && s > 0 || o.active.last && 0 > s) ? b(i, 'reset', 200) : Math.abs(s) >= o.settings.swipeThreshold ? (0 > s ? r.goToNextSlide() : r.goToPrevSlide(),r.stopAuto()) : b(i, 'reset', 200)}o.viewport.unbind('touchend', V)},B = function () {var e = t(window).width(),i = t(window).height();(a != e || l != i) && (a = e,l = i,r.redrawSlider())};return r.goToSlide = function (e,i) {if (!o.working && o.active.index != e)if (o.working = !0,o.oldIndex = o.active.index,o.active.index = 0 > e ? x() - 1 : e >= x() ? 0 : e,o.settings.onSlideBefore(o.children.eq(o.active.index), o.oldIndex, o.active.index),'next' == i ? o.settings.onSlideNext(o.children.eq(o.active.index), o.oldIndex, o.active.index) : 'prev' == i && o.settings.onSlidePrev(o.children.eq(o.active.index), o.oldIndex, o.active.index),o.active.last = o.active.index >= x() - 1,o.settings.pager && I(o.active.index),o.settings.controls && W(),'fade' == o.settings.mode)o.settings.adaptiveHeight && o.viewport.height() != p() && o.viewport.animate({height:p()}, o.settings.adaptiveHeightSpeed),o.children.filter(':visible').fadeOut(o.settings.speed).css({zIndex:0}),o.children.eq(o.active.index).css('zIndex', 51).fadeIn(o.settings.speed, function () {t(this).css('zIndex', 50),D()});else {o.settings.adaptiveHeight && o.viewport.height() != p() && o.viewport.animate({height:p()}, o.settings.adaptiveHeightSpeed);var s = 0,n = {left:0,top:0};if (!o.settings.infiniteLoop && o.carousel && o.active.last)if ('horizontal' == o.settings.mode){var a = o.children.eq(o.children.length - 1);n = a.position(),s = o.viewport.width() - a.outerWidth()}else {var l = o.children.length - o.settings.minSlides;n = o.children.eq(l).position()}else if (o.carousel && o.active.last && 'prev' == i){var d = 1 == o.settings.moveSlides ? o.settings.maxSlides - m() : (x() - 1) * m() - (o.children.length - o.settings.maxSlides),a = r.children('.bx-clone').eq(d);n = a.position()}else if ('next' == i && 0 == o.active.index)n = r.find('> .bx-clone').eq(o.settings.maxSlides).position(),o.active.last = !1;else if (e >= 0){var c = e * m();n = o.children.eq(c).position()}if ('undefined' != typeof n){var g = 'horizontal' == o.settings.mode ? -(n.left - s) : -n.top;b(g, 'slide', o.settings.speed)}}},r.goToNextSlide = function () {if (o.settings.infiniteLoop || !o.active.last){var t = parseInt(o.active.index) + 1;r.goToSlide(t, 'next')}},r.goToPrevSlide = function () {if (o.settings.infiniteLoop || 0 != o.active.index){var t = parseInt(o.active.index) - 1;r.goToSlide(t, 'prev')}},r.startAuto = function (t) {o.interval || (o.interval = setInterval(function () {'next' == o.settings.autoDirection ? r.goToNextSlide() : r.goToPrevSlide()}, o.settings.pause),o.settings.autoControls && 1 != t && A('stop'))},r.stopAuto = function (t) {o.interval && (clearInterval(o.interval),o.interval = null,o.settings.autoControls && 1 != t && A('start'))},r.getCurrentSlide = function () {return o.active.index},r.getSlideCount = function () {return o.children.length},r.redrawSlider = function () {o.children.add(r.find('.bx-clone')).outerWidth(u()),o.viewport.css('height', p()),o.settings.ticker || S(),o.active.last && (o.active.index = x() - 1),o.active.index >= x() && (o.active.last = !0),o.settings.pager && !o.settings.pagerCustom && (w(),I(o.active.index))},r.destroySlider = function () {o.initialized && (o.initialized = !1,t('.bx-clone', this).remove(),o.children.each(function () {void 0 != t(this).data('origStyle') ? t(this).attr('style', t(this).data('origStyle')) : t(this).removeAttr('style')}),void 0 != t(this).data('origStyle') ? this.attr('style', t(this).data('origStyle')) : t(this).removeAttr('style'),t(this).unwrap().unwrap(),o.controls.el && o.controls.el.remove(),o.controls.next && o.controls.next.remove(),o.controls.prev && o.controls.prev.remove(),o.pagerEl && o.pagerEl.remove(),t('.bx-caption', this).remove(),o.controls.autoEl && o.controls.autoEl.remove(),clearInterval(o.interval),o.settings.responsive && t(window).unbind('resize', B))},r.reloadSlider = function (t) {void 0 != t && (n = t),r.destroySlider(),d()},d(),this}}(jQuery);

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/plugins/jquery.bxslider.min.js","/plugins")
},{"buffer":114,"r7L21G":116}],112:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
/* ========================================================================
 * Bootstrap: tooltip.js v3.3.1
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
    'use strict';

    // TOOLTIP PUBLIC CLASS DEFINITION
    // ===============================

    var Tooltip = function (element, options) {
        this.type       =
        this.options    =
        this.enabled    =
        this.timeout    =
        this.hoverState =
        this.$element   = null

        this.init('tooltip', element, options)
    }

    Tooltip.VERSION  = '3.3.1'

    Tooltip.TRANSITION_DURATION = 150

    Tooltip.DEFAULTS = {
        animation: true,
        placement: 'top',
        selector: false,
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: 'hover focus',
        title: '',
        delay: 0,
        html: false,
        container: false,
        viewport: {
            selector: 'body',
            padding: 0
        }
    };

    Tooltip.prototype.init = function (type, element, options) {
        this.enabled   = true;
        this.type      = type;
        this.$element  = $(element);
        this.options   = this.getOptions(options)
        this.$viewport = this.options.viewport && $(this.options.viewport.selector || this.options.viewport)

        var triggers = this.options.trigger.split(' ')

        for (var i = triggers.length; i--;) {
            var trigger = triggers[i]

            if (trigger == 'click') {
                this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
            } else if (trigger != 'manual') {
                var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
                var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

                this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
                this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
            }
        }

        this.options.selector ?
          (this._options = $.extend({}, this.options, {trigger: 'manual', selector: ''})) :
          this.fixTitle()
    }

    Tooltip.prototype.getDefaults = function () {
        return Tooltip.DEFAULTS
    }

    Tooltip.prototype.getOptions = function (options) {
        options = $.extend({}, this.getDefaults(), this.$element.data(), options)

        if (options.delay && typeof options.delay == 'number') {
            options.delay = {
                show: options.delay,
                hide: options.delay
            }
        }

        return options
    }

    Tooltip.prototype.getDelegateOptions = function () {
        var options  = {}
        var defaults = this.getDefaults()

        this._options && $.each(this._options, function (key, value) {
            if (defaults[key] != value) options[key] = value
        })

        return options
    }

    Tooltip.prototype.enter = function (obj) {
        var self = obj instanceof this.constructor ?
          obj : $(obj.currentTarget).data('bs.' + this.type)

        if (self && self.$tip && self.$tip.is(':visible')) {
            self.hoverState = 'in'
            return
        }

        if (!self) {
            self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
            $(obj.currentTarget).data('bs.' + this.type, self)
        }

        clearTimeout(self.timeout)

        self.hoverState = 'in'

        if (!self.options.delay || !self.options.delay.show) return self.show()

        self.timeout = setTimeout(function () {
            if (self.hoverState == 'in') self.show()
        }, self.options.delay.show)
    }

    Tooltip.prototype.leave = function (obj) {
        var self = obj instanceof this.constructor ?
          obj : $(obj.currentTarget).data('bs.' + this.type)

        if (!self) {
            self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
            $(obj.currentTarget).data('bs.' + this.type, self)
        }

        clearTimeout(self.timeout)

        self.hoverState = 'out'

        if (!self.options.delay || !self.options.delay.hide) return self.hide()

        self.timeout = setTimeout(function () {
            if (self.hoverState == 'out') self.hide()
        }, self.options.delay.hide)
    }

    Tooltip.prototype.show = function () {
        var e = $.Event('show.bs.' + this.type)

        if (this.hasContent() && this.enabled) {
            this.$element.trigger(e)

            var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
            if (e.isDefaultPrevented() || !inDom) return
            var that = this

            var $tip = this.tip()

            var tipId = this.getUID(this.type)

            this.setContent()
            $tip.attr('id', tipId)
            this.$element.attr('aria-describedby', tipId)

            if (this.options.animation) $tip.addClass('fade')

            var placement = typeof this.options.placement == 'function' ?
              this.options.placement.call(this, $tip[0], this.$element[0]) :
              this.options.placement

            var autoToken = /\s?auto?\s?/i
            var autoPlace = autoToken.test(placement)
            if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

            $tip
              .detach()
              .css({top: 0, left: 0, display: 'block'})
              .addClass(placement)
              .data('bs.' + this.type, this)

            this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)

            var pos          = this.getPosition()
            var actualWidth  = $tip[0].offsetWidth
            var actualHeight = $tip[0].offsetHeight

            if (autoPlace) {
                var orgPlacement = placement
                var $container   = this.options.container ? $(this.options.container) : this.$element.parent()
                var containerDim = this.getPosition($container)

                placement = placement == 'bottom' && pos.bottom + actualHeight > containerDim.bottom ? 'top'    :
                            placement == 'top'    && pos.top    - actualHeight < containerDim.top    ? 'bottom' :
                            placement == 'right'  && pos.right  + actualWidth  > containerDim.width  ? 'left'   :
                            placement == 'left'   && pos.left   - actualWidth  < containerDim.left   ? 'right'  :
                            placement

                $tip
                  .removeClass(orgPlacement)
                  .addClass(placement)
            }

            var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

            this.applyPlacement(calculatedOffset, placement)

            var complete = function () {
                var prevHoverState = that.hoverState
                that.$element.trigger('shown.bs.' + that.type)
                that.hoverState = null

                if (prevHoverState == 'out') that.leave(that)
            }

            $.support.transition && this.$tip.hasClass('fade') ?
              $tip
                .one('bsTransitionEnd', complete)
                .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
              complete()
        }
    }

    Tooltip.prototype.applyPlacement = function (offset, placement) {
        var $tip   = this.tip()
        var width  = $tip[0].offsetWidth
        var height = $tip[0].offsetHeight

        // manually read margins because getBoundingClientRect includes difference
        var marginTop = parseInt($tip.css('margin-top'), 10)
        var marginLeft = parseInt($tip.css('margin-left'), 10)

        // we must check for NaN for ie 8/9
        if (isNaN(marginTop))  marginTop  = 0
        if (isNaN(marginLeft)) marginLeft = 0

        offset.top  = offset.top  + marginTop
        offset.left = offset.left + marginLeft

        // $.fn.offset doesn't round pixel values
        // so we use setOffset directly with our own function B-0
        $.offset.setOffset($tip[0], $.extend({
            using: function (props) {
                $tip.css({
                    top: Math.round(props.top),
                    left: Math.round(props.left)
                })
            }
        }, offset), 0)

        $tip.addClass('in')

        // check to see if placing tip in new offset caused the tip to resize itself
        var actualWidth  = $tip[0].offsetWidth
        var actualHeight = $tip[0].offsetHeight

        if (placement == 'top' && actualHeight != height) {
            offset.top = offset.top + height - actualHeight
        }

        var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

        if (delta.left) offset.left += delta.left
        else offset.top += delta.top

        var isVertical          = /top|bottom/.test(placement)
        var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
        var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

        $tip.offset(offset)
        this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
    }

    Tooltip.prototype.replaceArrow = function (delta, dimension, isHorizontal) {
        this.arrow()
          .css(isHorizontal ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
          .css(isHorizontal ? 'top' : 'left', '')
    }

    Tooltip.prototype.setContent = function () {
        var $tip  = this.tip()
        var title = this.getTitle()

        $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
        $tip.removeClass('fade in top bottom left right')
    }

    Tooltip.prototype.hide = function (callback) {
        var that = this
        var $tip = this.tip()
        var e    = $.Event('hide.bs.' + this.type)

        function complete() {
            if (that.hoverState != 'in') $tip.detach()
            that.$element
              .removeAttr('aria-describedby')
              .trigger('hidden.bs.' + that.type)
            callback && callback()
        }

        this.$element.trigger(e)

        if (e.isDefaultPrevented()) return

        $tip.removeClass('in')

        $.support.transition && this.$tip.hasClass('fade') ?
          $tip
            .one('bsTransitionEnd', complete)
            .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
          complete()

        this.hoverState = null

        return this
    }

    Tooltip.prototype.fixTitle = function () {
        var $e = this.$element
        if ($e.attr('title') || typeof ($e.attr('data-original-title')) != 'string') {
            $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
        }
    }

    Tooltip.prototype.hasContent = function () {
        return this.getTitle()
    }

    Tooltip.prototype.getPosition = function ($element) {
        $element   = $element || this.$element

        var el     = $element[0]
        var isBody = el.tagName == 'BODY'

        var elRect    = el.getBoundingClientRect()
        if (elRect.width == null) {
            // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
            elRect = $.extend({}, elRect, {width: elRect.right - elRect.left, height: elRect.bottom - elRect.top})
        }
        var elOffset  = isBody ? {top: 0, left: 0} : $element.offset()
        var scroll    = {scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop()}
        var outerDims = isBody ? {width: $(window).width(), height: $(window).height()} : null

        return $.extend({}, elRect, scroll, outerDims, elOffset)
    }

    Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
        return placement == 'bottom' ? {top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2} :
               placement == 'top'    ? {top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2} :
               placement == 'left'   ? {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth} :
            /* placement == 'right' */ {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width}

    }

    Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
        var delta = {top: 0, left: 0}
        if (!this.$viewport) return delta

        var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
        var viewportDimensions = this.getPosition(this.$viewport)

        if (/right|left/.test(placement)) {
            var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
            var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
            if (topEdgeOffset < viewportDimensions.top) { // top overflow
                delta.top = viewportDimensions.top - topEdgeOffset
            } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
                delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
            }
        } else {
            var leftEdgeOffset  = pos.left - viewportPadding
            var rightEdgeOffset = pos.left + viewportPadding + actualWidth
            if (leftEdgeOffset < viewportDimensions.left) { // left overflow
                delta.left = viewportDimensions.left - leftEdgeOffset
            } else if (rightEdgeOffset > viewportDimensions.width) { // right overflow
                delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
            }
        }

        return delta
    }

    Tooltip.prototype.getTitle = function () {
        var title
        var $e = this.$element
        var o  = this.options

        title = $e.attr('data-original-title')
          || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

        return title
    }

    Tooltip.prototype.getUID = function (prefix) {
        do prefix += ~~(Math.random() * 1000000)
        while (document.getElementById(prefix))
        return prefix
    }

    Tooltip.prototype.tip = function () {
        return (this.$tip = this.$tip || $(this.options.template))
    }

    Tooltip.prototype.arrow = function () {
        return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
    }

    Tooltip.prototype.enable = function () {
        this.enabled = true
    }

    Tooltip.prototype.disable = function () {
        this.enabled = false
    }

    Tooltip.prototype.toggleEnabled = function () {
        this.enabled = !this.enabled
    }

    Tooltip.prototype.toggle = function (e) {
        var self = this
        if (e) {
            self = $(e.currentTarget).data('bs.' + this.type)
            if (!self) {
                self = new this.constructor(e.currentTarget, this.getDelegateOptions())
                $(e.currentTarget).data('bs.' + this.type, self)
            }
        }

        self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }

    Tooltip.prototype.destroy = function () {
        var that = this
        clearTimeout(this.timeout)
        this.hide(function () {
            that.$element.off('.' + that.type).removeData('bs.' + that.type)
        })
    }

    // TOOLTIP PLUGIN DEFINITION
    // =========================

    function Plugin(option) {
        return this.each(function () {
            var $this    = $(this)
            var data     = $this.data('bs.tooltip')
            var options  = typeof option == 'object' && option
            var selector = options && options.selector

            if (!data && option == 'destroy') return
            if (selector) {
                if (!data) $this.data('bs.tooltip', (data = {}))
                if (!data[selector]) data[selector] = new Tooltip(this, options)
            } else {
                if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
            }
            if (typeof option == 'string') data[option]()
        })
    }

    var old = $.fn.tooltip

    $.fn.tooltip             = Plugin
    $.fn.tooltip.Constructor = Tooltip

    // TOOLTIP NO CONFLICT
    // ===================

    $.fn.tooltip.noConflict = function () {
        $.fn.tooltip = old;
        return this
    }

}(jQuery);

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/plugins/tooltip.js","/plugins")
},{"buffer":114,"r7L21G":116}],113:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

;(function (exports) {
	'use strict';

  var Arr = (typeof Uint8Array !== 'undefined')
    ? Uint8Array
    : Array

	var PLUS   = '+'.charCodeAt(0)
	var SLASH  = '/'.charCodeAt(0)
	var NUMBER = '0'.charCodeAt(0)
	var LOWER  = 'a'.charCodeAt(0)
	var UPPER  = 'A'.charCodeAt(0)
	var PLUS_URL_SAFE = '-'.charCodeAt(0)
	var SLASH_URL_SAFE = '_'.charCodeAt(0)

	function decode (elt) {
		var code = elt.charCodeAt(0)
		if (code === PLUS ||
		    code === PLUS_URL_SAFE)
			return 62 // '+'
		if (code === SLASH ||
		    code === SLASH_URL_SAFE)
			return 63 // '/'
		if (code < NUMBER)
			return -1 //no match
		if (code < NUMBER + 10)
			return code - NUMBER + 26 + 26
		if (code < UPPER + 26)
			return code - UPPER
		if (code < LOWER + 26)
			return code - LOWER + 26
	}

	function b64ToByteArray (b64) {
		var i, j, l, tmp, placeHolders, arr

		if (b64.length % 4 > 0) {
			throw new Error('Invalid string. Length must be a multiple of 4')
		}

		// the number of equal signs (place holders)
		// if there are two placeholders, than the two characters before it
		// represent one byte
		// if there is only one, then the three characters before it represent 2 bytes
		// this is just a cheap hack to not do indexOf twice
		var len = b64.length
		placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0

		// base64 is 4/3 + up to two characters of the original data
		arr = new Arr(b64.length * 3 / 4 - placeHolders)

		// if there are placeholders, only get up to the last complete 4 chars
		l = placeHolders > 0 ? b64.length - 4 : b64.length

		var L = 0

		function push (v) {
			arr[L++] = v
		}

		for (i = 0, j = 0; i < l; i += 4, j += 3) {
			tmp = (decode(b64.charAt(i)) << 18) | (decode(b64.charAt(i + 1)) << 12) | (decode(b64.charAt(i + 2)) << 6) | decode(b64.charAt(i + 3))
			push((tmp & 0xFF0000) >> 16)
			push((tmp & 0xFF00) >> 8)
			push(tmp & 0xFF)
		}

		if (placeHolders === 2) {
			tmp = (decode(b64.charAt(i)) << 2) | (decode(b64.charAt(i + 1)) >> 4)
			push(tmp & 0xFF)
		} else if (placeHolders === 1) {
			tmp = (decode(b64.charAt(i)) << 10) | (decode(b64.charAt(i + 1)) << 4) | (decode(b64.charAt(i + 2)) >> 2)
			push((tmp >> 8) & 0xFF)
			push(tmp & 0xFF)
		}

		return arr
	}

	function uint8ToBase64 (uint8) {
		var i,
			extraBytes = uint8.length % 3, // if we have 1 byte left, pad 2 bytes
			output = "",
			temp, length

		function encode (num) {
			return lookup.charAt(num)
		}

		function tripletToBase64 (num) {
			return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F)
		}

		// go through the array every three bytes, we'll deal with trailing stuff later
		for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
			temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
			output += tripletToBase64(temp)
		}

		// pad the end with zeros, but make sure to not forget the extra bytes
		switch (extraBytes) {
			case 1:
				temp = uint8[uint8.length - 1]
				output += encode(temp >> 2)
				output += encode((temp << 4) & 0x3F)
				output += '=='
				break
			case 2:
				temp = (uint8[uint8.length - 2] << 8) + (uint8[uint8.length - 1])
				output += encode(temp >> 10)
				output += encode((temp >> 4) & 0x3F)
				output += encode((temp << 2) & 0x3F)
				output += '='
				break
		}

		return output
	}

	exports.toByteArray = b64ToByteArray
	exports.fromByteArray = uint8ToBase64
}(typeof exports === 'undefined' ? (this.base64js = {}) : exports))

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../../../../node_modules/base64-js/lib/b64.js","/../../../../node_modules/base64-js/lib")
},{"buffer":114,"r7L21G":116}],114:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

var base64 = require('base64-js')
var ieee754 = require('ieee754')

exports.Buffer = Buffer
exports.SlowBuffer = Buffer
exports.INSPECT_MAX_BYTES = 50
Buffer.poolSize = 8192

/**
 * If `Buffer._useTypedArrays`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (compatible down to IE6)
 */
Buffer._useTypedArrays = (function () {
  // Detect if browser supports Typed Arrays. Supported browsers are IE 10+, Firefox 4+,
  // Chrome 7+, Safari 5.1+, Opera 11.6+, iOS 4.2+. If the browser does not support adding
  // properties to `Uint8Array` instances, then that's the same as no `Uint8Array` support
  // because we need to be able to add all the node Buffer API methods. This is an issue
  // in Firefox 4-29. Now fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=695438
  try {
    var buf = new ArrayBuffer(0)
    var arr = new Uint8Array(buf)
    arr.foo = function () { return 42 }
    return 42 === arr.foo() &&
        typeof arr.subarray === 'function' // Chrome 9-10 lack `subarray`
  } catch (e) {
    return false
  }
})()

/**
 * Class: Buffer
 * =============
 *
 * The Buffer constructor returns instances of `Uint8Array` that are augmented
 * with function properties for all the node `Buffer` API functions. We use
 * `Uint8Array` so that square bracket notation works as expected -- it returns
 * a single octet.
 *
 * By augmenting the instances, we can avoid modifying the `Uint8Array`
 * prototype.
 */
function Buffer (subject, encoding, noZero) {
  if (!(this instanceof Buffer))
    return new Buffer(subject, encoding, noZero)

  var type = typeof subject

  // Workaround: node's base64 implementation allows for non-padded strings
  // while base64-js does not.
  if (encoding === 'base64' && type === 'string') {
    subject = stringtrim(subject)
    while (subject.length % 4 !== 0) {
      subject = subject + '='
    }
  }

  // Find the length
  var length
  if (type === 'number')
    length = coerce(subject)
  else if (type === 'string')
    length = Buffer.byteLength(subject, encoding)
  else if (type === 'object')
    length = coerce(subject.length) // assume that object is array-like
  else
    throw new Error('First argument needs to be a number, array or string.')

  var buf
  if (Buffer._useTypedArrays) {
    // Preferred: Return an augmented `Uint8Array` instance for best performance
    buf = Buffer._augment(new Uint8Array(length))
  } else {
    // Fallback: Return THIS instance of Buffer (created by `new`)
    buf = this
    buf.length = length
    buf._isBuffer = true
  }

  var i
  if (Buffer._useTypedArrays && typeof subject.byteLength === 'number') {
    // Speed optimization -- use set if we're copying from a typed array
    buf._set(subject)
  } else if (isArrayish(subject)) {
    // Treat array-ish objects as a byte array
    for (i = 0; i < length; i++) {
      if (Buffer.isBuffer(subject))
        buf[i] = subject.readUInt8(i)
      else
        buf[i] = subject[i]
    }
  } else if (type === 'string') {
    buf.write(subject, 0, encoding)
  } else if (type === 'number' && !Buffer._useTypedArrays && !noZero) {
    for (i = 0; i < length; i++) {
      buf[i] = 0
    }
  }

  return buf
}

// STATIC METHODS
// ==============

Buffer.isEncoding = function (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'binary':
    case 'base64':
    case 'raw':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.isBuffer = function (b) {
  return !!(b !== null && b !== undefined && b._isBuffer)
}

Buffer.byteLength = function (str, encoding) {
  var ret
  str = str + ''
  switch (encoding || 'utf8') {
    case 'hex':
      ret = str.length / 2
      break
    case 'utf8':
    case 'utf-8':
      ret = utf8ToBytes(str).length
      break
    case 'ascii':
    case 'binary':
    case 'raw':
      ret = str.length
      break
    case 'base64':
      ret = base64ToBytes(str).length
      break
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      ret = str.length * 2
      break
    default:
      throw new Error('Unknown encoding')
  }
  return ret
}

Buffer.concat = function (list, totalLength) {
  assert(isArray(list), 'Usage: Buffer.concat(list, [totalLength])\n' +
      'list should be an Array.')

  if (list.length === 0) {
    return new Buffer(0)
  } else if (list.length === 1) {
    return list[0]
  }

  var i
  if (typeof totalLength !== 'number') {
    totalLength = 0
    for (i = 0; i < list.length; i++) {
      totalLength += list[i].length
    }
  }

  var buf = new Buffer(totalLength)
  var pos = 0
  for (i = 0; i < list.length; i++) {
    var item = list[i]
    item.copy(buf, pos)
    pos += item.length
  }
  return buf
}

// BUFFER INSTANCE METHODS
// =======================

function _hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  assert(strLen % 2 === 0, 'Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; i++) {
    var byte = parseInt(string.substr(i * 2, 2), 16)
    assert(!isNaN(byte), 'Invalid hex string')
    buf[offset + i] = byte
  }
  Buffer._charsWritten = i * 2
  return i
}

function _utf8Write (buf, string, offset, length) {
  var charsWritten = Buffer._charsWritten =
    blitBuffer(utf8ToBytes(string), buf, offset, length)
  return charsWritten
}

function _asciiWrite (buf, string, offset, length) {
  var charsWritten = Buffer._charsWritten =
    blitBuffer(asciiToBytes(string), buf, offset, length)
  return charsWritten
}

function _binaryWrite (buf, string, offset, length) {
  return _asciiWrite(buf, string, offset, length)
}

function _base64Write (buf, string, offset, length) {
  var charsWritten = Buffer._charsWritten =
    blitBuffer(base64ToBytes(string), buf, offset, length)
  return charsWritten
}

function _utf16leWrite (buf, string, offset, length) {
  var charsWritten = Buffer._charsWritten =
    blitBuffer(utf16leToBytes(string), buf, offset, length)
  return charsWritten
}

Buffer.prototype.write = function (string, offset, length, encoding) {
  // Support both (string, offset, length, encoding)
  // and the legacy (string, encoding, offset, length)
  if (isFinite(offset)) {
    if (!isFinite(length)) {
      encoding = length
      length = undefined
    }
  } else {  // legacy
    var swap = encoding
    encoding = offset
    offset = length
    length = swap
  }

  offset = Number(offset) || 0
  var remaining = this.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }
  encoding = String(encoding || 'utf8').toLowerCase()

  var ret
  switch (encoding) {
    case 'hex':
      ret = _hexWrite(this, string, offset, length)
      break
    case 'utf8':
    case 'utf-8':
      ret = _utf8Write(this, string, offset, length)
      break
    case 'ascii':
      ret = _asciiWrite(this, string, offset, length)
      break
    case 'binary':
      ret = _binaryWrite(this, string, offset, length)
      break
    case 'base64':
      ret = _base64Write(this, string, offset, length)
      break
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      ret = _utf16leWrite(this, string, offset, length)
      break
    default:
      throw new Error('Unknown encoding')
  }
  return ret
}

Buffer.prototype.toString = function (encoding, start, end) {
  var self = this

  encoding = String(encoding || 'utf8').toLowerCase()
  start = Number(start) || 0
  end = (end !== undefined)
    ? Number(end)
    : end = self.length

  // Fastpath empty strings
  if (end === start)
    return ''

  var ret
  switch (encoding) {
    case 'hex':
      ret = _hexSlice(self, start, end)
      break
    case 'utf8':
    case 'utf-8':
      ret = _utf8Slice(self, start, end)
      break
    case 'ascii':
      ret = _asciiSlice(self, start, end)
      break
    case 'binary':
      ret = _binarySlice(self, start, end)
      break
    case 'base64':
      ret = _base64Slice(self, start, end)
      break
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      ret = _utf16leSlice(self, start, end)
      break
    default:
      throw new Error('Unknown encoding')
  }
  return ret
}

Buffer.prototype.toJSON = function () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function (target, target_start, start, end) {
  var source = this

  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (!target_start) target_start = 0

  // Copy 0 bytes; we're done
  if (end === start) return
  if (target.length === 0 || source.length === 0) return

  // Fatal error conditions
  assert(end >= start, 'sourceEnd < sourceStart')
  assert(target_start >= 0 && target_start < target.length,
      'targetStart out of bounds')
  assert(start >= 0 && start < source.length, 'sourceStart out of bounds')
  assert(end >= 0 && end <= source.length, 'sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length)
    end = this.length
  if (target.length - target_start < end - start)
    end = target.length - target_start + start

  var len = end - start

  if (len < 100 || !Buffer._useTypedArrays) {
    for (var i = 0; i < len; i++)
      target[i + target_start] = this[i + start]
  } else {
    target._set(this.subarray(start, start + len), target_start)
  }
}

function _base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function _utf8Slice (buf, start, end) {
  var res = ''
  var tmp = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; i++) {
    if (buf[i] <= 0x7F) {
      res += decodeUtf8Char(tmp) + String.fromCharCode(buf[i])
      tmp = ''
    } else {
      tmp += '%' + buf[i].toString(16)
    }
  }

  return res + decodeUtf8Char(tmp)
}

function _asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; i++)
    ret += String.fromCharCode(buf[i])
  return ret
}

function _binarySlice (buf, start, end) {
  return _asciiSlice(buf, start, end)
}

function _hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; i++) {
    out += toHex(buf[i])
  }
  return out
}

function _utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i+1] * 256)
  }
  return res
}

Buffer.prototype.slice = function (start, end) {
  var len = this.length
  start = clamp(start, len, 0)
  end = clamp(end, len, len)

  if (Buffer._useTypedArrays) {
    return Buffer._augment(this.subarray(start, end))
  } else {
    var sliceLen = end - start
    var newBuf = new Buffer(sliceLen, undefined, true)
    for (var i = 0; i < sliceLen; i++) {
      newBuf[i] = this[i + start]
    }
    return newBuf
  }
}

// `get` will be removed in Node 0.13+
Buffer.prototype.get = function (offset) {
  console.log('.get() is deprecated. Access using array indexes instead.')
  return this.readUInt8(offset)
}

// `set` will be removed in Node 0.13+
Buffer.prototype.set = function (v, offset) {
  console.log('.set() is deprecated. Access using array indexes instead.')
  return this.writeUInt8(v, offset)
}

Buffer.prototype.readUInt8 = function (offset, noAssert) {
  if (!noAssert) {
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset < this.length, 'Trying to read beyond buffer length')
  }

  if (offset >= this.length)
    return

  return this[offset]
}

function _readUInt16 (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 1 < buf.length, 'Trying to read beyond buffer length')
  }

  var len = buf.length
  if (offset >= len)
    return

  var val
  if (littleEndian) {
    val = buf[offset]
    if (offset + 1 < len)
      val |= buf[offset + 1] << 8
  } else {
    val = buf[offset] << 8
    if (offset + 1 < len)
      val |= buf[offset + 1]
  }
  return val
}

Buffer.prototype.readUInt16LE = function (offset, noAssert) {
  return _readUInt16(this, offset, true, noAssert)
}

Buffer.prototype.readUInt16BE = function (offset, noAssert) {
  return _readUInt16(this, offset, false, noAssert)
}

function _readUInt32 (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'Trying to read beyond buffer length')
  }

  var len = buf.length
  if (offset >= len)
    return

  var val
  if (littleEndian) {
    if (offset + 2 < len)
      val = buf[offset + 2] << 16
    if (offset + 1 < len)
      val |= buf[offset + 1] << 8
    val |= buf[offset]
    if (offset + 3 < len)
      val = val + (buf[offset + 3] << 24 >>> 0)
  } else {
    if (offset + 1 < len)
      val = buf[offset + 1] << 16
    if (offset + 2 < len)
      val |= buf[offset + 2] << 8
    if (offset + 3 < len)
      val |= buf[offset + 3]
    val = val + (buf[offset] << 24 >>> 0)
  }
  return val
}

Buffer.prototype.readUInt32LE = function (offset, noAssert) {
  return _readUInt32(this, offset, true, noAssert)
}

Buffer.prototype.readUInt32BE = function (offset, noAssert) {
  return _readUInt32(this, offset, false, noAssert)
}

Buffer.prototype.readInt8 = function (offset, noAssert) {
  if (!noAssert) {
    assert(offset !== undefined && offset !== null,
        'missing offset')
    assert(offset < this.length, 'Trying to read beyond buffer length')
  }

  if (offset >= this.length)
    return

  var neg = this[offset] & 0x80
  if (neg)
    return (0xff - this[offset] + 1) * -1
  else
    return this[offset]
}

function _readInt16 (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 1 < buf.length, 'Trying to read beyond buffer length')
  }

  var len = buf.length
  if (offset >= len)
    return

  var val = _readUInt16(buf, offset, littleEndian, true)
  var neg = val & 0x8000
  if (neg)
    return (0xffff - val + 1) * -1
  else
    return val
}

Buffer.prototype.readInt16LE = function (offset, noAssert) {
  return _readInt16(this, offset, true, noAssert)
}

Buffer.prototype.readInt16BE = function (offset, noAssert) {
  return _readInt16(this, offset, false, noAssert)
}

function _readInt32 (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'Trying to read beyond buffer length')
  }

  var len = buf.length
  if (offset >= len)
    return

  var val = _readUInt32(buf, offset, littleEndian, true)
  var neg = val & 0x80000000
  if (neg)
    return (0xffffffff - val + 1) * -1
  else
    return val
}

Buffer.prototype.readInt32LE = function (offset, noAssert) {
  return _readInt32(this, offset, true, noAssert)
}

Buffer.prototype.readInt32BE = function (offset, noAssert) {
  return _readInt32(this, offset, false, noAssert)
}

function _readFloat (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset + 3 < buf.length, 'Trying to read beyond buffer length')
  }

  return ieee754.read(buf, offset, littleEndian, 23, 4)
}

Buffer.prototype.readFloatLE = function (offset, noAssert) {
  return _readFloat(this, offset, true, noAssert)
}

Buffer.prototype.readFloatBE = function (offset, noAssert) {
  return _readFloat(this, offset, false, noAssert)
}

function _readDouble (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset + 7 < buf.length, 'Trying to read beyond buffer length')
  }

  return ieee754.read(buf, offset, littleEndian, 52, 8)
}

Buffer.prototype.readDoubleLE = function (offset, noAssert) {
  return _readDouble(this, offset, true, noAssert)
}

Buffer.prototype.readDoubleBE = function (offset, noAssert) {
  return _readDouble(this, offset, false, noAssert)
}

Buffer.prototype.writeUInt8 = function (value, offset, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset < this.length, 'trying to write beyond buffer length')
    verifuint(value, 0xff)
  }

  if (offset >= this.length) return

  this[offset] = value
}

function _writeUInt16 (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 1 < buf.length, 'trying to write beyond buffer length')
    verifuint(value, 0xffff)
  }

  var len = buf.length
  if (offset >= len)
    return

  for (var i = 0, j = Math.min(len - offset, 2); i < j; i++) {
    buf[offset + i] =
        (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
            (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function (value, offset, noAssert) {
  _writeUInt16(this, value, offset, true, noAssert)
}

Buffer.prototype.writeUInt16BE = function (value, offset, noAssert) {
  _writeUInt16(this, value, offset, false, noAssert)
}

function _writeUInt32 (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'trying to write beyond buffer length')
    verifuint(value, 0xffffffff)
  }

  var len = buf.length
  if (offset >= len)
    return

  for (var i = 0, j = Math.min(len - offset, 4); i < j; i++) {
    buf[offset + i] =
        (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function (value, offset, noAssert) {
  _writeUInt32(this, value, offset, true, noAssert)
}

Buffer.prototype.writeUInt32BE = function (value, offset, noAssert) {
  _writeUInt32(this, value, offset, false, noAssert)
}

Buffer.prototype.writeInt8 = function (value, offset, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset < this.length, 'Trying to write beyond buffer length')
    verifsint(value, 0x7f, -0x80)
  }

  if (offset >= this.length)
    return

  if (value >= 0)
    this.writeUInt8(value, offset, noAssert)
  else
    this.writeUInt8(0xff + value + 1, offset, noAssert)
}

function _writeInt16 (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 1 < buf.length, 'Trying to write beyond buffer length')
    verifsint(value, 0x7fff, -0x8000)
  }

  var len = buf.length
  if (offset >= len)
    return

  if (value >= 0)
    _writeUInt16(buf, value, offset, littleEndian, noAssert)
  else
    _writeUInt16(buf, 0xffff + value + 1, offset, littleEndian, noAssert)
}

Buffer.prototype.writeInt16LE = function (value, offset, noAssert) {
  _writeInt16(this, value, offset, true, noAssert)
}

Buffer.prototype.writeInt16BE = function (value, offset, noAssert) {
  _writeInt16(this, value, offset, false, noAssert)
}

function _writeInt32 (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'Trying to write beyond buffer length')
    verifsint(value, 0x7fffffff, -0x80000000)
  }

  var len = buf.length
  if (offset >= len)
    return

  if (value >= 0)
    _writeUInt32(buf, value, offset, littleEndian, noAssert)
  else
    _writeUInt32(buf, 0xffffffff + value + 1, offset, littleEndian, noAssert)
}

Buffer.prototype.writeInt32LE = function (value, offset, noAssert) {
  _writeInt32(this, value, offset, true, noAssert)
}

Buffer.prototype.writeInt32BE = function (value, offset, noAssert) {
  _writeInt32(this, value, offset, false, noAssert)
}

function _writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'Trying to write beyond buffer length')
    verifIEEE754(value, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }

  var len = buf.length
  if (offset >= len)
    return

  ieee754.write(buf, value, offset, littleEndian, 23, 4)
}

Buffer.prototype.writeFloatLE = function (value, offset, noAssert) {
  _writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function (value, offset, noAssert) {
  _writeFloat(this, value, offset, false, noAssert)
}

function _writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 7 < buf.length,
        'Trying to write beyond buffer length')
    verifIEEE754(value, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }

  var len = buf.length
  if (offset >= len)
    return

  ieee754.write(buf, value, offset, littleEndian, 52, 8)
}

Buffer.prototype.writeDoubleLE = function (value, offset, noAssert) {
  _writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function (value, offset, noAssert) {
  _writeDouble(this, value, offset, false, noAssert)
}

// fill(value, start=0, end=buffer.length)
Buffer.prototype.fill = function (value, start, end) {
  if (!value) value = 0
  if (!start) start = 0
  if (!end) end = this.length

  if (typeof value === 'string') {
    value = value.charCodeAt(0)
  }

  assert(typeof value === 'number' && !isNaN(value), 'value is not a number')
  assert(end >= start, 'end < start')

  // Fill 0 bytes; we're done
  if (end === start) return
  if (this.length === 0) return

  assert(start >= 0 && start < this.length, 'start out of bounds')
  assert(end >= 0 && end <= this.length, 'end out of bounds')

  for (var i = start; i < end; i++) {
    this[i] = value
  }
}

Buffer.prototype.inspect = function () {
  var out = []
  var len = this.length
  for (var i = 0; i < len; i++) {
    out[i] = toHex(this[i])
    if (i === exports.INSPECT_MAX_BYTES) {
      out[i + 1] = '...'
      break
    }
  }
  return '<Buffer ' + out.join(' ') + '>'
}

/**
 * Creates a new `ArrayBuffer` with the *copied* memory of the buffer instance.
 * Added in Node 0.12. Only available in browsers that support ArrayBuffer.
 */
Buffer.prototype.toArrayBuffer = function () {
  if (typeof Uint8Array !== 'undefined') {
    if (Buffer._useTypedArrays) {
      return (new Buffer(this)).buffer
    } else {
      var buf = new Uint8Array(this.length)
      for (var i = 0, len = buf.length; i < len; i += 1)
        buf[i] = this[i]
      return buf.buffer
    }
  } else {
    throw new Error('Buffer.toArrayBuffer not supported in this browser')
  }
}

// HELPER FUNCTIONS
// ================

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

var BP = Buffer.prototype

/**
 * Augment a Uint8Array *instance* (not the Uint8Array class!) with Buffer methods
 */
Buffer._augment = function (arr) {
  arr._isBuffer = true

  // save reference to original Uint8Array get/set methods before overwriting
  arr._get = arr.get
  arr._set = arr.set

  // deprecated, will be removed in node 0.13+
  arr.get = BP.get
  arr.set = BP.set

  arr.write = BP.write
  arr.toString = BP.toString
  arr.toLocaleString = BP.toString
  arr.toJSON = BP.toJSON
  arr.copy = BP.copy
  arr.slice = BP.slice
  arr.readUInt8 = BP.readUInt8
  arr.readUInt16LE = BP.readUInt16LE
  arr.readUInt16BE = BP.readUInt16BE
  arr.readUInt32LE = BP.readUInt32LE
  arr.readUInt32BE = BP.readUInt32BE
  arr.readInt8 = BP.readInt8
  arr.readInt16LE = BP.readInt16LE
  arr.readInt16BE = BP.readInt16BE
  arr.readInt32LE = BP.readInt32LE
  arr.readInt32BE = BP.readInt32BE
  arr.readFloatLE = BP.readFloatLE
  arr.readFloatBE = BP.readFloatBE
  arr.readDoubleLE = BP.readDoubleLE
  arr.readDoubleBE = BP.readDoubleBE
  arr.writeUInt8 = BP.writeUInt8
  arr.writeUInt16LE = BP.writeUInt16LE
  arr.writeUInt16BE = BP.writeUInt16BE
  arr.writeUInt32LE = BP.writeUInt32LE
  arr.writeUInt32BE = BP.writeUInt32BE
  arr.writeInt8 = BP.writeInt8
  arr.writeInt16LE = BP.writeInt16LE
  arr.writeInt16BE = BP.writeInt16BE
  arr.writeInt32LE = BP.writeInt32LE
  arr.writeInt32BE = BP.writeInt32BE
  arr.writeFloatLE = BP.writeFloatLE
  arr.writeFloatBE = BP.writeFloatBE
  arr.writeDoubleLE = BP.writeDoubleLE
  arr.writeDoubleBE = BP.writeDoubleBE
  arr.fill = BP.fill
  arr.inspect = BP.inspect
  arr.toArrayBuffer = BP.toArrayBuffer

  return arr
}

// slice(start, end)
function clamp (index, len, defaultValue) {
  if (typeof index !== 'number') return defaultValue
  index = ~~index;  // Coerce to integer.
  if (index >= len) return len
  if (index >= 0) return index
  index += len
  if (index >= 0) return index
  return 0
}

function coerce (length) {
  // Coerce length to a number (possibly NaN), round up
  // in case it's fractional (e.g. 123.456) then do a
  // double negate to coerce a NaN to 0. Easy, right?
  length = ~~Math.ceil(+length)
  return length < 0 ? 0 : length
}

function isArray (subject) {
  return (Array.isArray || function (subject) {
    return Object.prototype.toString.call(subject) === '[object Array]'
  })(subject)
}

function isArrayish (subject) {
  return isArray(subject) || Buffer.isBuffer(subject) ||
      subject && typeof subject === 'object' &&
      typeof subject.length === 'number'
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    var b = str.charCodeAt(i)
    if (b <= 0x7F)
      byteArray.push(str.charCodeAt(i))
    else {
      var start = i
      if (b >= 0xD800 && b <= 0xDFFF) i++
      var h = encodeURIComponent(str.slice(start, i+1)).substr(1).split('%')
      for (var j = 0; j < h.length; j++)
        byteArray.push(parseInt(h[j], 16))
    }
  }
  return byteArray
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(str)
}

function blitBuffer (src, dst, offset, length) {
  var pos
  for (var i = 0; i < length; i++) {
    if ((i + offset >= dst.length) || (i >= src.length))
      break
    dst[i + offset] = src[i]
  }
  return i
}

function decodeUtf8Char (str) {
  try {
    return decodeURIComponent(str)
  } catch (err) {
    return String.fromCharCode(0xFFFD) // UTF 8 invalid char
  }
}

/*
 * We have to make sure that the value is a valid integer. This means that it
 * is non-negative. It has no fractional component and that it does not
 * exceed the maximum allowed value.
 */
function verifuint (value, max) {
  assert(typeof value === 'number', 'cannot write a non-number as a number')
  assert(value >= 0, 'specified a negative value for writing an unsigned value')
  assert(value <= max, 'value is larger than maximum value for type')
  assert(Math.floor(value) === value, 'value has a fractional component')
}

function verifsint (value, max, min) {
  assert(typeof value === 'number', 'cannot write a non-number as a number')
  assert(value <= max, 'value larger than maximum allowed value')
  assert(value >= min, 'value smaller than minimum allowed value')
  assert(Math.floor(value) === value, 'value has a fractional component')
}

function verifIEEE754 (value, max, min) {
  assert(typeof value === 'number', 'cannot write a non-number as a number')
  assert(value <= max, 'value larger than maximum allowed value')
  assert(value >= min, 'value smaller than minimum allowed value')
}

function assert (test, message) {
  if (!test) throw new Error(message || 'Failed assertion')
}

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../../../../node_modules/buffer/index.js","/../../../../node_modules/buffer")
},{"base64-js":113,"buffer":114,"ieee754":115,"r7L21G":116}],115:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../../../../node_modules/ieee754/index.js","/../../../../node_modules/ieee754")
},{"buffer":114,"r7L21G":116}],116:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// shim for using process in browser

var process = module.exports = {};

process.nextTick = (function () {
    var canSetImmediate = typeof window !== 'undefined'
    && window.setImmediate;
    var canPost = typeof window !== 'undefined'
    && window.postMessage && window.addEventListener
    ;

    if (canSetImmediate) {
        return function (f) { return window.setImmediate(f) };
    }

    if (canPost) {
        var queue = [];
        window.addEventListener('message', function (ev) {
            var source = ev.source;
            if ((source === window || source === null) && ev.data === 'process-tick') {
                ev.stopPropagation();
                if (queue.length > 0) {
                    var fn = queue.shift();
                    fn();
                }
            }
        }, true);

        return function nextTick(fn) {
            queue.push(fn);
            window.postMessage('process-tick', '*');
        };
    }

    return function nextTick(fn) {
        setTimeout(fn, 0);
    };
})();

process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
}

// TODO(shtylman)
process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};

}).call(this,require("r7L21G"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../../../../node_modules/process/browser.js","/../../../../node_modules/process")
},{"buffer":114,"r7L21G":116}]},{},[62])